
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire06f1"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire06f1"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
'use strict';

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $1c29a66706a62afd$export$3ba232387fd5d6dd, (v) => $1c29a66706a62afd$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$3ba232387fd5d6dd;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
function $1c29a66706a62afd$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$3ba232387fd5d6dd = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = $1c29a66706a62afd$var$X;
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$Lg(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$Sg(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Tg(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Ug = $0b2e6adb871a3b94$var$Og(!0), $0b2e6adb871a3b94$var$Vg = $0b2e6adb871a3b94$var$Og(!1), $0b2e6adb871a3b94$var$Wg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Xg = null, $0b2e6adb871a3b94$var$Yg = null, $0b2e6adb871a3b94$var$Zg = null;
function $0b2e6adb871a3b94$var$$g() {
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Xg = null;
}
function $0b2e6adb871a3b94$var$ah(a) {
    var b = $0b2e6adb871a3b94$var$Wg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    $0b2e6adb871a3b94$var$Xg = a;
    $0b2e6adb871a3b94$var$Zg = $0b2e6adb871a3b94$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$dh = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$eh(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Yg) {
            if (null === $0b2e6adb871a3b94$var$Xg) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Yg = a;
            $0b2e6adb871a3b94$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Yg = $0b2e6adb871a3b94$var$Yg.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$fh = null;
function $0b2e6adb871a3b94$var$gh(a) {
    null === $0b2e6adb871a3b94$var$fh ? $0b2e6adb871a3b94$var$fh = [
        a
    ] : $0b2e6adb871a3b94$var$fh.push(a);
}
function $0b2e6adb871a3b94$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$ih(a, d);
}
function $0b2e6adb871a3b94$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$jh = !1;
function $0b2e6adb871a3b94$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$ih(a, c);
}
function $0b2e6adb871a3b94$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$th = {}, $0b2e6adb871a3b94$var$uh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$vh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th), $0b2e6adb871a3b94$var$wh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$th);
function $0b2e6adb871a3b94$var$xh(a) {
    if (a === $0b2e6adb871a3b94$var$th) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$yh(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$wh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, $0b2e6adb871a3b94$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, b);
}
function $0b2e6adb871a3b94$var$zh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$wh);
}
function $0b2e6adb871a3b94$var$Ah(a) {
    $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
    var b = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$vh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$uh, c));
}
function $0b2e6adb871a3b94$var$Bh(a) {
    $0b2e6adb871a3b94$var$vh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$uh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$vh));
}
var $0b2e6adb871a3b94$var$L = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Dh = [];
function $0b2e6adb871a3b94$var$Eh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Dh.length; a++)$0b2e6adb871a3b94$var$Dh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Dh.length = 0;
}
var $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Hh = 0, $0b2e6adb871a3b94$var$M = null, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$Ih = !1, $0b2e6adb871a3b94$var$Jh = !1, $0b2e6adb871a3b94$var$Kh = 0, $0b2e6adb871a3b94$var$Lh = 0;
function $0b2e6adb871a3b94$var$P() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Nh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Hh = f;
    $0b2e6adb871a3b94$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Fh.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Oh : $0b2e6adb871a3b94$var$Ph;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Jh) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Qh;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Jh);
    }
    $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
    b = null !== $0b2e6adb871a3b94$var$N && null !== $0b2e6adb871a3b94$var$N.next;
    $0b2e6adb871a3b94$var$Hh = 0;
    $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
    $0b2e6adb871a3b94$var$Ih = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$Sh() {
    var a = 0 !== $0b2e6adb871a3b94$var$Kh;
    $0b2e6adb871a3b94$var$Kh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Uh() {
    if (null === $0b2e6adb871a3b94$var$N) {
        var a = $0b2e6adb871a3b94$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$N.next;
    var b = null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState : $0b2e6adb871a3b94$var$O.next;
    if (null !== b) $0b2e6adb871a3b94$var$O = b, $0b2e6adb871a3b94$var$N = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$N = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$N.memoizedState,
            baseState: $0b2e6adb871a3b94$var$N.baseState,
            baseQueue: $0b2e6adb871a3b94$var$N.baseQueue,
            queue: $0b2e6adb871a3b94$var$N.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$O ? $0b2e6adb871a3b94$var$M.memoizedState = $0b2e6adb871a3b94$var$O = a : $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$O.next = a;
    }
    return $0b2e6adb871a3b94$var$O;
}
function $0b2e6adb871a3b94$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$Wh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$M.lanes |= m;
                $0b2e6adb871a3b94$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$M.lanes |= f, $0b2e6adb871a3b94$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$Xh(a) {
    var b = $0b2e6adb871a3b94$var$Uh(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$Yh() {}
function $0b2e6adb871a3b94$var$Zh(a, b) {
    var c = $0b2e6adb871a3b94$var$M, d = $0b2e6adb871a3b94$var$Uh(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$dh = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$$h($0b2e6adb871a3b94$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$O && $0b2e6adb871a3b94$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
}
function $0b2e6adb871a3b94$var$ai(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$ei(b) && $0b2e6adb871a3b94$var$fi(a);
    });
}
function $0b2e6adb871a3b94$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$ih(a, 1);
    null !== b && $0b2e6adb871a3b94$var$gi(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$hi(a) {
    var b = $0b2e6adb871a3b94$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ii.bind(null, $0b2e6adb871a3b94$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$ji() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$ki(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Th();
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$N) {
        var g = $0b2e6adb871a3b94$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Mh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$bi(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$M.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$bi(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$mi(a, b) {
    return $0b2e6adb871a3b94$var$ki(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$$h(a, b) {
    return $0b2e6adb871a3b94$var$li(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$ni(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$oi(a, b) {
    return $0b2e6adb871a3b94$var$li(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$li(4, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$ri() {}
function $0b2e6adb871a3b94$var$si(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ti(a, b) {
    var c = $0b2e6adb871a3b94$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$ui(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Hh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$dh = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$M.lanes |= c, $0b2e6adb871a3b94$var$rh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Gh.transition;
    $0b2e6adb871a3b94$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Gh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$wi() {
    return $0b2e6adb871a3b94$var$Uh().memoizedState;
}
function $0b2e6adb871a3b94$var$xi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, c);
    else if (c = $0b2e6adb871a3b94$var$hh(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$R();
        $0b2e6adb871a3b94$var$gi(c, a, d, e);
        $0b2e6adb871a3b94$var$Bi(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ii(a, b, c) {
    var d = $0b2e6adb871a3b94$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$zi(a)) $0b2e6adb871a3b94$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$hh(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$R(), $0b2e6adb871a3b94$var$gi(c, a, d, e), $0b2e6adb871a3b94$var$Bi(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$zi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$M || null !== b && b === $0b2e6adb871a3b94$var$M;
}
function $0b2e6adb871a3b94$var$Ai(a, b) {
    $0b2e6adb871a3b94$var$Jh = $0b2e6adb871a3b94$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$Rh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$P,
    useContext: $0b2e6adb871a3b94$var$P,
    useEffect: $0b2e6adb871a3b94$var$P,
    useImperativeHandle: $0b2e6adb871a3b94$var$P,
    useInsertionEffect: $0b2e6adb871a3b94$var$P,
    useLayoutEffect: $0b2e6adb871a3b94$var$P,
    useMemo: $0b2e6adb871a3b94$var$P,
    useReducer: $0b2e6adb871a3b94$var$P,
    useRef: $0b2e6adb871a3b94$var$P,
    useState: $0b2e6adb871a3b94$var$P,
    useDebugValue: $0b2e6adb871a3b94$var$P,
    useDeferredValue: $0b2e6adb871a3b94$var$P,
    useTransition: $0b2e6adb871a3b94$var$P,
    useMutableSource: $0b2e6adb871a3b94$var$P,
    useSyncExternalStore: $0b2e6adb871a3b94$var$P,
    useId: $0b2e6adb871a3b94$var$P,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Oh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ki(4194308, 4, $0b2e6adb871a3b94$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$xi.bind(null, $0b2e6adb871a3b94$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$hi,
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$hi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$vi.bind(null, a[1]);
        $0b2e6adb871a3b94$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$M, e = $0b2e6adb871a3b94$var$Th();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$Q) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Hh & 30) || $0b2e6adb871a3b94$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$mi($0b2e6adb871a3b94$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$bi(9, $0b2e6adb871a3b94$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$Th(), b = $0b2e6adb871a3b94$var$Q.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Ph = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Wh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Wh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Qh = {
    readContext: $0b2e6adb871a3b94$var$eh,
    useCallback: $0b2e6adb871a3b94$var$si,
    useContext: $0b2e6adb871a3b94$var$eh,
    useEffect: $0b2e6adb871a3b94$var$$h,
    useImperativeHandle: $0b2e6adb871a3b94$var$qi,
    useInsertionEffect: $0b2e6adb871a3b94$var$ni,
    useLayoutEffect: $0b2e6adb871a3b94$var$oi,
    useMemo: $0b2e6adb871a3b94$var$ti,
    useReducer: $0b2e6adb871a3b94$var$Xh,
    useRef: $0b2e6adb871a3b94$var$ji,
    useState: function() {
        return $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh);
    },
    useDebugValue: $0b2e6adb871a3b94$var$ri,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$Uh();
        return null === $0b2e6adb871a3b94$var$N ? b.memoizedState = a : $0b2e6adb871a3b94$var$ui(b, $0b2e6adb871a3b94$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$Xh($0b2e6adb871a3b94$var$Vh)[0], b = $0b2e6adb871a3b94$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$Yh,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Zh,
    useId: $0b2e6adb871a3b94$var$wi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $0b2e6adb871a3b94$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$R(), e = $0b2e6adb871a3b94$var$yi(a), f = $0b2e6adb871a3b94$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$nh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, e, d), $0b2e6adb871a3b94$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$R(), d = $0b2e6adb871a3b94$var$yi(a), e = $0b2e6adb871a3b94$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$nh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$gi(b, a, d, c), $0b2e6adb871a3b94$var$oh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$eh(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $0b2e6adb871a3b94$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$eh(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$Ei.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Ni(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Oi || ($0b2e6adb871a3b94$var$Oi = !0, $0b2e6adb871a3b94$var$Pi = d);
        $0b2e6adb871a3b94$var$Li(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Qi(a, b, c) {
    c = $0b2e6adb871a3b94$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Li(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Ri ? $0b2e6adb871a3b94$var$Ri = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$mh(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Wi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$dh = !1;
function $0b2e6adb871a3b94$var$Xi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Vg(b, null, c, d) : $0b2e6adb871a3b94$var$Ug(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$ch(b, e);
    d = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$bj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$dh = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$Zi(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$cj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj);
            $0b2e6adb871a3b94$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$ej, $0b2e6adb871a3b94$var$fj), $0b2e6adb871a3b94$var$fj |= d;
    $0b2e6adb871a3b94$var$Xi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$ch(b, e);
    c = $0b2e6adb871a3b94$var$Nh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$Sh();
    if (null !== a && !$0b2e6adb871a3b94$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$Zi(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Xi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$ch(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$ij(a, b), $0b2e6adb871a3b94$var$Gi(b, c, d), $0b2e6adb871a3b94$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$eh(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$Hi(b, g, d, l);
        $0b2e6adb871a3b94$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof m && ($0b2e6adb871a3b94$var$Di(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$eh(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$Hi(b, g, d, k);
        $0b2e6adb871a3b94$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$jh ? ("function" === typeof y && ($0b2e6adb871a3b94$var$Di(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$jh || $0b2e6adb871a3b94$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$jj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$jj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$Zi(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Ug(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Ug(b, null, h, f)) : $0b2e6adb871a3b94$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$yh(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$lj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Xi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$oj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$pj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$nj(c), b.memoizedState = $0b2e6adb871a3b94$var$mj, a) : $0b2e6adb871a3b94$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$Pg(h, f) : (f = $0b2e6adb871a3b94$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$qj(a, b) {
    b = $0b2e6adb871a3b94$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Ug(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$nj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Ki(f, d, void 0);
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$dh || h) {
        d = $0b2e6adb871a3b94$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$ih(a, e), $0b2e6adb871a3b94$var$gi(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$tj();
        d = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$bh(a.return, b, c);
}
function $0b2e6adb871a3b94$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Xi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$kj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Ah(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$oj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
                a = $0b2e6adb871a3b94$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    return $0b2e6adb871a3b94$var$Zi(a, b, c);
}
var $0b2e6adb871a3b94$var$zj, $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj;
$0b2e6adb871a3b94$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Aj = function() {};
$0b2e6adb871a3b94$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Dj(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$zh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Aj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Bh(b);
            var e = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$wh.current);
                $0b2e6adb871a3b94$var$xh($0b2e6adb871a3b94$var$uh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Fj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$L.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$Aj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Dj(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, $0b2e6adb871a3b94$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Gj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$L.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$L, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$fj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Ij(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$zh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Bh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L), null;
        case 4:
            return $0b2e6adb871a3b94$var$zh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Jj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Nj = !1;
function $0b2e6adb871a3b94$var$Oj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Nj;
    $0b2e6adb871a3b94$var$Nj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Vj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Xj = !1;
function $0b2e6adb871a3b94$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$Zj(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Lj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Xj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Xj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Xj = !0;
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Mj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Yj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Yj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Yj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Kj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Xj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$Zj(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$dk(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Pj(3, a, a.return), $0b2e6adb871a3b94$var$Qj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Pj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$fk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$ck(b, a);
            $0b2e6adb871a3b94$var$ek(a);
            d & 4 && $0b2e6adb871a3b94$var$ak(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$ck(b, a), $0b2e6adb871a3b94$var$ek(a);
    }
}
function $0b2e6adb871a3b94$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Uj(a);
                    $0b2e6adb871a3b94$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$hk(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$ik(a, b, c);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Jj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Jj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$jk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$jk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$ik(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Jj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$kk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Rj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$gk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$jk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Qj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$lk = Math.ceil, $0b2e6adb871a3b94$var$mk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$fj = 0, $0b2e6adb871a3b94$var$ej = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$pk = null, $0b2e6adb871a3b94$var$rh = 0, $0b2e6adb871a3b94$var$qk = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = null, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$fk = 0, $0b2e6adb871a3b94$var$Gj = Infinity, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Oi = !1, $0b2e6adb871a3b94$var$Pi = null, $0b2e6adb871a3b94$var$Ri = null, $0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = null, $0b2e6adb871a3b94$var$xk = 0, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, $0b2e6adb871a3b94$var$Ak = -1, $0b2e6adb871a3b94$var$Bk = 0;
function $0b2e6adb871a3b94$var$R() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$Ak : $0b2e6adb871a3b94$var$Ak = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Bk && ($0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Bk;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$gi(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$yk) throw $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$Q) a === $0b2e6adb871a3b94$var$Q && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$qk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Ck(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Dk(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Ek.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Ek.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Fk(c, $0b2e6adb871a3b94$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Gk(a, b) {
    $0b2e6adb871a3b94$var$Ak = -1;
    $0b2e6adb871a3b94$var$Bk = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Hk() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$Q ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Ik(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Jk();
        if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Kk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Lk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Mk(a, h);
        }
        $0b2e6adb871a3b94$var$$g();
        $0b2e6adb871a3b94$var$mk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Nk(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Ok(e) && (b = $0b2e6adb871a3b94$var$Ik(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Nk(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, d), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$fk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Pk.bind(null, a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Gk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    var c = $0b2e6adb871a3b94$var$sk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Kk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Ik(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$tk = c, null !== b && $0b2e6adb871a3b94$var$Fj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Fj(a) {
    null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = a : $0b2e6adb871a3b94$var$tk.push.apply($0b2e6adb871a3b94$var$tk, a);
}
function $0b2e6adb871a3b94$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Ck(a, b) {
    b &= ~$0b2e6adb871a3b94$var$rk;
    b &= ~$0b2e6adb871a3b94$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Ek(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Nk(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$pk, $0b2e6adb871a3b94$var$Kk(a, 0), $0b2e6adb871a3b94$var$Ck(a, b), $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Pk(a, $0b2e6adb871a3b94$var$tk, $0b2e6adb871a3b94$var$uk);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Qk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Rk(a) {
    null !== $0b2e6adb871a3b94$var$wk && 0 === $0b2e6adb871a3b94$var$wk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Hk();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$ok.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$ok.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Hj() {
    $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$ej.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$ej);
}
function $0b2e6adb871a3b94$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$zh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Eh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Bh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$zh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$L);
                break;
            case 10:
                $0b2e6adb871a3b94$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Hj();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$Q = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$Pg(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$fj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$pk = null;
    $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$qk = $0b2e6adb871a3b94$var$rh = 0;
    $0b2e6adb871a3b94$var$tk = $0b2e6adb871a3b94$var$sk = null;
    if (null !== $0b2e6adb871a3b94$var$fh) {
        for(b = 0; b < $0b2e6adb871a3b94$var$fh.length; b++)if (c = $0b2e6adb871a3b94$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$fh = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$$g();
            $0b2e6adb871a3b94$var$Fh.current = $0b2e6adb871a3b94$var$Rh;
            if ($0b2e6adb871a3b94$var$Ih) {
                for(var d = $0b2e6adb871a3b94$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Ih = !1;
            }
            $0b2e6adb871a3b94$var$Hh = 0;
            $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = $0b2e6adb871a3b94$var$M = null;
            $0b2e6adb871a3b94$var$Jh = !1;
            $0b2e6adb871a3b94$var$Kh = 0;
            $0b2e6adb871a3b94$var$nk.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$pk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Si(f, l, b);
                            $0b2e6adb871a3b94$var$tj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Vi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ji(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$sk ? $0b2e6adb871a3b94$var$sk = [
                    f
                ] : $0b2e6adb871a3b94$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Ni(f, k, b);
                            $0b2e6adb871a3b94$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Qi(f, h, b);
                                $0b2e6adb871a3b94$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Sk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Jk() {
    var a = $0b2e6adb871a3b94$var$mk.current;
    $0b2e6adb871a3b94$var$mk.current = $0b2e6adb871a3b94$var$Rh;
    return null === a ? $0b2e6adb871a3b94$var$Rh : a;
}
function $0b2e6adb871a3b94$var$tj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$Q || 0 === ($0b2e6adb871a3b94$var$rh & 268435455) && 0 === ($0b2e6adb871a3b94$var$qk & 268435455) || $0b2e6adb871a3b94$var$Ck($0b2e6adb871a3b94$var$Q, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Ik(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Jk();
    if ($0b2e6adb871a3b94$var$Q !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$Kk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Tk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Mk(a, e);
    }
    $0b2e6adb871a3b94$var$$g();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$mk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$Q = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Tk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Lk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Uk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Uk(a) {
    var b = $0b2e6adb871a3b94$var$Vk(a.alternate, a, $0b2e6adb871a3b94$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Sk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$nk.current = null;
}
function $0b2e6adb871a3b94$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Ej(c, b, $0b2e6adb871a3b94$var$fj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Pk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$ok.transition;
    try {
        $0b2e6adb871a3b94$var$ok.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Wk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$ok.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Wk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Hk();
    while (null !== $0b2e6adb871a3b94$var$wk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$Q && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$Q = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$vk || ($0b2e6adb871a3b94$var$vk = !0, $0b2e6adb871a3b94$var$Fk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$ok.transition;
        $0b2e6adb871a3b94$var$ok.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$nk.current = null;
        $0b2e6adb871a3b94$var$Oj(a, c);
        $0b2e6adb871a3b94$var$dk(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$hk(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$ok.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$vk && ($0b2e6adb871a3b94$var$vk = !1, $0b2e6adb871a3b94$var$wk = a, $0b2e6adb871a3b94$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Ri = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Oi) throw $0b2e6adb871a3b94$var$Oi = !1, a = $0b2e6adb871a3b94$var$Pi, $0b2e6adb871a3b94$var$Pi = null, a;
    0 !== ($0b2e6adb871a3b94$var$xk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$zk ? $0b2e6adb871a3b94$var$yk++ : ($0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = a) : $0b2e6adb871a3b94$var$yk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Hk() {
    if (null !== $0b2e6adb871a3b94$var$wk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$xk), b = $0b2e6adb871a3b94$var$ok.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$ok.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$wk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$wk;
                $0b2e6adb871a3b94$var$wk = null;
                $0b2e6adb871a3b94$var$xk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Sj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Qj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$ok.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ji(c, b);
    b = $0b2e6adb871a3b94$var$Ni(a, b, 1);
    a = $0b2e6adb871a3b94$var$nh(a, b, 1);
    b = $0b2e6adb871a3b94$var$R();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Dk(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Ri || !$0b2e6adb871a3b94$var$Ri.has(d))) {
                a = $0b2e6adb871a3b94$var$Ji(c, a);
                a = $0b2e6adb871a3b94$var$Qi(b, a, 1);
                b = $0b2e6adb871a3b94$var$nh(b, a, 1);
                a = $0b2e6adb871a3b94$var$R();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$Q === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$fk ? $0b2e6adb871a3b94$var$Kk(a, 0) : $0b2e6adb871a3b94$var$rk |= c);
    $0b2e6adb871a3b94$var$Dk(a, b);
}
function $0b2e6adb871a3b94$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$R();
    a = $0b2e6adb871a3b94$var$ih(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Dk(a, c));
}
function $0b2e6adb871a3b94$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
function $0b2e6adb871a3b94$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Yk(a, c);
}
var $0b2e6adb871a3b94$var$Vk;
$0b2e6adb871a3b94$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$yj(a, b, c);
            $0b2e6adb871a3b94$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$dh = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$ij(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$ch(b, c);
            e = $0b2e6adb871a3b94$var$Nh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$kh(b), e.updater = $0b2e6adb871a3b94$var$Ei, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$Ii(b, d, a, c), b = $0b2e6adb871a3b94$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$Zk(d);
                a = $0b2e6adb871a3b94$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$$i(null, b, d, $0b2e6adb871a3b94$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$kj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$lh(a, b);
                $0b2e6adb871a3b94$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ji(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$lj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Ah(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$gj(a, b), $0b2e6adb871a3b94$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$oj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Ug(b, null, d, c) : $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$Yi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$ch(b, c), e = $0b2e6adb871a3b94$var$eh(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Ci(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Ci(d.type, e), $0b2e6adb871a3b94$var$$i(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Ci(d, e), $0b2e6adb871a3b94$var$ij(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$ch(b, c), $0b2e6adb871a3b94$var$Gi(b, d, e), $0b2e6adb871a3b94$var$Ii(b, d, e, c), $0b2e6adb871a3b94$var$jj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$xj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$dj(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Fk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$$k(a, b, c, d);
}
function $0b2e6adb871a3b94$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$Zk(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Tg(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Tg(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$pj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$Qg(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$kh(f);
    return a;
}
function $0b2e6adb871a3b94$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$dl(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$el(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$dl(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$R();
    e = $0b2e6adb871a3b94$var$yi(c);
    f = $0b2e6adb871a3b94$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$nh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Dk(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$R(), g = $0b2e6adb871a3b94$var$yi(e);
    c = $0b2e6adb871a3b94$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$nh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$gi(a, e, g, f), $0b2e6adb871a3b94$var$oh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    $0b2e6adb871a3b94$var$hl(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$hl(a, b);
}
function $0b2e6adb871a3b94$var$jl() {
    return null;
}
var $0b2e6adb871a3b94$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ll(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.render = $0b2e6adb871a3b94$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$fl(a, b, null, null);
};
$0b2e6adb871a3b94$var$ml.prototype.unmount = $0b2e6adb871a3b94$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Rk(function() {
            $0b2e6adb871a3b94$var$fl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$pl() {}
function $0b2e6adb871a3b94$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$el(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$gl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$bl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$pl);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$fl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$gl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$fl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$ql(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$gl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Dk(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Gj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Rk(function() {
                var b = $0b2e6adb871a3b94$var$ih(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$R();
                    $0b2e6adb871a3b94$var$gi(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$il(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$ih(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$il(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$yi(a), c = $0b2e6adb871a3b94$var$ih(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$R();
            $0b2e6adb871a3b94$var$gi(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$il(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Rk;
var $0b2e6adb871a3b94$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Qk
    ]
}, $0b2e6adb871a3b94$var$tl = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$ul = {
    bundleType: $0b2e6adb871a3b94$var$tl.bundleType,
    version: $0b2e6adb871a3b94$var$tl.version,
    rendererPackageName: $0b2e6adb871a3b94$var$tl.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$tl.findFiberByHostInstance || $0b2e6adb871a3b94$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$vl.isDisabled && $0b2e6adb871a3b94$var$vl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$vl.inject($0b2e6adb871a3b94$var$ul), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$vl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$sl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$nl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$cl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ll(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Rk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$nl(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$rl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Rk(function() {
        $0b2e6adb871a3b94$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Qk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$ol(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$rl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));


parcelRequire("acw62");
var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
'use strict';
var $11492dca620dcaa5$exports = {};
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;


// App.jsx - Main App component (slim orchestrator)

parcelRequire("acw62");
/**
 * @fileoverview Exports React Context providers and their associated hooks.
 * These contexts manage global application state, separating user preferences
 * (settings) from quiz session state for better separation of concerns.
 * @module context
 */ /**
 * @description SettingsProvider wraps the app to provide user preferences.
 * @description useSettings hook accesses settings state (levels, forms, display options).
 */ // Settings Context - manages all user preferences and display options


var $acw62 = parcelRequire("acw62");
// Default quiz settings
const $2dbe475692899d38$export$896bb544166b7bc5 = [
    1,
    2
];
const $2dbe475692899d38$export$31a1864be1d33bad = [
    'Intransitive',
    'Transitive'
];
const $2dbe475692899d38$export$c36f40dd12d0ad64 = [
    'Polite',
    'Plain'
];
const $2dbe475692899d38$export$d894ea38a8d3ed54 = [
    1,
    2,
    3,
    4,
    5,
    6
];


const $967b4ec559f6d613$var$SettingsContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
// Helper to toggle an item in an array (with minimum 1 item constraint)
const $967b4ec559f6d613$var$toggleItem = (prev, item)=>{
    if (prev.includes(item)) {
        if (prev.length === 1) return prev; // At least one must remain
        return prev.filter((i)=>i !== item);
    }
    return [
        ...prev,
        item
    ];
};
function $967b4ec559f6d613$export$e134aa690da9cc14({ children: children }) {
    // Filter settings
    const [selectedLevels, setSelectedLevels] = (0, $acw62.useState)((0, $2dbe475692899d38$export$896bb544166b7bc5));
    const [selectedTypes, setSelectedTypes] = (0, $acw62.useState)((0, $2dbe475692899d38$export$31a1864be1d33bad));
    const [selectedForms, setSelectedForms] = (0, $acw62.useState)((0, $2dbe475692899d38$export$c36f40dd12d0ad64));
    const [isFixedOrder, setIsFixedOrder] = (0, $acw62.useState)(false);
    // Display settings
    const [showFurigana, setShowFurigana] = (0, $acw62.useState)(false);
    const [showDictionary, setShowDictionary] = (0, $acw62.useState)(false);
    const [showPairs, setShowPairs] = (0, $acw62.useState)(false);
    const [showEnglish, setShowEnglish] = (0, $acw62.useState)(false);
    const [showSimilarPatterns, setShowSimilarPatterns] = (0, $acw62.useState)(false);
    // Toggle functions with minimum constraint
    const toggleLevel = (0, $acw62.useCallback)((level)=>{
        setSelectedLevels((prev)=>$967b4ec559f6d613$var$toggleItem(prev, level));
    }, []);
    const toggleType = (0, $acw62.useCallback)((type)=>{
        setSelectedTypes((prev)=>$967b4ec559f6d613$var$toggleItem(prev, type));
    }, []);
    const toggleForm = (0, $acw62.useCallback)((form)=>{
        setSelectedForms((prev)=>$967b4ec559f6d613$var$toggleItem(prev, form));
    }, []);
    const value = {
        selectedLevels: // Filter settings
        selectedLevels,
        selectedTypes: selectedTypes,
        selectedForms: selectedForms,
        isFixedOrder: isFixedOrder,
        toggleLevel: toggleLevel,
        toggleType: toggleType,
        toggleForm: toggleForm,
        setIsFixedOrder: setIsFixedOrder,
        showFurigana: // Display settings
        showFurigana,
        showDictionary: showDictionary,
        showPairs: showPairs,
        showEnglish: showEnglish,
        showSimilarPatterns: showSimilarPatterns,
        setShowFurigana: setShowFurigana,
        setShowDictionary: setShowDictionary,
        setShowPairs: setShowPairs,
        setShowEnglish: setShowEnglish,
        setShowSimilarPatterns: setShowSimilarPatterns
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($967b4ec559f6d613$var$SettingsContext.Provider, {
        value: value,
        children: children
    });
}
const $967b4ec559f6d613$export$9115b42802a3e44f = ()=>{
    const context = (0, $acw62.useContext)($967b4ec559f6d613$var$SettingsContext);
    if (!context) throw new Error('useSettings must be used within a SettingsProvider');
    return context;
};


// Quiz Context - manages quiz state using useReducer


var $acw62 = parcelRequire("acw62");
// Quiz filtering, shuffling, and answer validation logic
/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $6ea6f2158d3e9a5f$export$3d46f4579dba46e5 = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();


/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $54b042b30b7c9ecc$export$73bda83cddbc7187 = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();


/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $d2dcfab7024a5319$export$86f54f62aa7a7514 = (string)=>string.replace(/^([A-Z])|[\s-_]+(\w)/g, (match, p1, p2)=>p2 ? p2.toUpperCase() : p1.toLowerCase());


const $65d69981a4d8cd49$export$6fb43ff9addf7357 = (string)=>{
    const camelCase = (0, $d2dcfab7024a5319$export$86f54f62aa7a7514)(string);
    return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};


/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $acw62 = parcelRequire("acw62");
/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var $65855df5fc59b2ec$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};


/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $3d93205fc0768e44$export$ab365959aa6deed0 = (props)=>{
    for(const prop in props){
        if (prop.startsWith("aria-") || prop === "role" || prop === "title") return true;
    }
    return false;
};



const $d2b1338ec3fa0df8$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)(({ color: color = "currentColor", size: size = 24, strokeWidth: strokeWidth = 2, absoluteStrokeWidth: absoluteStrokeWidth, className: className = "", children: children, iconNode: iconNode, ...rest }, ref)=>(0, $acw62.createElement)("svg", {
        ref: ref,
        ...(0, $65855df5fc59b2ec$export$2e2bcd8739ae039),
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: (0, $6ea6f2158d3e9a5f$export$3d46f4579dba46e5)("lucide", className),
        ...!children && !(0, $3d93205fc0768e44$export$ab365959aa6deed0)(rest) && {
            "aria-hidden": "true"
        },
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, $acw62.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]));


const $810dc495bedb1cb1$export$2e2bcd8739ae039 = (iconName, iconNode)=>{
    const Component = (0, $acw62.forwardRef)(({ className: className, ...props }, ref)=>(0, $acw62.createElement)((0, $d2b1338ec3fa0df8$export$2e2bcd8739ae039), {
            ref: ref,
            iconNode: iconNode,
            className: (0, $6ea6f2158d3e9a5f$export$3d46f4579dba46e5)(`lucide-${(0, $54b042b30b7c9ecc$export$73bda83cddbc7187)((0, $65d69981a4d8cd49$export$6fb43ff9addf7357)(iconName))}`, `lucide-${iconName}`, className),
            ...props
        }));
    Component.displayName = (0, $65d69981a4d8cd49$export$6fb43ff9addf7357)(iconName);
    return Component;
};


const $f9e50e5a44fb11e0$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "m12 5 7 7-7 7",
            key: "xquz4c"
        }
    ]
];
const $f9e50e5a44fb11e0$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("arrow-right", $f9e50e5a44fb11e0$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $dbe0cbc446f3d7c2$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10 16c.5.3 1.2.5 2 .5s1.5-.2 2-.5",
            key: "1u7htd"
        }
    ],
    [
        "path",
        {
            d: "M15 12h.01",
            key: "1k8ypt"
        }
    ],
    [
        "path",
        {
            d: "M19.38 6.813A9 9 0 0 1 20.8 10.2a2 2 0 0 1 0 3.6 9 9 0 0 1-17.6 0 2 2 0 0 1 0-3.6A9 9 0 0 1 12 3c2 0 3.5 1.1 3.5 2.5s-.9 2.5-2 2.5c-.8 0-1.5-.4-1.5-1",
            key: "11xh7x"
        }
    ],
    [
        "path",
        {
            d: "M9 12h.01",
            key: "157uk2"
        }
    ]
];
const $dbe0cbc446f3d7c2$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("baby", $dbe0cbc446f3d7c2$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $a9a828219bd3e73d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M4 13c3.5-2 8-2 10 2a5.5 5.5 0 0 1 8 5",
            key: "1cscit"
        }
    ],
    [
        "path",
        {
            d: "M5.15 17.89c5.52-1.52 8.65-6.89 7-12C11.55 4 11.5 2 13 2c3.22 0 5 5.5 5 8 0 6.5-4.2 12-10.49 12C5.11 22 2 22 2 20c0-1.5 1.14-1.55 3.15-2.11Z",
            key: "1y1nbv"
        }
    ]
];
const $a9a828219bd3e73d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("banana", $a9a828219bd3e73d$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $399d1cc6b64aaf4c$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M17 11h1a3 3 0 0 1 0 6h-1",
            key: "1yp76v"
        }
    ],
    [
        "path",
        {
            d: "M9 12v6",
            key: "1u1cab"
        }
    ],
    [
        "path",
        {
            d: "M13 12v6",
            key: "1sugkk"
        }
    ],
    [
        "path",
        {
            d: "M14 7.5c-1 0-1.44.5-3 .5s-2-.5-3-.5-1.72.5-2.5.5a2.5 2.5 0 0 1 0-5c.78 0 1.57.5 2.5.5S9.44 2 11 2s2 1.5 3 1.5 1.72-.5 2.5-.5a2.5 2.5 0 0 1 0 5c-.78 0-1.5-.5-2.5-.5Z",
            key: "1510fo"
        }
    ],
    [
        "path",
        {
            d: "M5 8v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8",
            key: "19jb7n"
        }
    ]
];
const $399d1cc6b64aaf4c$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("beer", $399d1cc6b64aaf4c$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $42cc10498d5d9f4b$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M17 10c.7-.7 1.69 0 2.5 0a2.5 2.5 0 1 0 0-5 .5.5 0 0 1-.5-.5 2.5 2.5 0 1 0-5 0c0 .81.7 1.8 0 2.5l-7 7c-.7.7-1.69 0-2.5 0a2.5 2.5 0 0 0 0 5c.28 0 .5.22.5.5a2.5 2.5 0 1 0 5 0c0-.81-.7-1.8 0-2.5Z",
            key: "w610uw"
        }
    ]
];
const $42cc10498d5d9f4b$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("bone", $42cc10498d5d9f4b$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b5e412fe3136fb7c$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 18V5",
            key: "adv99a"
        }
    ],
    [
        "path",
        {
            d: "M15 13a4.17 4.17 0 0 1-3-4 4.17 4.17 0 0 1-3 4",
            key: "1e3is1"
        }
    ],
    [
        "path",
        {
            d: "M17.598 6.5A3 3 0 1 0 12 5a3 3 0 1 0-5.598 1.5",
            key: "1gqd8o"
        }
    ],
    [
        "path",
        {
            d: "M17.997 5.125a4 4 0 0 1 2.526 5.77",
            key: "iwvgf7"
        }
    ],
    [
        "path",
        {
            d: "M18 18a4 4 0 0 0 2-7.464",
            key: "efp6ie"
        }
    ],
    [
        "path",
        {
            d: "M19.967 17.483A4 4 0 1 1 12 18a4 4 0 1 1-7.967-.517",
            key: "1gq6am"
        }
    ],
    [
        "path",
        {
            d: "M6 18a4 4 0 0 1-2-7.464",
            key: "k1g0md"
        }
    ],
    [
        "path",
        {
            d: "M6.003 5.125a4 4 0 0 0-2.526 5.77",
            key: "q97ue3"
        }
    ]
];
const $b5e412fe3136fb7c$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("brain", $b5e412fe3136fb7c$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $34c3e517ec92034a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16",
            key: "jecpp"
        }
    ],
    [
        "rect",
        {
            width: "20",
            height: "14",
            x: "2",
            y: "6",
            rx: "2",
            key: "i6l2r4"
        }
    ]
];
const $34c3e517ec92034a$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("briefcase", $34c3e517ec92034a$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $30050f52d874b8f2$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M8 2v4",
            key: "1cmpym"
        }
    ],
    [
        "path",
        {
            d: "M16 2v4",
            key: "4m81vk"
        }
    ],
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "4",
            rx: "2",
            key: "1hopcy"
        }
    ],
    [
        "path",
        {
            d: "M3 10h18",
            key: "8toen8"
        }
    ]
];
const $30050f52d874b8f2$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("calendar", $30050f52d874b8f2$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $7fca19d3fce363c2$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M13.997 4a2 2 0 0 1 1.76 1.05l.486.9A2 2 0 0 0 18.003 7H20a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h1.997a2 2 0 0 0 1.759-1.048l.489-.904A2 2 0 0 1 10.004 4z",
            key: "18u6gg"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "13",
            r: "3",
            key: "1vg3eu"
        }
    ]
];
const $7fca19d3fce363c2$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("camera", $7fca19d3fce363c2$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f4dbd3c6c67fb44f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m21 8-2 2-1.5-3.7A2 2 0 0 0 15.646 5H8.4a2 2 0 0 0-1.903 1.257L5 10 3 8",
            key: "1imjwt"
        }
    ],
    [
        "path",
        {
            d: "M7 14h.01",
            key: "1qa3f1"
        }
    ],
    [
        "path",
        {
            d: "M17 14h.01",
            key: "7oqj8z"
        }
    ],
    [
        "rect",
        {
            width: "18",
            height: "8",
            x: "3",
            y: "10",
            rx: "2",
            key: "a7itu8"
        }
    ],
    [
        "path",
        {
            d: "M5 18v2",
            key: "ppbyun"
        }
    ],
    [
        "path",
        {
            d: "M19 18v2",
            key: "gy7782"
        }
    ]
];
const $f4dbd3c6c67fb44f$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("car-front", $f4dbd3c6c67fb44f$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $176d6e46e6973fb2$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M18 6 7 17l-5-5",
            key: "116fxf"
        }
    ],
    [
        "path",
        {
            d: "m22 10-7.5 7.5L13 16",
            key: "ke71qq"
        }
    ]
];
const $176d6e46e6973fb2$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("check-check", $176d6e46e6973fb2$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e3f86240925e7a9e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21.801 10A10 10 0 1 1 17 3.335",
            key: "yps3ct"
        }
    ],
    [
        "path",
        {
            d: "m9 11 3 3L22 4",
            key: "1pflzl"
        }
    ]
];
const $e3f86240925e7a9e$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("circle-check-big", $e3f86240925e7a9e$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c879de12ab6f91f5$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21 10.656V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12.344",
            key: "2acyp4"
        }
    ],
    [
        "path",
        {
            d: "m9 11 3 3L22 4",
            key: "1pflzl"
        }
    ]
];
const $c879de12ab6f91f5$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("square-check-big", $c879de12ab6f91f5$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8a5d1dc6449205ac$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "1",
            key: "41hilf"
        }
    ]
];
const $8a5d1dc6449205ac$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("circle-dot", $8a5d1dc6449205ac$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $200392fae49ddb7e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 6v6l4 2",
            key: "mmk7yg"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ]
];
const $200392fae49ddb7e$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("clock", $200392fae49ddb7e$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $6826835d9d90fe9d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10 2v2",
            key: "7u0qdc"
        }
    ],
    [
        "path",
        {
            d: "M14 2v2",
            key: "6buw04"
        }
    ],
    [
        "path",
        {
            d: "M16 8a1 1 0 0 1 1 1v8a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V9a1 1 0 0 1 1-1h14a4 4 0 1 1 0 8h-1",
            key: "pwadti"
        }
    ],
    [
        "path",
        {
            d: "M6 2v2",
            key: "colzsn"
        }
    ]
];
const $6826835d9d90fe9d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("coffee", $6826835d9d90fe9d$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9ec88f95add56de8$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "8",
            cy: "8",
            r: "6",
            key: "3yglwk"
        }
    ],
    [
        "path",
        {
            d: "M18.09 10.37A6 6 0 1 1 10.34 18",
            key: "t5s6rm"
        }
    ],
    [
        "path",
        {
            d: "M7 6h1v4",
            key: "1obek4"
        }
    ],
    [
        "path",
        {
            d: "m16.71 13.88.7.71-2.82 2.82",
            key: "1rbuyh"
        }
    ]
];
const $9ec88f95add56de8$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("coins", $9ec88f95add56de8$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $118a3f0c40edc8b8$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10.2 18H4.774a1.5 1.5 0 0 1-1.352-.97 11 11 0 0 1 .132-6.487",
            key: "14kkz9"
        }
    ],
    [
        "path",
        {
            d: "M18 10.2V4.774a1.5 1.5 0 0 0-.97-1.352 11 11 0 0 0-6.486.132",
            key: "1g7v07"
        }
    ],
    [
        "path",
        {
            d: "M18 5a4 3 0 0 1 4 3 2 2 0 0 1-2 2 10 10 0 0 0-5.139 1.42",
            key: "ratg6b"
        }
    ],
    [
        "path",
        {
            d: "M5 18a3 4 0 0 0 3 4 2 2 0 0 0 2-2 10 10 0 0 1 1.42-5.14",
            key: "4454f0"
        }
    ],
    [
        "path",
        {
            d: "M8.709 2.554a10 10 0 0 0-6.155 6.155 1.5 1.5 0 0 0 .676 1.626l9.807 5.42a2 2 0 0 0 2.718-2.718l-5.42-9.807a1.5 1.5 0 0 0-1.626-.676",
            key: "qmemie"
        }
    ]
];
const $118a3f0c40edc8b8$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("croissant", $118a3f0c40edc8b8$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $da7acf661ca2b113$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M11.25 16.25h1.5L12 17z",
            key: "w7jh35"
        }
    ],
    [
        "path",
        {
            d: "M16 14v.5",
            key: "1lajdz"
        }
    ],
    [
        "path",
        {
            d: "M4.42 11.247A13.152 13.152 0 0 0 4 14.556C4 18.728 7.582 21 12 21s8-2.272 8-6.444a11.702 11.702 0 0 0-.493-3.309",
            key: "u7s9ue"
        }
    ],
    [
        "path",
        {
            d: "M8 14v.5",
            key: "1nzgdb"
        }
    ],
    [
        "path",
        {
            d: "M8.5 8.5c-.384 1.05-1.083 2.028-2.344 2.5-1.931.722-3.576-.297-3.656-1-.113-.994 1.177-6.53 4-7 1.923-.321 3.651.845 3.651 2.235A7.497 7.497 0 0 1 14 5.277c0-1.39 1.844-2.598 3.767-2.277 2.823.47 4.113 6.006 4 7-.08.703-1.725 1.722-3.656 1-1.261-.472-1.855-1.45-2.239-2.5",
            key: "v8hric"
        }
    ]
];
const $da7acf661ca2b113$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("dog", $da7acf661ca2b113$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $857e3ecebc998acb$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10 12h.01",
            key: "1kxr2c"
        }
    ],
    [
        "path",
        {
            d: "M18 20V6a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v14",
            key: "36qu9e"
        }
    ],
    [
        "path",
        {
            d: "M2 20h20",
            key: "owomy5"
        }
    ]
];
const $857e3ecebc998acb$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("door-closed", $857e3ecebc998acb$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5312be1f93a1cf02$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M11 20H2",
            key: "nlcfvz"
        }
    ],
    [
        "path",
        {
            d: "M11 4.562v16.157a1 1 0 0 0 1.242.97L19 20V5.562a2 2 0 0 0-1.515-1.94l-4-1A2 2 0 0 0 11 4.561z",
            key: "au4z13"
        }
    ],
    [
        "path",
        {
            d: "M11 4H8a2 2 0 0 0-2 2v14",
            key: "74r1mk"
        }
    ],
    [
        "path",
        {
            d: "M14 12h.01",
            key: "1jfl7z"
        }
    ],
    [
        "path",
        {
            d: "M22 20h-3",
            key: "vhrsz"
        }
    ]
];
const $5312be1f93a1cf02$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("door-open", $5312be1f93a1cf02$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $dcca7f0309fce79c$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M6 8.5a6.5 6.5 0 1 1 13 0c0 6-6 6-6 10a3.5 3.5 0 1 1-7 0",
            key: "1dfaln"
        }
    ],
    [
        "path",
        {
            d: "M15 8.5a2.5 2.5 0 0 0-5 0v1a2 2 0 1 1 0 4",
            key: "1qnva7"
        }
    ]
];
const $dcca7f0309fce79c$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("ear", $dcca7f0309fce79c$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9f84efd0d553789a$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 2C8 2 4 8 4 14a8 8 0 0 0 16 0c0-6-4-12-8-12",
            key: "1le142"
        }
    ]
];
const $9f84efd0d553789a$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("egg", $9f84efd0d553789a$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $ed5cb62e5e60963e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M15 2h-4a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8",
            key: "14sh0y"
        }
    ],
    [
        "path",
        {
            d: "M16.706 2.706A2.4 2.4 0 0 0 15 2v5a1 1 0 0 0 1 1h5a2.4 2.4 0 0 0-.706-1.706z",
            key: "1970lx"
        }
    ],
    [
        "path",
        {
            d: "M5 7a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h8a2 2 0 0 0 1.732-1",
            key: "l4dndm"
        }
    ]
];
const $ed5cb62e5e60963e$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("files", $ed5cb62e5e60963e$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $72b94b0deb61e5b1$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z",
            key: "1oefj6"
        }
    ],
    [
        "path",
        {
            d: "M14 2v5a1 1 0 0 0 1 1h5",
            key: "wfsgrz"
        }
    ],
    [
        "path",
        {
            d: "m14.5 12.5-5 5",
            key: "b62r18"
        }
    ],
    [
        "path",
        {
            d: "m9.5 12.5 5 5",
            key: "1rk7el"
        }
    ]
];
const $72b94b0deb61e5b1$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("file-x", $72b94b0deb61e5b1$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $0d83c4063ed3cfa6$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4",
            key: "1nerag"
        }
    ],
    [
        "path",
        {
            d: "M14 13.12c0 2.38 0 6.38-1 8.88",
            key: "o46ks0"
        }
    ],
    [
        "path",
        {
            d: "M17.29 21.02c.12-.6.43-2.3.5-3.02",
            key: "ptglia"
        }
    ],
    [
        "path",
        {
            d: "M2 12a10 10 0 0 1 18-6",
            key: "ydlgp0"
        }
    ],
    [
        "path",
        {
            d: "M2 16h.01",
            key: "1gqxmh"
        }
    ],
    [
        "path",
        {
            d: "M21.8 16c.2-2 .131-5.354 0-6",
            key: "drycrb"
        }
    ],
    [
        "path",
        {
            d: "M5 19.5C5.5 18 6 15 6 12a6 6 0 0 1 .34-2",
            key: "1tidbn"
        }
    ],
    [
        "path",
        {
            d: "M8.65 22c.21-.66.45-1.32.57-2",
            key: "13wd9y"
        }
    ],
    [
        "path",
        {
            d: "M9 6.8a6 6 0 0 1 9 5.2v2",
            key: "1fr1j5"
        }
    ]
];
const $0d83c4063ed3cfa6$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("fingerprint-pattern", $0d83c4063ed3cfa6$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $60ce6054535c0854$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 3q1 4 4 6.5t3 5.5a1 1 0 0 1-14 0 5 5 0 0 1 1-3 1 1 0 0 0 5 0c0-2-1.5-3-1.5-5q0-2 2.5-4",
            key: "1slcih"
        }
    ]
];
const $60ce6054535c0854$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("flame", $60ce6054535c0854$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $d456d8ec70b00bbe$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z",
            key: "j76jl0"
        }
    ],
    [
        "path",
        {
            d: "M22 10v6",
            key: "1lu8f3"
        }
    ],
    [
        "path",
        {
            d: "M6 12.5V16a6 3 0 0 0 12 0v-3.5",
            key: "1r8lef"
        }
    ]
];
const $d456d8ec70b00bbe$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("graduation-cap", $d456d8ec70b00bbe$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $95e9e50748ea8ef2$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5",
            key: "mvr1a0"
        }
    ],
    [
        "path",
        {
            d: "M3.22 13H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27",
            key: "auskq0"
        }
    ]
];
const $95e9e50748ea8ef2$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("heart-pulse", $95e9e50748ea8ef2$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e57d6b071418ede9$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5",
            key: "1gvzjb"
        }
    ],
    [
        "path",
        {
            d: "M9 18h6",
            key: "x1upvd"
        }
    ],
    [
        "path",
        {
            d: "M10 22h4",
            key: "ceow96"
        }
    ]
];
const $e57d6b071418ede9$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("lightbulb", $e57d6b071418ede9$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $0c41eca9379797e2$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16.8 11.2c.8-.9 1.2-2 1.2-3.2a6 6 0 0 0-9.3-5",
            key: "1fkcox"
        }
    ],
    [
        "path",
        {
            d: "m2 2 20 20",
            key: "1ooewy"
        }
    ],
    [
        "path",
        {
            d: "M6.3 6.3a4.67 4.67 0 0 0 1.2 5.2c.7.7 1.3 1.5 1.5 2.5",
            key: "10m8kw"
        }
    ],
    [
        "path",
        {
            d: "M9 18h6",
            key: "x1upvd"
        }
    ],
    [
        "path",
        {
            d: "M10 22h4",
            key: "ceow96"
        }
    ]
];
const $0c41eca9379797e2$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("lightbulb-off", $0c41eca9379797e2$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f633c0fb63f4b508$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "20",
            height: "14",
            x: "2",
            y: "3",
            rx: "2",
            key: "48i651"
        }
    ],
    [
        "line",
        {
            x1: "8",
            x2: "16",
            y1: "21",
            y2: "21",
            key: "1svkeh"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "17",
            y2: "21",
            key: "vw1qmm"
        }
    ]
];
const $f633c0fb63f4b508$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("monitor", $f633c0fb63f4b508$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $071feb051549c27f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m8 3 4 8 5-5 5 15H2L8 3z",
            key: "otkl63"
        }
    ]
];
const $071feb051549c27f$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("mountain", $071feb051549c27f$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $766b7a414a24981f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M9 18V5l12-2v13",
            key: "1jmyc2"
        }
    ],
    [
        "circle",
        {
            cx: "6",
            cy: "18",
            r: "3",
            key: "fqmcym"
        }
    ],
    [
        "circle",
        {
            cx: "18",
            cy: "16",
            r: "3",
            key: "1hluhg"
        }
    ]
];
const $766b7a414a24981f$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("music", $766b7a414a24981f$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $437c67a40c1b8279$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z",
            key: "1a0edw"
        }
    ],
    [
        "path",
        {
            d: "M12 22V12",
            key: "d0xqtd"
        }
    ],
    [
        "polyline",
        {
            points: "3.29 7 12 12 20.71 7",
            key: "ousv84"
        }
    ],
    [
        "path",
        {
            d: "m7.5 4.27 9 5.15",
            key: "1c824w"
        }
    ]
];
const $437c67a40c1b8279$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("package", $437c67a40c1b8279$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $b33d9013e1e2b0b6$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
            key: "1a8usu"
        }
    ]
];
const $b33d9013e1e2b0b6$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("pen", $b33d9013e1e2b0b6$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8a800148d042d893$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8",
            key: "v9h5vc"
        }
    ],
    [
        "path",
        {
            d: "M21 3v5h-5",
            key: "1q7to0"
        }
    ],
    [
        "path",
        {
            d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16",
            key: "3uifl3"
        }
    ],
    [
        "path",
        {
            d: "M8 16H3v5",
            key: "1cv678"
        }
    ]
];
const $8a800148d042d893$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("refresh-cw", $8a800148d042d893$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $3b2757083c1fe006$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8",
            key: "1p45f6"
        }
    ],
    [
        "path",
        {
            d: "M21 3v5h-5",
            key: "1q7to0"
        }
    ]
];
const $3b2757083c1fe006$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("rotate-cw", $3b2757083c1fe006$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $0811c1891b547863$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 3v18",
            key: "108xh3"
        }
    ],
    [
        "path",
        {
            d: "m19 8 3 8a5 5 0 0 1-6 0zV7",
            key: "zcdpyk"
        }
    ],
    [
        "path",
        {
            d: "M3 7h1a17 17 0 0 0 8-2 17 17 0 0 0 8 2h1",
            key: "1yorad"
        }
    ],
    [
        "path",
        {
            d: "m5 8 3 8a5 5 0 0 1-6 0zV7",
            key: "eua70x"
        }
    ],
    [
        "path",
        {
            d: "M7 21h10",
            key: "1b0cd5"
        }
    ]
];
const $0811c1891b547863$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("scale", $0811c1891b547863$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $2c4b775586278895$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "6",
            cy: "6",
            r: "3",
            key: "1lh9wr"
        }
    ],
    [
        "path",
        {
            d: "M8.12 8.12 12 12",
            key: "1alkpv"
        }
    ],
    [
        "path",
        {
            d: "M20 4 8.12 15.88",
            key: "xgtan2"
        }
    ],
    [
        "circle",
        {
            cx: "6",
            cy: "18",
            r: "3",
            key: "fqmcym"
        }
    ],
    [
        "path",
        {
            d: "M14.8 14.8 20 20",
            key: "ptml3r"
        }
    ]
];
const $2c4b775586278895$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("scissors", $2c4b775586278895$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9ad14973a512851d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m21 21-4.34-4.34",
            key: "14j7rj"
        }
    ],
    [
        "circle",
        {
            cx: "11",
            cy: "11",
            r: "8",
            key: "4ej97u"
        }
    ]
];
const $9ad14973a512851d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("search", $9ad14973a512851d$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $da03c070d837b197$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915",
            key: "1i5ecw"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "3",
            key: "1v7zrd"
        }
    ]
];
const $da03c070d837b197$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("settings", $da03c070d837b197$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $0d47d6236e6e268e$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z",
            key: "1wgbhj"
        }
    ]
];
const $0d47d6236e6e268e$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("shirt", $0d47d6236e6e268e$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $bbd8efc75c2264c3$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 21a9 9 0 0 0 9-9H3a9 9 0 0 0 9 9Z",
            key: "4rw317"
        }
    ],
    [
        "path",
        {
            d: "M7 21h10",
            key: "1b0cd5"
        }
    ],
    [
        "path",
        {
            d: "M19.5 12 22 6",
            key: "shfsr5"
        }
    ],
    [
        "path",
        {
            d: "M16.25 3c.27.1.8.53.75 1.36-.06.83-.93 1.2-1 2.02-.05.78.34 1.24.73 1.62",
            key: "rpc6vp"
        }
    ],
    [
        "path",
        {
            d: "M11.25 3c.27.1.8.53.74 1.36-.05.83-.93 1.2-.98 2.02-.06.78.33 1.24.72 1.62",
            key: "1lf63m"
        }
    ],
    [
        "path",
        {
            d: "M6.25 3c.27.1.8.53.75 1.36-.06.83-.93 1.2-1 2.02-.05.78.34 1.24.74 1.62",
            key: "97tijn"
        }
    ]
];
const $bbd8efc75c2264c3$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("soup", $bbd8efc75c2264c3$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $552554c986ed6ef6$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "4",
            key: "4exip2"
        }
    ],
    [
        "path",
        {
            d: "M12 2v2",
            key: "tus03m"
        }
    ],
    [
        "path",
        {
            d: "M12 20v2",
            key: "1lh1kg"
        }
    ],
    [
        "path",
        {
            d: "m4.93 4.93 1.41 1.41",
            key: "149t6j"
        }
    ],
    [
        "path",
        {
            d: "m17.66 17.66 1.41 1.41",
            key: "ptbguv"
        }
    ],
    [
        "path",
        {
            d: "M2 12h2",
            key: "1t8f8n"
        }
    ],
    [
        "path",
        {
            d: "M20 12h2",
            key: "1q8mjw"
        }
    ],
    [
        "path",
        {
            d: "m6.34 17.66-1.41 1.41",
            key: "1m8zz5"
        }
    ],
    [
        "path",
        {
            d: "m19.07 4.93-1.41 1.41",
            key: "1shlcs"
        }
    ]
];
const $552554c986ed6ef6$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("sun", $552554c986ed6ef6$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8872a1d80d2463f9$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z",
            key: "vktsd0"
        }
    ],
    [
        "circle",
        {
            cx: "7.5",
            cy: "7.5",
            r: ".5",
            fill: "currentColor",
            key: "kqv944"
        }
    ]
];
const $8872a1d80d2463f9$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("tag", $8872a1d80d2463f9$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $8c74e91f1b4ec8c3$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m10 20-1.25-2.5L6 18",
            key: "18frcb"
        }
    ],
    [
        "path",
        {
            d: "M10 4 8.75 6.5 6 6",
            key: "7mghy3"
        }
    ],
    [
        "path",
        {
            d: "M10.585 15H10",
            key: "4nqulp"
        }
    ],
    [
        "path",
        {
            d: "M2 12h6.5L10 9",
            key: "kv9z4n"
        }
    ],
    [
        "path",
        {
            d: "M20 14.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0z",
            key: "yu0u2z"
        }
    ],
    [
        "path",
        {
            d: "m4 10 1.5 2L4 14",
            key: "k9enpj"
        }
    ],
    [
        "path",
        {
            d: "m7 21 3-6-1.5-3",
            key: "j8hb9u"
        }
    ],
    [
        "path",
        {
            d: "m7 3 3 6h2",
            key: "1bbqgq"
        }
    ]
];
const $8c74e91f1b4ec8c3$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("thermometer-snowflake", $8c74e91f1b4ec8c3$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $9d9f9102f02f4e08$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12 2v2",
            key: "tus03m"
        }
    ],
    [
        "path",
        {
            d: "M12 8a4 4 0 0 0-1.645 7.647",
            key: "wz5p04"
        }
    ],
    [
        "path",
        {
            d: "M2 12h2",
            key: "1t8f8n"
        }
    ],
    [
        "path",
        {
            d: "M20 14.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0z",
            key: "yu0u2z"
        }
    ],
    [
        "path",
        {
            d: "m4.93 4.93 1.41 1.41",
            key: "149t6j"
        }
    ],
    [
        "path",
        {
            d: "m6.34 17.66-1.41 1.41",
            key: "1m8zz5"
        }
    ]
];
const $9d9f9102f02f4e08$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("thermometer-sun", $9d9f9102f02f4e08$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $1d55a58c47e43a5b$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10 11v6",
            key: "nco0om"
        }
    ],
    [
        "path",
        {
            d: "M14 11v6",
            key: "outv1u"
        }
    ],
    [
        "path",
        {
            d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6",
            key: "miytrc"
        }
    ],
    [
        "path",
        {
            d: "M3 6h18",
            key: "d0wm0j"
        }
    ],
    [
        "path",
        {
            d: "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2",
            key: "e791ji"
        }
    ]
];
const $1d55a58c47e43a5b$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("trash-2", $1d55a58c47e43a5b$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $fab2f21898bf5b1d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10 10v.2A3 3 0 0 1 8.9 16H5a3 3 0 0 1-1-5.8V10a3 3 0 0 1 6 0Z",
            key: "1l6gj6"
        }
    ],
    [
        "path",
        {
            d: "M7 16v6",
            key: "1a82de"
        }
    ],
    [
        "path",
        {
            d: "M13 19v3",
            key: "13sx9i"
        }
    ],
    [
        "path",
        {
            d: "M12 19h8.3a1 1 0 0 0 .7-1.7L18 14h.3a1 1 0 0 0 .7-1.7L16 9h.2a1 1 0 0 0 .8-1.7L13 3l-1.4 1.5",
            key: "1sj9kv"
        }
    ]
];
const $fab2f21898bf5b1d$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("trees", $fab2f21898bf5b1d$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $0f45c1e8ae52ad76$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2",
            key: "975kel"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "7",
            r: "4",
            key: "17ys0d"
        }
    ]
];
const $0f45c1e8ae52ad76$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("user", $0f45c1e8ae52ad76$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c38b5b11d1e2b813$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
            key: "1yyitq"
        }
    ],
    [
        "path",
        {
            d: "M16 3.128a4 4 0 0 1 0 7.744",
            key: "16gr8j"
        }
    ],
    [
        "path",
        {
            d: "M22 21v-2a4 4 0 0 0-3-3.87",
            key: "kshegd"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "7",
            r: "4",
            key: "nufk8"
        }
    ]
];
const $c38b5b11d1e2b813$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("users", $c38b5b11d1e2b813$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $33b542e8915cec79$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1",
            key: "18etb6"
        }
    ],
    [
        "path",
        {
            d: "M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4",
            key: "xoc0q4"
        }
    ]
];
const $33b542e8915cec79$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("wallet", $33b542e8915cec79$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $228a858c8f4b4bf0$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M2 6c.6.5 1.2 1 2.5 1C7 7 7 5 9.5 5c2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
            key: "knzxuh"
        }
    ],
    [
        "path",
        {
            d: "M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
            key: "2jd2cc"
        }
    ],
    [
        "path",
        {
            d: "M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
            key: "rd2r6e"
        }
    ]
];
const $228a858c8f4b4bf0$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("waves", $228a858c8f4b4bf0$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $23f985f27b046d81$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M12.8 19.6A2 2 0 1 0 14 16H2",
            key: "148xed"
        }
    ],
    [
        "path",
        {
            d: "M17.5 8a2.5 2.5 0 1 1 2 4H2",
            key: "1u4tom"
        }
    ],
    [
        "path",
        {
            d: "M9.8 4.4A2 2 0 1 1 11 8H2",
            key: "75valh"
        }
    ]
];
const $23f985f27b046d81$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("wind", $23f985f27b046d81$export$3efd853dbb351e94);

/**
 * @license lucide-react v0.563.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $839eea37a960d2b1$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "m15 9-6 6",
            key: "1uzhvr"
        }
    ],
    [
        "path",
        {
            d: "m9 9 6 6",
            key: "z0biqf"
        }
    ]
];
const $839eea37a960d2b1$export$2e2bcd8739ae039 = (0, $810dc495bedb1cb1$export$2e2bcd8739ae039)("circle-x", $839eea37a960d2b1$export$3efd853dbb351e94);




const $1e60d8c6534cd098$export$af1e5d9f49fbe577 = {
    su: {
        pattern: 'suffix-su',
        explanationJa: "\u2026\u3059 \u27F9 \u5916\u5411\u7684 (\u2248 \u3059\u308B)",
        explanationEn: 'Outward-Directed (\u2248 "To do")',
        type: 'Transitive'
    },
    aru: {
        pattern: 'suffix-aru',
        explanationJa: "\u2026\u3042 + \u308B \u27F9 \u5185\u5411\u7684 (\u2248 \u3042\u308B)",
        explanationEn: 'Inward-Directed (\u2248 "To be")',
        type: 'Intransitive'
    }
};
// "A" column hiragana characters that precede る in the aru pattern
const $1e60d8c6534cd098$var$A_COLUMN_HIRAGANA = [
    "\u3042",
    "\u304B",
    "\u3055",
    "\u305F",
    "\u306A",
    "\u306F",
    "\u307E",
    "\u3084",
    "\u3089",
    "\u308F",
    "\u304C",
    "\u3056",
    "\u3060",
    "\u3070",
    "\u3071"
];
function $1e60d8c6534cd098$export$c6323d5e307fb20c(dictionaryRuby) {
    if (!dictionaryRuby || dictionaryRuby.length === 0) return null;
    // Get the reading of the verb (combine all rt values, falling back to text for kana)
    const reading = dictionaryRuby.map((r)=>r.rt || r.text).join('');
    // Check for suffix -su: ends in す
    if (reading.endsWith("\u3059")) return 'suffix-su';
    // Check for suffix -aru: ends in [a-column hiragana] + る
    if (reading.endsWith("\u308B") && reading.length >= 2) {
        const secondToLast = reading[reading.length - 2];
        if ($1e60d8c6534cd098$var$A_COLUMN_HIRAGANA.includes(secondToLast)) return 'suffix-aru';
    }
    return null;
}
const $1e60d8c6534cd098$export$b28a0e5be47ced59 = [
    // --- LEVEL 1 (IDs 1-20) ---
    {
        id: 1,
        level: 1,
        politeSentence: "\u30C9\u30A2\u304C\u958B\u304D\u307E\u3059",
        politeKana: "\u30C9\u30A2\u304C\u3042\u304D\u307E\u3059",
        plainSentence: "\u30C9\u30A2\u304C\u958B\u304F",
        plainKana: "\u30C9\u30A2\u304C\u3042\u304F",
        type: "Intransitive",
        english: "The door opens",
        noun: "\u30C9\u30A2",
        nounRuby: [
            {
                text: "\u30C9\u30A2",
                rt: ""
            }
        ],
        verbPrompt: "\u958B",
        verbRuby: [
            {
                text: "\u958B",
                rt: "\u3042"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u958B",
                rt: "\u3042"
            },
            {
                text: "\u304F",
                rt: ""
            }
        ],
        icon: (0, $5312be1f93a1cf02$export$2e2bcd8739ae039),
        color: "text-blue-400",
        morphologicalEnding: "\u3046-\u3048\u308B"
    },
    {
        id: 2,
        level: 1,
        politeSentence: "\u30C9\u30A2\u3092\u958B\u3051\u307E\u3059",
        politeKana: "\u30C9\u30A2\u3092\u3042\u3051\u307E\u3059",
        plainSentence: "\u30C9\u30A2\u3092\u958B\u3051\u308B",
        plainKana: "\u30C9\u30A2\u3092\u3042\u3051\u308B",
        type: "Transitive",
        english: "I open the door",
        noun: "\u30C9\u30A2",
        nounRuby: [
            {
                text: "\u30C9\u30A2",
                rt: ""
            }
        ],
        verbPrompt: "\u958B",
        verbRuby: [
            {
                text: "\u958B",
                rt: "\u3042"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u958B",
                rt: "\u3042"
            },
            {
                text: "\u3051",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $5312be1f93a1cf02$export$2e2bcd8739ae039),
        color: "text-green-400",
        morphologicalEnding: "\u3046-\u3048\u308B"
    },
    {
        id: 3,
        level: 1,
        politeSentence: "\u30C9\u30A2\u304C\u9589\u307E\u308A\u307E\u3059",
        politeKana: "\u30C9\u30A2\u304C\u3057\u307E\u308A\u307E\u3059",
        plainSentence: "\u30C9\u30A2\u304C\u9589\u307E\u308B",
        plainKana: "\u30C9\u30A2\u304C\u3057\u307E\u308B",
        type: "Intransitive",
        english: "The door closes",
        noun: "\u30C9\u30A2",
        nounRuby: [
            {
                text: "\u30C9\u30A2",
                rt: ""
            }
        ],
        verbPrompt: "\u9589",
        verbRuby: [
            {
                text: "\u9589",
                rt: "\u3057"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u9589",
                rt: "\u3057"
            },
            {
                text: "\u307E",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $857e3ecebc998acb$export$2e2bcd8739ae039),
        color: "text-blue-400",
        morphologicalEnding: "\u3042\u308B-\u3048\u308B"
    },
    {
        id: 4,
        level: 1,
        politeSentence: "\u30C9\u30A2\u3092\u9589\u3081\u307E\u3059",
        politeKana: "\u30C9\u30A2\u3092\u3057\u3081\u307E\u3059",
        plainSentence: "\u30C9\u30A2\u3092\u9589\u3081\u308B",
        plainKana: "\u30C9\u30A2\u3092\u3057\u3081\u308B",
        type: "Transitive",
        english: "I close the door",
        noun: "\u30C9\u30A2",
        nounRuby: [
            {
                text: "\u30C9\u30A2",
                rt: ""
            }
        ],
        verbPrompt: "\u9589",
        verbRuby: [
            {
                text: "\u9589",
                rt: "\u3057"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u9589",
                rt: "\u3057"
            },
            {
                text: "\u3081",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $857e3ecebc998acb$export$2e2bcd8739ae039),
        color: "text-green-400",
        morphologicalEnding: "\u3042\u308B-\u3048\u308B"
    },
    {
        id: 5,
        level: 1,
        politeSentence: "\u72AC\u304C\u51FA\u307E\u3059",
        politeKana: "\u3044\u306C\u304C\u3067\u307E\u3059",
        plainSentence: "\u72AC\u304C\u51FA\u308B",
        plainKana: "\u3044\u306C\u304C\u3067\u308B",
        type: "Intransitive",
        english: "The dog leaves / goes out",
        noun: "\u72AC",
        nounRuby: [
            {
                text: "\u72AC",
                rt: "\u3044\u306C"
            }
        ],
        verbPrompt: "\u51FA",
        verbRuby: [
            {
                text: "\u51FA",
                rt: "\u3067"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u51FA",
                rt: "\u3067"
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $da7acf661ca2b113$export$2e2bcd8739ae039),
        color: "text-blue-400",
        morphologicalEnding: "\u3048\u308B-\u3042\u3059"
    },
    {
        id: 6,
        level: 1,
        politeSentence: "\u72AC\u3092\u51FA\u3057\u307E\u3059",
        politeKana: "\u3044\u306C\u3092\u3060\u3057\u307E\u3059",
        plainSentence: "\u72AC\u3092\u51FA\u3059",
        plainKana: "\u3044\u306C\u3092\u3060\u3059",
        type: "Transitive",
        english: "I let the dog out",
        noun: "\u72AC",
        nounRuby: [
            {
                text: "\u72AC",
                rt: "\u3044\u306C"
            }
        ],
        verbPrompt: "\u51FA",
        verbRuby: [
            {
                text: "\u51FA",
                rt: "\u3060"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u51FA",
                rt: "\u3060"
            },
            {
                text: "\u3059",
                rt: ""
            }
        ],
        icon: (0, $da7acf661ca2b113$export$2e2bcd8739ae039),
        color: "text-green-400",
        morphologicalEnding: "\u3048\u308B-\u3042\u3059"
    },
    {
        id: 7,
        level: 1,
        politeSentence: "\u8033\u304C\u52D5\u304D\u307E\u3059",
        politeKana: "\u307F\u307F\u304C\u3046\u3054\u304D\u307E\u3059",
        plainSentence: "\u8033\u304C\u52D5\u304F",
        plainKana: "\u307F\u307F\u304C\u3046\u3054\u304F",
        type: "Intransitive",
        english: "The ears move",
        noun: "\u8033",
        nounRuby: [
            {
                text: "\u8033",
                rt: "\u307F\u307F"
            }
        ],
        verbPrompt: "\u52D5",
        verbRuby: [
            {
                text: "\u52D5",
                rt: "\u3046\u3054"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u52D5",
                rt: "\u3046\u3054"
            },
            {
                text: "\u304F",
                rt: ""
            }
        ],
        icon: (0, $dcca7f0309fce79c$export$2e2bcd8739ae039),
        color: "text-blue-400",
        morphologicalEnding: "\u3046-\u3042\u3059"
    },
    {
        id: 8,
        level: 1,
        politeSentence: "\u8033\u3092\u52D5\u304B\u3057\u307E\u3059",
        politeKana: "\u307F\u307F\u3092\u3046\u3054\u304B\u3057\u307E\u3059",
        plainSentence: "\u8033\u3092\u52D5\u304B\u3059",
        plainKana: "\u307F\u307F\u3092\u3046\u3054\u304B\u3059",
        type: "Transitive",
        english: "I move my ears",
        noun: "\u8033",
        nounRuby: [
            {
                text: "\u8033",
                rt: "\u307F\u307F"
            }
        ],
        verbPrompt: "\u52D5",
        verbRuby: [
            {
                text: "\u52D5",
                rt: "\u3046\u3054"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u52D5",
                rt: "\u3046\u3054"
            },
            {
                text: "\u304B",
                rt: ""
            },
            {
                text: "\u3059",
                rt: ""
            }
        ],
        icon: (0, $dcca7f0309fce79c$export$2e2bcd8739ae039),
        color: "text-green-400",
        morphologicalEnding: "\u3046-\u3042\u3059"
    },
    {
        id: 9,
        level: 1,
        politeSentence: "\u8ECA\u304C\u6B62\u307E\u308A\u307E\u3059",
        politeKana: "\u304F\u308B\u30DE\u30AC\u3068\u307E\u308A\u307E\u3059",
        plainSentence: "\u8ECA\u304C\u6B62\u307E\u308B",
        plainKana: "\u304F\u308B\u307E\u304C\u3068\u307E\u308B",
        type: "Intransitive",
        english: "The car stops",
        noun: "\u8ECA",
        nounRuby: [
            {
                text: "\u8ECA",
                rt: "\u304F\u308B\u307E"
            }
        ],
        verbPrompt: "\u6B62",
        verbRuby: [
            {
                text: "\u6B62",
                rt: "\u3068"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u6B62",
                rt: "\u3068"
            },
            {
                text: "\u307E",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $f4dbd3c6c67fb44f$export$2e2bcd8739ae039),
        color: "text-blue-400",
        morphologicalEnding: "\u3042\u308B-\u3048\u308B"
    },
    {
        id: 10,
        level: 1,
        politeSentence: "\u8ECA\u3092\u6B62\u3081\u307E\u3059",
        politeKana: "\u304F\u308B\u307E\u3092\u3068\u3081\u307E\u3059",
        plainSentence: "\u8ECA\u3092\u6B62\u3081\u308B",
        plainKana: "\u304F\u308B\u307E\u3092\u3068\u3081\u308B",
        type: "Transitive",
        english: "I stop the car",
        noun: "\u8ECA",
        nounRuby: [
            {
                text: "\u8ECA",
                rt: "\u304F\u308B\u307E"
            }
        ],
        verbPrompt: "\u6B62",
        verbRuby: [
            {
                text: "\u6B62",
                rt: "\u3068"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u6B62",
                rt: "\u3068"
            },
            {
                text: "\u3081",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $f4dbd3c6c67fb44f$export$2e2bcd8739ae039),
        color: "text-green-400",
        morphologicalEnding: "\u3042\u308B-\u3048\u308B"
    },
    {
        id: 11,
        level: 1,
        politeSentence: "\u96FB\u6C17\u304C\u3064\u304D\u307E\u3059",
        politeKana: "\u3067\u3093\u304D\u304C\u3064\u304D\u307E\u3059",
        plainSentence: "\u96FB\u6C17\u304C\u3064\u304F",
        plainKana: "\u3067\u3093\u304D\u304C\u3064\u304F",
        type: "Intransitive",
        english: "The light comes on",
        noun: "\u96FB\u6C17",
        nounRuby: [
            {
                text: "\u96FB",
                rt: "\u3067\u3093"
            },
            {
                text: "\u6C17",
                rt: "\u304D"
            }
        ],
        verbPrompt: "\u3064",
        verbRuby: [
            {
                text: "\u3064",
                rt: ""
            }
        ],
        dictionaryRuby: [
            {
                text: "\u3064",
                rt: ""
            },
            {
                text: "\u304F",
                rt: ""
            }
        ],
        icon: (0, $e57d6b071418ede9$export$2e2bcd8739ae039),
        color: "text-yellow-400",
        morphologicalEnding: "\u3046-\u3048\u308B"
    },
    {
        id: 12,
        level: 1,
        politeSentence: "\u96FB\u6C17\u3092\u3064\u3051\u307E\u3059",
        politeKana: "\u3067\u3093\u304D\u3092\u3064\u3051\u307E\u3059",
        plainSentence: "\u96FB\u6C17\u3092\u3064\u3051\u308B",
        plainKana: "\u3067\u3093\u304D\u3092\u3064\u3051\u308B",
        type: "Transitive",
        english: "I turn on the light",
        noun: "\u96FB\u6C17",
        nounRuby: [
            {
                text: "\u96FB",
                rt: "\u3067\u3093"
            },
            {
                text: "\u6C17",
                rt: "\u304D"
            }
        ],
        verbPrompt: "\u3064",
        verbRuby: [
            {
                text: "\u3064",
                rt: ""
            }
        ],
        dictionaryRuby: [
            {
                text: "\u3064",
                rt: ""
            },
            {
                text: "\u3051",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $e57d6b071418ede9$export$2e2bcd8739ae039),
        color: "text-yellow-400",
        morphologicalEnding: "\u3046-\u3048\u308B"
    },
    {
        id: 13,
        level: 1,
        politeSentence: "\u96FB\u6C17\u304C\u6D88\u3048\u307E\u3059",
        politeKana: "\u3067\u3093\u304D\u304C\u304D\u3048\u307E\u3059",
        plainSentence: "\u96FB\u6C17\u304C\u6D88\u3048\u308B",
        plainKana: "\u3067\u3093\u304D\u304C\u304D\u3048\u308B",
        type: "Intransitive",
        english: "The light goes off",
        noun: "\u96FB\u6C17",
        nounRuby: [
            {
                text: "\u96FB",
                rt: "\u3067\u3093"
            },
            {
                text: "\u6C17",
                rt: "\u304D"
            }
        ],
        verbPrompt: "\u6D88",
        verbRuby: [
            {
                text: "\u6D88",
                rt: "\u304D"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u6D88",
                rt: "\u304D"
            },
            {
                text: "\u3048",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $0c41eca9379797e2$export$2e2bcd8739ae039),
        color: "text-gray-400",
        morphologicalEnding: "\u3048\u308B-\u3059"
    },
    {
        id: 14,
        level: 1,
        politeSentence: "\u96FB\u6C17\u3092\u6D88\u3057\u307E\u3059",
        politeKana: "\u3067\u3093\u304D\u3092\u3051\u3057\u307E\u3059",
        plainSentence: "\u96FB\u6C17\u3092\u6D88\u3059",
        plainKana: "\u3067\u3093\u304D\u3092\u3051\u3059",
        type: "Transitive",
        english: "I turn off the light",
        noun: "\u96FB\u6C17",
        nounRuby: [
            {
                text: "\u96FB",
                rt: "\u3067\u3093"
            },
            {
                text: "\u6C17",
                rt: "\u304D"
            }
        ],
        verbPrompt: "\u6D88",
        verbRuby: [
            {
                text: "\u6D88",
                rt: "\u3051"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u6D88",
                rt: "\u3051"
            },
            {
                text: "\u3059",
                rt: ""
            }
        ],
        icon: (0, $0c41eca9379797e2$export$2e2bcd8739ae039),
        color: "text-gray-400",
        morphologicalEnding: "\u3048\u308B-\u3059"
    },
    {
        id: 15,
        level: 1,
        politeSentence: "\u4E88\u5B9A\u304C\u5909\u308F\u308A\u307E\u3059",
        politeKana: "\u3088\u3066\u3044\u304C\u304B\u308F\u308A",
        plainSentence: "\u4E88\u5B9A\u304C\u5909\u308F\u308B",
        plainKana: "\u3088\u3066\u3044\u304C\u304B\u308F\u308B",
        type: "Intransitive",
        english: "The plan changes",
        noun: "\u4E88\u5B9A",
        nounRuby: [
            {
                text: "\u4E88",
                rt: "\u3088"
            },
            {
                text: "\u5B9A",
                rt: "\u3066\u3044"
            }
        ],
        verbPrompt: "\u5909",
        verbRuby: [
            {
                text: "\u5909",
                rt: "\u304B"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u5909",
                rt: "\u304B"
            },
            {
                text: "\u308F",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $30050f52d874b8f2$export$2e2bcd8739ae039),
        color: "text-blue-400",
        morphologicalEnding: "\u3042\u308B-\u3048\u308B"
    },
    {
        id: 16,
        level: 1,
        politeSentence: "\u4E88\u5B9A\u3092\u5909\u3048\u307E\u3059",
        politeKana: "\u3088\u3066\u3044\u3092\u304B\u3048\u307E\u3059",
        plainSentence: "\u4E88\u5B9A\u3092\u5909\u3048\u308B",
        plainKana: "\u3088\u3066\u3044\u3092\u304B\u3048\u308B",
        type: "Transitive",
        english: "I change the plan",
        noun: "\u4E88\u5B9A",
        nounRuby: [
            {
                text: "\u4E88",
                rt: "\u3088"
            },
            {
                text: "\u5B9A",
                rt: "\u3066\u3044"
            }
        ],
        verbPrompt: "\u5909",
        verbRuby: [
            {
                text: "\u5909",
                rt: "\u304B"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u5909",
                rt: "\u304B"
            },
            {
                text: "\u3048",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $30050f52d874b8f2$export$2e2bcd8739ae039),
        color: "text-green-400",
        morphologicalEnding: "\u3042\u308B-\u3048\u308B"
    },
    {
        id: 17,
        level: 1,
        politeSentence: "\u75C5\u6C17\u304C\u6CBB\u308A\u307E\u3059",
        politeKana: "\u3073\u3087\u3046\u304D\u304C\u306A\u304A\u308A\u307E\u3059",
        plainSentence: "\u75C5\u6C17\u304C\u6CBB\u308B",
        plainKana: "\u3073\u3087\u3046\u304D\u304C\u306A\u304A\u308B",
        type: "Intransitive",
        english: "The illness is cured",
        noun: "\u75C5\u6C17",
        nounRuby: [
            {
                text: "\u75C5",
                rt: "\u3073\u3087\u3046"
            },
            {
                text: "\u6C17",
                rt: "\u304D"
            }
        ],
        verbPrompt: "\u6CBB",
        verbRuby: [
            {
                text: "\u6CBB",
                rt: "\u306A\u304A"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u6CBB",
                rt: "\u306A\u304A"
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $95e9e50748ea8ef2$export$2e2bcd8739ae039),
        color: "text-red-400",
        morphologicalEnding: "\u308B-\u3059"
    },
    {
        id: 18,
        level: 1,
        politeSentence: "\u75C5\u6C17\u3092\u6CBB\u3057\u307E\u3059",
        politeKana: "\u3073\u3087\u3046\u304D\u3092\u306A\u304A\u3057\u307E\u3059",
        plainSentence: "\u75C5\u6C17\u3092\u6CBB\u3059",
        plainKana: "\u3073\u3087\u3046\u304D\u3092\u306A\u304A\u3059",
        type: "Transitive",
        english: "I cure the illness",
        noun: "\u75C5\u6C17",
        nounRuby: [
            {
                text: "\u75C5",
                rt: "\u3073\u3087\u3046"
            },
            {
                text: "\u6C17",
                rt: "\u304D"
            }
        ],
        verbPrompt: "\u6CBB",
        verbRuby: [
            {
                text: "\u6CBB",
                rt: "\u306A\u304A"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u6CBB",
                rt: "\u306A\u304A"
            },
            {
                text: "\u3059",
                rt: ""
            }
        ],
        icon: (0, $95e9e50748ea8ef2$export$2e2bcd8739ae039),
        color: "text-red-400",
        morphologicalEnding: "\u308B-\u3059"
    },
    {
        id: 19,
        level: 1,
        politeSentence: "\u30EC\u30C3\u30B9\u30F3\u304C\u59CB\u307E\u308A\u307E\u3059",
        politeKana: "\u30EC\u30C3\u30B9\u30F3\u304C\u306F\u3058\u307E\u308A\u307E\u3059",
        plainSentence: "\u30EC\u30C3\u30B9\u30F3\u304C\u59CB\u307E\u308B",
        plainKana: "\u30EC\u30C3\u30B9\u30F3\u304C\u306F\u3058\u307E\u308B",
        type: "Intransitive",
        english: "The lesson begins",
        noun: "\u30EC\u30C3\u30B9\u30F3",
        nounRuby: [
            {
                text: "\u30EC\u30C3\u30B9\u30F3",
                rt: ""
            }
        ],
        verbPrompt: "\u59CB",
        verbRuby: [
            {
                text: "\u59CB",
                rt: "\u306F\u3058"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u59CB",
                rt: "\u306F\u3058"
            },
            {
                text: "\u307E",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $d456d8ec70b00bbe$export$2e2bcd8739ae039),
        color: "text-blue-400",
        morphologicalEnding: "\u3042\u308B-\u3048\u308B"
    },
    {
        id: 20,
        level: 1,
        politeSentence: "\u30EC\u30C3\u30B9\u30F3\u3092\u59CB\u3081\u307E\u3059",
        politeKana: "\u30EC\u30C3\u30B9\u30F3\u3092\u306F\u3058\u3081\u307E\u3059",
        plainSentence: "\u30EC\u30C3\u30B9\u30F3\u3092\u59CB\u3081\u308B",
        plainKana: "\u30EC\u30C3\u30B9\u30F3\u3092\u306F\u3058\u3081\u308B",
        type: "Transitive",
        english: "I begin the lesson",
        noun: "\u30EC\u30C3\u30B9\u30F3",
        nounRuby: [
            {
                text: "\u30EC\u30C3\u30B9\u30F3",
                rt: ""
            }
        ],
        verbPrompt: "\u59CB",
        verbRuby: [
            {
                text: "\u59CB",
                rt: "\u306F\u3058"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u59CB",
                rt: "\u306F\u3058"
            },
            {
                text: "\u3081",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $d456d8ec70b00bbe$export$2e2bcd8739ae039),
        color: "text-green-400",
        morphologicalEnding: "\u3042\u308B-\u3048\u308B"
    },
    // --- LEVEL 2 (IDs 21-40) ---
    {
        id: 21,
        level: 2,
        politeSentence: "\u30DA\u30F3\u304C\u843D\u3061\u307E\u3059",
        politeKana: "\u30DA\u30F3\u304C\u304A\u3061\u307E\u3059",
        plainSentence: "\u30DA\u30F3\u304C\u843D\u3061\u308B",
        plainKana: "\u30DA\u30F3\u304C\u304A\u3061\u308B",
        type: "Intransitive",
        english: "The pen falls",
        noun: "\u30DA\u30F3",
        nounRuby: [
            {
                text: "\u30DA\u30F3",
                rt: ""
            }
        ],
        verbPrompt: "\u843D",
        verbRuby: [
            {
                text: "\u843D",
                rt: "\u304A"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u843D",
                rt: "\u304A"
            },
            {
                text: "\u3061",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $b33d9013e1e2b0b6$export$2e2bcd8739ae039),
        color: "text-blue-400",
        morphologicalEnding: "\u3044\u308B-\u304A\u3059"
    },
    {
        id: 22,
        level: 2,
        politeSentence: "\u30DA\u30F3\u3092\u843D\u3068\u3057\u307E\u3059",
        politeKana: "\u30DA\u30F3\u3092\u304A\u3068\u3057\u307E\u3059",
        plainSentence: "\u30DA\u30F3\u3092\u843D\u3068\u3059",
        plainKana: "\u30DA\u30F3\u3092\u304A\u3068\u3059",
        type: "Transitive",
        english: "I drop the pen",
        noun: "\u30DA\u30F3",
        nounRuby: [
            {
                text: "\u30DA\u30F3",
                rt: ""
            }
        ],
        verbPrompt: "\u843D",
        verbRuby: [
            {
                text: "\u843D",
                rt: "\u304A"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u843D",
                rt: "\u304A"
            },
            {
                text: "\u3068",
                rt: ""
            },
            {
                text: "\u3059",
                rt: ""
            }
        ],
        icon: (0, $b33d9013e1e2b0b6$export$2e2bcd8739ae039),
        color: "text-green-400",
        morphologicalEnding: "\u3044\u308B-\u304A\u3059"
    },
    {
        id: 23,
        level: 2,
        politeSentence: "\u97F3\u697D\u304C\u805E\u3053\u3048\u307E\u3059",
        politeKana: "\u304A\u3093\u304C\u304F\u304C\u304D\u3053\u3048\u307E\u3059",
        plainSentence: "\u97F3\u697D\u304C\u805E\u3053\u3048\u308B",
        plainKana: "\u304A\u3093\u304C\u304F\u304C\u304D\u3053\u3048\u308B",
        type: "Intransitive",
        english: "The music can be heard",
        noun: "\u97F3\u697D",
        nounRuby: [
            {
                text: "\u97F3",
                rt: "\u304A\u3093"
            },
            {
                text: "\u697D",
                rt: "\u304C\u304F"
            }
        ],
        verbPrompt: "\u805E",
        verbRuby: [
            {
                text: "\u805E",
                rt: "\u304D"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u805E",
                rt: "\u304D"
            },
            {
                text: "\u3053",
                rt: ""
            },
            {
                text: "\u3048",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $766b7a414a24981f$export$2e2bcd8739ae039),
        color: "text-purple-400",
        morphologicalEnding: "\u3048\u308B-\u3046"
    },
    {
        id: 24,
        level: 2,
        politeSentence: "\u97F3\u697D\u3092\u805E\u304D\u307E\u3059",
        politeKana: "\u304A\u3093\u304C\u304F\u3092\u304D\u304D\u307E\u3059",
        plainSentence: "\u97F3\u697D\u3092\u805E\u304F",
        plainKana: "\u304A\u3093\u304C\u304F\u3092\u304D\u304F",
        type: "Transitive",
        english: "I listen to music",
        noun: "\u97F3\u697D",
        nounRuby: [
            {
                text: "\u97F3",
                rt: "\u304A\u3093"
            },
            {
                text: "\u697D",
                rt: "\u304C\u304F"
            }
        ],
        verbPrompt: "\u805E",
        verbRuby: [
            {
                text: "\u805E",
                rt: "\u304D"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u805E",
                rt: "\u304D"
            },
            {
                text: "\u304F",
                rt: ""
            }
        ],
        icon: (0, $766b7a414a24981f$export$2e2bcd8739ae039),
        color: "text-purple-400",
        morphologicalEnding: "\u3048\u308B-\u3046"
    },
    {
        id: 25,
        level: 2,
        politeSentence: "\u5BCC\u58EB\u5C71\u304C\u898B\u3048\u307E\u3059",
        politeKana: "\u3075\u3058\u3055\u3093\u304C\u307F\u3048\u307E\u3059",
        plainSentence: "\u5BCC\u58EB\u5C71\u304C\u898B\u3048\u308B",
        plainKana: "\u3075\u3058\u3055\u3093\u304C\u307F\u3048\u308B",
        type: "Intransitive",
        english: "Mt. Fuji can be seen",
        noun: "\u5BCC\u58EB\u5C71",
        nounRuby: [
            {
                text: "\u5BCC",
                rt: "\u3075"
            },
            {
                text: "\u58EB",
                rt: "\u3058"
            },
            {
                text: "\u5C71",
                rt: "\u3055\u3093"
            }
        ],
        verbPrompt: "\u898B",
        verbRuby: [
            {
                text: "\u898B",
                rt: "\u307F"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u898B",
                rt: "\u307F"
            },
            {
                text: "\u3048",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $071feb051549c27f$export$2e2bcd8739ae039),
        color: "text-blue-400",
        morphologicalEnding: "\u3048\u308B-\u308B"
    },
    {
        id: 26,
        level: 2,
        politeSentence: "\u5BCC\u58EB\u5C71\u3092\u898B\u307E\u3059",
        politeKana: "\u3075\u3058\u3055\u3093\u3092\u307F\u307E\u3059",
        plainSentence: "\u5BCC\u58EB\u5C71\u3092\u898B\u308B",
        plainKana: "\u3075\u3058\u3055\u3093\u3092\u307F\u308B",
        type: "Transitive",
        english: "I look at Mt. Fuji",
        noun: "\u5BCC\u58EB\u5C71",
        nounRuby: [
            {
                text: "\u5BCC",
                rt: "\u3075"
            },
            {
                text: "\u58EB",
                rt: "\u3058"
            },
            {
                text: "\u5C71",
                rt: "\u3055\u3093"
            }
        ],
        verbPrompt: "\u898B",
        verbRuby: [
            {
                text: "\u898B",
                rt: "\u307F"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u898B",
                rt: "\u307F"
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $071feb051549c27f$export$2e2bcd8739ae039),
        color: "text-green-400",
        morphologicalEnding: "\u3048\u308B-\u308B"
    },
    {
        id: 27,
        level: 2,
        politeSentence: "\u8CA1\u5E03\u304C\u306A\u304F\u306A\u308A\u307E\u3059",
        politeKana: "\u3055\u3044\u3075\u304C\u306A\u304F\u306A\u308A\u307E\u3059",
        plainSentence: "\u8CA1\u5E03\u304C\u306A\u304F\u306A\u308B",
        plainKana: "\u3055\u3044\u3075\u304C\u306A\u304F\u306A\u308B",
        type: "Intransitive",
        english: "The wallet gets lost",
        noun: "\u8CA1\u5E03",
        nounRuby: [
            {
                text: "\u8CA1",
                rt: "\u3055\u3044"
            },
            {
                text: "\u5E03",
                rt: "\u3075"
            }
        ],
        verbPrompt: "\u306A",
        verbRuby: [
            {
                text: "\u306A\u304F",
                rt: ""
            }
        ],
        dictionaryRuby: [
            {
                text: "\u306A",
                rt: ""
            },
            {
                text: "\u304F",
                rt: ""
            },
            {
                text: "\u306A",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $33b542e8915cec79$export$2e2bcd8739ae039),
        color: "text-yellow-600",
        morphologicalEnding: "\u3042\u308B-\u3059"
    },
    {
        id: 28,
        level: 2,
        politeSentence: "\u8CA1\u5E03\u3092\u306A\u304F\u3057\u307E\u3059",
        politeKana: "\u3055\u3044\u3075\u3092\u306A\u304F\u3057\u307E\u3059",
        plainSentence: "\u8CA1\u5E03\u3092\u306A\u304F\u3059",
        plainKana: "\u3055\u3044\u3075\u3092\u306A\u304F\u3059",
        type: "Transitive",
        english: "I lose the wallet",
        noun: "\u8CA1\u5E03",
        nounRuby: [
            {
                text: "\u8CA1",
                rt: "\u3055\u3044"
            },
            {
                text: "\u5E03",
                rt: "\u3075"
            }
        ],
        verbPrompt: "\u306A",
        verbRuby: [
            {
                text: "\u306A\u304F",
                rt: ""
            }
        ],
        dictionaryRuby: [
            {
                text: "\u306A",
                rt: ""
            },
            {
                text: "\u304F",
                rt: ""
            },
            {
                text: "\u3059",
                rt: ""
            }
        ],
        icon: (0, $33b542e8915cec79$export$2e2bcd8739ae039),
        color: "text-yellow-600",
        morphologicalEnding: "\u3042\u308B-\u3059"
    },
    {
        id: 29,
        level: 2,
        politeSentence: "\u8CA1\u5E03\u304C\u898B\u3064\u304B\u308A\u307E\u3059",
        politeKana: "\u3055\u3044\u3075\u304C\u307F\u3064\u304B\u308A\u307E\u3059",
        plainSentence: "\u8CA1\u5E03\u304C\u898B\u3064\u304B\u308B",
        plainKana: "\u3055\u3044\u3075\u304C\u307F\u3064\u304B\u308B",
        type: "Intransitive",
        english: "The wallet is found",
        noun: "\u8CA1\u5E03",
        nounRuby: [
            {
                text: "\u8CA1",
                rt: "\u3055\u3044"
            },
            {
                text: "\u5E03",
                rt: "\u3075"
            }
        ],
        verbPrompt: "\u898B",
        verbRuby: [
            {
                text: "\u898B\u3064",
                rt: "\u307F\u3064"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u898B",
                rt: "\u307F"
            },
            {
                text: "\u3064",
                rt: ""
            },
            {
                text: "\u304B",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $9ad14973a512851d$export$2e2bcd8739ae039),
        color: "text-blue-400",
        morphologicalEnding: "\u3042\u308B-\u3048\u308B"
    },
    {
        id: 30,
        level: 2,
        politeSentence: "\u8CA1\u5E03\u3092\u898B\u3064\u3051\u307E\u3059",
        politeKana: "\u3055\u3044\u3075\u3092\u307F\u3064\u3051\u307E\u3059",
        plainSentence: "\u8CA1\u5E03\u3092\u898B\u3064\u3051\u308B",
        plainKana: "\u3055\u3044\u3075\u3092\u307F\u3064\u3051\u308B",
        type: "Transitive",
        english: "I find the wallet",
        noun: "\u8CA1\u5E03",
        nounRuby: [
            {
                text: "\u8CA1",
                rt: "\u3055\u3044"
            },
            {
                text: "\u5E03",
                rt: "\u3075"
            }
        ],
        verbPrompt: "\u898B",
        verbRuby: [
            {
                text: "\u898B\u3064",
                rt: "\u307F\u3064"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u898B",
                rt: "\u307F"
            },
            {
                text: "\u3064",
                rt: ""
            },
            {
                text: "\u3051",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $9ad14973a512851d$export$2e2bcd8739ae039),
        color: "text-green-400",
        morphologicalEnding: "\u3042\u308B-\u3048\u308B"
    },
    {
        id: 31,
        level: 2,
        politeSentence: "\u4E88\u5B9A\u304C\u6C7A\u307E\u308A\u307E\u3059",
        politeKana: "\u3088\u3066\u3044\u304C\u304D\u307E\u308A\u307E\u3059",
        plainSentence: "\u4E88\u5B9A\u304C\u6C7A\u307E\u308B",
        plainKana: "\u3088\u3066\u3044\u304C\u304D\u307E\u308B",
        type: "Intransitive",
        english: "The plan is decided",
        noun: "\u4E88\u5B9A",
        nounRuby: [
            {
                text: "\u4E88",
                rt: "\u3088"
            },
            {
                text: "\u5B9A",
                rt: "\u3066\u3044"
            }
        ],
        verbPrompt: "\u6C7A",
        verbRuby: [
            {
                text: "\u6C7A",
                rt: "\u304D"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u6C7A",
                rt: "\u304D"
            },
            {
                text: "\u307E",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $c879de12ab6f91f5$export$2e2bcd8739ae039),
        color: "text-blue-400",
        morphologicalEnding: "\u3042\u308B-\u3048\u308B"
    },
    {
        id: 32,
        level: 2,
        politeSentence: "\u4E88\u5B9A\u3092\u6C7A\u3081\u307E\u3059",
        politeKana: "\u3088\u3066\u3044\u3092\u304D\u3081\u307E\u3059",
        plainSentence: "\u4E88\u5B9A\u3092\u6C7A\u3081\u308B",
        plainKana: "\u3088\u3066\u3044\u3092\u304D\u3081\u308B",
        type: "Transitive",
        english: "I decide the plan",
        noun: "\u4E88\u5B9A",
        nounRuby: [
            {
                text: "\u4E88",
                rt: "\u3088"
            },
            {
                text: "\u5B9A",
                rt: "\u3066\u3044"
            }
        ],
        verbPrompt: "\u6C7A",
        verbRuby: [
            {
                text: "\u6C7A",
                rt: "\u304D"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u6C7A",
                rt: "\u304D"
            },
            {
                text: "\u3081",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $c879de12ab6f91f5$export$2e2bcd8739ae039),
        color: "text-green-400",
        morphologicalEnding: "\u3042\u308B-\u3048\u308B"
    },
    {
        id: 33,
        level: 2,
        politeSentence: "\u98A8\u304C\u5165\u308A\u307E\u3059",
        politeKana: "\u304B\u305C\u304C\u306F\u3044\u308A\u307E\u3059",
        plainSentence: "\u98A8\u304C\u5165\u308B",
        plainKana: "\u304B\u305C\u304C\u306F\u3044\u308B",
        type: "Intransitive",
        english: "The wind comes in",
        noun: "\u98A8",
        nounRuby: [
            {
                text: "\u98A8",
                rt: "\u304B\u305C"
            }
        ],
        verbPrompt: "\u5165",
        verbRuby: [
            {
                text: "\u5165",
                rt: "\u306F\u3044"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u5165",
                rt: "\u306F\u3044"
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $23f985f27b046d81$export$2e2bcd8739ae039),
        color: "text-cyan-400",
        morphologicalEnding: "\u308B-\u3048\u308B"
    },
    {
        id: 34,
        level: 2,
        politeSentence: "\u98A8\u3092\u5165\u308C\u307E\u3059",
        politeKana: "\u304B\u305C\u3092\u3044\u308C\u307E\u3059",
        plainSentence: "\u98A8\u3092\u5165\u308C\u308B",
        plainKana: "\u304B\u305C\u3092\u3044\u308C\u308B",
        type: "Transitive",
        english: "I let the wind in",
        noun: "\u98A8",
        nounRuby: [
            {
                text: "\u98A8",
                rt: "\u304B\u305C"
            }
        ],
        verbPrompt: "\u5165",
        verbRuby: [
            {
                text: "\u5165",
                rt: "\u3044"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u5165",
                rt: "\u3044"
            },
            {
                text: "\u308C",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $23f985f27b046d81$export$2e2bcd8739ae039),
        color: "text-cyan-400",
        morphologicalEnding: "\u308B-\u3048\u308B"
    },
    {
        id: 35,
        level: 2,
        politeSentence: "\u304A\u6E6F\u304C\u6CB8\u304D\u307E\u3059",
        politeKana: "\u304A\u3086\u304C\u308F\u304D\u307E\u3059",
        plainSentence: "\u304A\u6E6F\u304C\u6CB8\u304F",
        plainKana: "\u304A\u3086\u304C\u308F\u304F",
        type: "Intransitive",
        english: "The water boils",
        noun: "\u304A\u6E6F",
        nounRuby: [
            {
                text: "\u304A",
                rt: ""
            },
            {
                text: "\u6E6F",
                rt: "\u3086"
            }
        ],
        verbPrompt: "\u6CB8",
        verbRuby: [
            {
                text: "\u6CB8",
                rt: "\u308F"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u6CB8",
                rt: "\u308F"
            },
            {
                text: "\u304F",
                rt: ""
            }
        ],
        icon: (0, $60ce6054535c0854$export$2e2bcd8739ae039),
        color: "text-orange-400",
        morphologicalEnding: "\u3046-\u3042\u3059"
    },
    {
        id: 36,
        level: 2,
        politeSentence: "\u304A\u6E6F\u3092\u6CB8\u304B\u3057\u307E\u3059",
        politeKana: "\u304A\u3086\u3092\u308F\u304B\u3057\u307E\u3059",
        plainSentence: "\u304A\u6E6F\u3092\u6CB8\u304B\u3059",
        plainKana: "\u304A\u3086\u3092\u308F\u304B\u3059",
        type: "Transitive",
        english: "I boil the water",
        noun: "\u304A\u6E6F",
        nounRuby: [
            {
                text: "\u304A",
                rt: ""
            },
            {
                text: "\u6E6F",
                rt: "\u3086"
            }
        ],
        verbPrompt: "\u6CB8",
        verbRuby: [
            {
                text: "\u6CB8",
                rt: "\u308F"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u6CB8",
                rt: "\u308F"
            },
            {
                text: "\u304B",
                rt: ""
            },
            {
                text: "\u3059",
                rt: ""
            }
        ],
        icon: (0, $60ce6054535c0854$export$2e2bcd8739ae039),
        color: "text-orange-400",
        morphologicalEnding: "\u3046-\u3042\u3059"
    },
    {
        id: 37,
        level: 2,
        politeSentence: "\u30D1\u30F3\u304C\u713C\u3051\u307E\u3059",
        politeKana: "\u30D1\u30F3\u304C\u3084\u3051\u307E\u3059",
        plainSentence: "\u30D1\u30F3\u304C\u713C\u3051\u308B",
        plainKana: "\u30D1\u30F3\u304C\u3084\u3051\u308B",
        type: "Intransitive",
        english: "The bread bakes",
        noun: "\u30D1\u30F3",
        nounRuby: [
            {
                text: "\u30D1\u30F3",
                rt: ""
            }
        ],
        verbPrompt: "\u713C",
        verbRuby: [
            {
                text: "\u713C",
                rt: "\u3084"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u713C",
                rt: "\u3084"
            },
            {
                text: "\u3051",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $118a3f0c40edc8b8$export$2e2bcd8739ae039),
        color: "text-yellow-700",
        morphologicalEnding: "\u3048\u308B-\u3046"
    },
    {
        id: 38,
        level: 2,
        politeSentence: "\u30D1\u30F3\u3092\u713C\u304D\u307E\u3059",
        politeKana: "\u30D1\u30F3\u3092\u3084\u304D\u307E\u3059",
        plainSentence: "\u30D1\u30F3\u3092\u713C\u304F",
        plainKana: "\u30D1\u30F3\u3092\u3084\u304F",
        type: "Transitive",
        english: "I bake bread",
        noun: "\u30D1\u30F3",
        nounRuby: [
            {
                text: "\u30D1\u30F3",
                rt: ""
            }
        ],
        verbPrompt: "\u713C",
        verbRuby: [
            {
                text: "\u713C",
                rt: "\u3084"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u713C",
                rt: "\u3084"
            },
            {
                text: "\u304F",
                rt: ""
            }
        ],
        icon: (0, $118a3f0c40edc8b8$export$2e2bcd8739ae039),
        color: "text-yellow-700",
        morphologicalEnding: "\u3048\u308B-\u3046"
    },
    {
        id: 39,
        level: 2,
        politeSentence: "\u8089\u304C\u716E\u3048\u307E\u3059",
        politeKana: "\u306B\u304F\u304C\u306B\u3048\u307E\u3059",
        plainSentence: "\u8089\u304C\u716E\u3048\u308B",
        plainKana: "\u306B\u304F\u304C\u306B\u3048\u308B",
        type: "Intransitive",
        english: "The meat cooks / boils",
        noun: "\u8089",
        nounRuby: [
            {
                text: "\u8089",
                rt: "\u306B\u304F"
            }
        ],
        verbPrompt: "\u716E",
        verbRuby: [
            {
                text: "\u716E",
                rt: "\u306B"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u716E",
                rt: "\u306B"
            },
            {
                text: "\u3048",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $bbd8efc75c2264c3$export$2e2bcd8739ae039),
        color: "text-red-700",
        morphologicalEnding: "\u3048\u308B-\u308B"
    },
    {
        id: 40,
        level: 2,
        politeSentence: "\u8089\u3092\u716E\u307E\u3059",
        politeKana: "\u306B\u304F\u3092\u306B\u307E\u3059",
        plainSentence: "\u8089\u3092\u716E\u308B",
        plainKana: "\u306B\u304F\u3092\u306B\u308B",
        type: "Transitive",
        english: "I cook / boil the meat",
        noun: "\u8089",
        nounRuby: [
            {
                text: "\u8089",
                rt: "\u306B\u304F"
            }
        ],
        verbPrompt: "\u716E",
        verbRuby: [
            {
                text: "\u716E",
                rt: "\u306B"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u716E",
                rt: "\u306B"
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $bbd8efc75c2264c3$export$2e2bcd8739ae039),
        color: "text-red-700",
        morphologicalEnding: "\u3048\u308B-\u308B"
    },
    // --- LEVEL 3 (IDs 41-60) ---
    {
        id: 41,
        level: 3,
        politeSentence: "\u30AB\u30E1\u30E9\u304C\u58CA\u308C\u307E\u3059",
        politeKana: "\u30AB\u30E1\u30E9\u304C\u3053\u308F\u308C\u307E\u3059",
        plainSentence: "\u30AB\u30E1\u30E9\u304C\u58CA\u308C\u308B",
        plainKana: "\u30AB\u30E1\u30E9\u304C\u3053\u308F\u308C\u308B",
        type: "Intransitive",
        english: "The camera breaks",
        noun: "\u30AB\u30E1\u30E9",
        nounRuby: [
            {
                text: "\u30AB\u30E1\u30E9",
                rt: ""
            }
        ],
        verbPrompt: "\u58CA",
        verbRuby: [
            {
                text: "\u58CA",
                rt: "\u3053\u308F"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u58CA",
                rt: "\u3053\u308F"
            },
            {
                text: "\u308C",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $7fca19d3fce363c2$export$2e2bcd8739ae039),
        color: "text-red-500",
        morphologicalEnding: "\u308C\u308B-\u3059"
    },
    {
        id: 42,
        level: 3,
        politeSentence: "\u30AB\u30E1\u30E9\u3092\u58CA\u3057\u307E\u3059",
        politeKana: "\u30AB\u30E1\u30E9\u3092\u3053\u308F\u3057\u307E\u3059",
        plainSentence: "\u30AB\u30E1\u30E9\u3092\u58CA\u3059",
        plainKana: "\u30AB\u30E1\u30E9\u3092\u3053\u308F\u3059",
        type: "Transitive",
        english: "I break the camera",
        noun: "\u30AB\u30E1\u30E9",
        nounRuby: [
            {
                text: "\u30AB\u30E1\u30E9",
                rt: ""
            }
        ],
        verbPrompt: "\u58CA",
        verbRuby: [
            {
                text: "\u58CA",
                rt: "\u3053\u308F"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u58CA",
                rt: "\u3053\u308F"
            },
            {
                text: "\u3059",
                rt: ""
            }
        ],
        icon: (0, $7fca19d3fce363c2$export$2e2bcd8739ae039),
        color: "text-orange-500",
        morphologicalEnding: "\u308C\u308B-\u3059"
    },
    {
        id: 43,
        level: 3,
        politeSentence: "\u30D1\u30BD\u30B3\u30F3\u304C\u76F4\u308A\u307E\u3059",
        politeKana: "\u30D1\u30BD\u30B3\u30F3\u304C\u306A\u304A\u308A\u307E\u3059",
        plainSentence: "\u30D1\u30BD\u30B3\u30F3\u304C\u76F4\u308B",
        plainKana: "\u30D1\u30BD\u30B3\u30F3\u304C\u306A\u304A\u308B",
        type: "Intransitive",
        english: "The PC gets fixed",
        noun: "\u30D1\u30BD\u30B3\u30F3",
        nounRuby: [
            {
                text: "\u30D1\u30BD\u30B3\u30F3",
                rt: ""
            }
        ],
        verbPrompt: "\u76F4",
        verbRuby: [
            {
                text: "\u76F4",
                rt: "\u306A\u304A"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u76F4",
                rt: "\u306A\u304A"
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $f633c0fb63f4b508$export$2e2bcd8739ae039),
        color: "text-blue-500",
        morphologicalEnding: "\u308B-\u3059"
    },
    {
        id: 44,
        level: 3,
        politeSentence: "\u30D1\u30BD\u30B3\u30F3\u3092\u76F4\u3057\u307E\u3059",
        politeKana: "\u30D1\u30BD\u30B3\u30F3\u3092\u306A\u304A\u3057\u307E\u3059",
        plainSentence: "\u30D1\u30BD\u30B3\u30F3\u3092\u76F4\u3059",
        plainKana: "\u30D1\u30BD\u30B3\u30F3\u3092\u306A\u304A\u3059",
        type: "Transitive",
        english: "I fix the PC",
        noun: "\u30D1\u30BD\u30B3\u30F3",
        nounRuby: [
            {
                text: "\u30D1\u30BD\u30B3\u30F3",
                rt: ""
            }
        ],
        verbPrompt: "\u76F4",
        verbRuby: [
            {
                text: "\u76F4",
                rt: "\u306A\u304A"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u76F4",
                rt: "\u306A\u304A"
            },
            {
                text: "\u3059",
                rt: ""
            }
        ],
        icon: (0, $f633c0fb63f4b508$export$2e2bcd8739ae039),
        color: "text-green-500",
        morphologicalEnding: "\u308B-\u3059"
    },
    {
        id: 45,
        level: 3,
        politeSentence: "\u8377\u7269\u304C\u5C4A\u304D\u307E\u3059",
        politeKana: "\u306B\u3082\u3064\u304C\u3068\u3069\u304D\u307E\u3059",
        plainSentence: "\u8377\u7269\u304C\u5C4A\u304F",
        plainKana: "\u306B\u3082\u3064\u304C\u3068\u3069\u304F",
        type: "Intransitive",
        english: "The package arrives",
        noun: "\u8377\u7269",
        nounRuby: [
            {
                text: "\u8377",
                rt: "\u306B"
            },
            {
                text: "\u7269",
                rt: "\u3082\u3064"
            }
        ],
        verbPrompt: "\u5C4A",
        verbRuby: [
            {
                text: "\u5C4A",
                rt: "\u3068\u3069"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u5C4A",
                rt: "\u3068\u3069"
            },
            {
                text: "\u304F",
                rt: ""
            }
        ],
        icon: (0, $437c67a40c1b8279$export$2e2bcd8739ae039),
        color: "text-yellow-600",
        morphologicalEnding: "\u3046-\u3048\u308B"
    },
    {
        id: 46,
        level: 3,
        politeSentence: "\u8377\u7269\u3092\u5C4A\u3051\u307E\u3059",
        politeKana: "\u306B\u3082\u3064\u3092\u3068\u3069\u3051\u307E\u3059",
        plainSentence: "\u8377\u7269\u3092\u5C4A\u3051\u308B",
        plainKana: "\u306B\u3082\u3064\u3092\u3068\u3069\u3051\u308B",
        type: "Transitive",
        english: "I deliver the package",
        noun: "\u8377\u7269",
        nounRuby: [
            {
                text: "\u8377",
                rt: "\u306B"
            },
            {
                text: "\u7269",
                rt: "\u3082\u3064"
            }
        ],
        verbPrompt: "\u5C4A",
        verbRuby: [
            {
                text: "\u5C4A",
                rt: "\u3068\u3069"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u5C4A",
                rt: "\u3068\u3069"
            },
            {
                text: "\u3051",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $437c67a40c1b8279$export$2e2bcd8739ae039),
        color: "text-green-600",
        morphologicalEnding: "\u3046-\u3048\u308B"
    },
    {
        id: 47,
        level: 3,
        politeSentence: "\u5024\u6BB5\u304C\u4E0A\u304C\u308A\u307E\u3059",
        politeKana: "\u306D\u3060\u3093\u304C\u3042\u304C\u308A\u307E\u3059",
        plainSentence: "\u5024\u6BB5\u304C\u4E0A\u304C\u308B",
        plainKana: "\u306D\u3060\u3093\u304C\u3042\u304C\u308B",
        type: "Intransitive",
        english: "The price goes up",
        noun: "\u5024\u6BB5",
        nounRuby: [
            {
                text: "\u5024",
                rt: "\u306D"
            },
            {
                text: "\u6BB5",
                rt: "\u3060\u3093"
            }
        ],
        verbPrompt: "\u4E0A",
        verbRuby: [
            {
                text: "\u4E0A",
                rt: "\u3042"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u4E0A",
                rt: "\u3042"
            },
            {
                text: "\u304C",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $8872a1d80d2463f9$export$2e2bcd8739ae039),
        color: "text-red-600",
        morphologicalEnding: "\u3042\u308B-\u3048\u308B"
    },
    {
        id: 48,
        level: 3,
        politeSentence: "\u5024\u6BB5\u3092\u4E0A\u3052\u307E\u3059",
        politeKana: "\u306D\u3060\u3093\u3092\u3042\u3052\u307E\u3059",
        plainSentence: "\u5024\u6BB5\u3092\u4E0A\u3052\u308B",
        plainKana: "\u306D\u3060\u3093\u3092\u3042\u3052\u308B",
        type: "Transitive",
        english: "I raise the price",
        noun: "\u5024\u6BB5",
        nounRuby: [
            {
                text: "\u5024",
                rt: "\u306D"
            },
            {
                text: "\u6BB5",
                rt: "\u3060\u3093"
            }
        ],
        verbPrompt: "\u4E0A",
        verbRuby: [
            {
                text: "\u4E0A",
                rt: "\u3042"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u4E0A",
                rt: "\u3042"
            },
            {
                text: "\u3052",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $8872a1d80d2463f9$export$2e2bcd8739ae039),
        color: "text-green-600",
        morphologicalEnding: "\u3042\u308B-\u3048\u308B"
    },
    {
        id: 49,
        level: 3,
        politeSentence: "\u5024\u6BB5\u304C\u4E0B\u304C\u308A\u307E\u3059",
        politeKana: "\u306D\u3060\u3093\u304C\u3055\u304C\u308A\u307E\u3059",
        plainSentence: "\u5024\u6BB5\u304C\u4E0B\u304C\u308B",
        plainKana: "\u306D\u3060\u3093\u304C\u3055\u304C\u308B",
        type: "Intransitive",
        english: "The price goes down",
        noun: "\u5024\u6BB5",
        nounRuby: [
            {
                text: "\u5024",
                rt: "\u306D"
            },
            {
                text: "\u6BB5",
                rt: "\u3060\u3093"
            }
        ],
        verbPrompt: "\u4E0B",
        verbRuby: [
            {
                text: "\u4E0B",
                rt: "\u3055"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u4E0B",
                rt: "\u3055"
            },
            {
                text: "\u304C",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $8872a1d80d2463f9$export$2e2bcd8739ae039),
        color: "text-blue-600",
        morphologicalEnding: "\u3042\u308B-\u3048\u308B"
    },
    {
        id: 50,
        level: 3,
        politeSentence: "\u5024\u6BB5\u3092\u4E0B\u3052\u307E\u3059",
        politeKana: "\u306D\u3060\u3093\u3092\u3055\u3052\u307E\u3059",
        plainSentence: "\u5024\u6BB5\u3092\u4E0B\u3052\u308B",
        plainKana: "\u306D\u3060\u3093\u3092\u3055\u3052\u308B",
        type: "Transitive",
        english: "I lower the price",
        noun: "\u5024\u6BB5",
        nounRuby: [
            {
                text: "\u5024",
                rt: "\u306D"
            },
            {
                text: "\u6BB5",
                rt: "\u3060\u3093"
            }
        ],
        verbPrompt: "\u4E0B",
        verbRuby: [
            {
                text: "\u4E0B",
                rt: "\u3055"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u4E0B",
                rt: "\u3055"
            },
            {
                text: "\u3052",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $8872a1d80d2463f9$export$2e2bcd8739ae039),
        color: "text-green-800",
        morphologicalEnding: "\u3042\u308B-\u3048\u308B"
    },
    {
        id: 51,
        level: 3,
        politeSentence: "\u4ED5\u4E8B\u304C\u5897\u3048\u307E\u3059",
        politeKana: "\u3057\u3054\u3068\u304C\u3075\u3048\u307E\u3059",
        plainSentence: "\u4ED5\u4E8B\u304C\u5897\u3048\u308B",
        plainKana: "\u3057\u3054\u3068\u304C\u3075\u3048\u308B",
        type: "Intransitive",
        english: "Work increases",
        noun: "\u4ED5\u4E8B",
        nounRuby: [
            {
                text: "\u4ED5",
                rt: "\u3057"
            },
            {
                text: "\u4E8B",
                rt: "\u3054\u3068"
            }
        ],
        verbPrompt: "\u5897",
        verbRuby: [
            {
                text: "\u5897",
                rt: "\u3075"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u5897",
                rt: "\u3075"
            },
            {
                text: "\u3048",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $34c3e517ec92034a$export$2e2bcd8739ae039),
        color: "text-purple-500",
        morphologicalEnding: "\u3048\u308B-\u3042\u3059"
    },
    {
        id: 52,
        level: 3,
        politeSentence: "\u4ED5\u4E8B\u3092\u5897\u3084\u3057\u307E\u3059",
        politeKana: "\u3057\u3054\u3068\u3092\u3075\u3084\u3057\u307E\u3059",
        plainSentence: "\u4ED5\u4E8B\u3092\u5897\u3084\u3059",
        plainKana: "\u3057\u3054\u3068\u3092\u3075\u3084\u3059",
        type: "Transitive",
        english: "I increase the work",
        noun: "\u4ED5\u4E8B",
        nounRuby: [
            {
                text: "\u4ED5",
                rt: "\u3057"
            },
            {
                text: "\u4E8B",
                rt: "\u3054\u3068"
            }
        ],
        verbPrompt: "\u5897",
        verbRuby: [
            {
                text: "\u5897",
                rt: "\u3075"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u5897",
                rt: "\u3075"
            },
            {
                text: "\u3084",
                rt: ""
            },
            {
                text: "\u3059",
                rt: ""
            }
        ],
        icon: (0, $34c3e517ec92034a$export$2e2bcd8739ae039),
        color: "text-pink-500",
        morphologicalEnding: "\u3048\u308B-\u3042\u3059"
    },
    {
        id: 53,
        level: 3,
        politeSentence: "\u4F53\u91CD\u304C\u6E1B\u308A\u307E\u3059",
        politeKana: "\u305F\u3044\u3058\u3085\u3046\u304C\u3078\u308A\u307E\u3059",
        plainSentence: "\u4F53\u91CD\u304C\u6E1B\u308B",
        plainKana: "\u305F\u3044\u3058\u3085\u3046\u304C\u3078\u308B",
        type: "Intransitive",
        english: "Weight decreases",
        noun: "\u4F53\u91CD",
        nounRuby: [
            {
                text: "\u4F53",
                rt: "\u305F\u3044"
            },
            {
                text: "\u91CD",
                rt: "\u3058\u3085\u3046"
            }
        ],
        verbPrompt: "\u6E1B",
        verbRuby: [
            {
                text: "\u6E1B",
                rt: "\u3078"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u6E1B",
                rt: "\u3078"
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $0811c1891b547863$export$2e2bcd8739ae039),
        color: "text-teal-500",
        morphologicalEnding: "\u308B-\u3089\u3059"
    },
    {
        id: 54,
        level: 3,
        politeSentence: "\u4F53\u91CD\u3092\u6E1B\u3089\u3057\u307E\u3059",
        politeKana: "\u305F\u3044\u3058\u3085\u3046\u3092\u3078\u3089\u3057\u307E\u3059",
        plainSentence: "\u4F53\u91CD\u3092\u6E1B\u3089\u3059",
        plainKana: "\u305F\u3044\u3058\u3085\u3046\u3092\u3078\u3089\u3059",
        type: "Transitive",
        english: "I reduce the weight",
        noun: "\u4F53\u91CD",
        nounRuby: [
            {
                text: "\u4F53",
                rt: "\u305F\u3044"
            },
            {
                text: "\u91CD",
                rt: "\u3058\u3085\u3046"
            }
        ],
        verbPrompt: "\u6E1B",
        verbRuby: [
            {
                text: "\u6E1B",
                rt: "\u3078"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u6E1B",
                rt: "\u3078"
            },
            {
                text: "\u3089",
                rt: ""
            },
            {
                text: "\u3059",
                rt: ""
            }
        ],
        icon: (0, $0811c1891b547863$export$2e2bcd8739ae039),
        color: "text-teal-700",
        morphologicalEnding: "\u308B-\u3089\u3059"
    },
    {
        id: 55,
        level: 3,
        politeSentence: "\u30EC\u30C3\u30B9\u30F3\u304C\u7D9A\u304D\u307E\u3059",
        politeKana: "\u30EC\u30C3\u30B9\u30F3\u304C\u3064\u3065\u304D\u307E\u3059",
        plainSentence: "\u30EC\u30C3\u30B9\u30F3\u304C\u7D9A\u304F",
        plainKana: "\u30EC\u30C3\u30B9\u30F3\u304C\u3064\u3065\u304F",
        type: "Intransitive",
        english: "The lesson continues",
        noun: "\u30EC\u30C3\u30B9\u30F3",
        nounRuby: [
            {
                text: "\u30EC\u30C3\u30B9\u30F3",
                rt: ""
            }
        ],
        verbPrompt: "\u7D9A",
        verbRuby: [
            {
                text: "\u7D9A",
                rt: "\u3064\u3065"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u7D9A",
                rt: "\u3064\u3065"
            },
            {
                text: "\u304F",
                rt: ""
            }
        ],
        icon: (0, $d456d8ec70b00bbe$export$2e2bcd8739ae039),
        color: "text-indigo-400",
        morphologicalEnding: "\u3046-\u3048\u308B"
    },
    {
        id: 56,
        level: 3,
        politeSentence: "\u30EC\u30C3\u30B9\u30F3\u3092\u7D9A\u3051\u307E\u3059",
        politeKana: "\u30EC\u30C3\u30B9\u30F3\u3092\u3064\u3065\u3051\u307E\u3059",
        plainSentence: "\u30EC\u30C3\u30B9\u30F3\u3092\u7D9A\u3051\u308B",
        plainKana: "\u30EC\u30C3\u30B9\u30F3\u3092\u3064\u3065\u3051\u308B",
        type: "Transitive",
        english: "I continue the lesson",
        noun: "\u30EC\u30C3\u30B9\u30F3",
        nounRuby: [
            {
                text: "\u30EC\u30C3\u30B9\u30F3",
                rt: ""
            }
        ],
        verbPrompt: "\u7D9A",
        verbRuby: [
            {
                text: "\u7D9A",
                rt: "\u3064\u3065"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u7D9A",
                rt: "\u3064\u3065"
            },
            {
                text: "\u3051",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $d456d8ec70b00bbe$export$2e2bcd8739ae039),
        color: "text-indigo-600",
        morphologicalEnding: "\u3046-\u3048\u308B"
    },
    {
        id: 57,
        level: 3,
        politeSentence: "\u5B50\u3069\u3082\u304C\u52A9\u304B\u308A\u307E\u3059",
        politeKana: "\u3053\u3069\u3082\u304C\u305F\u3059\u304B\u308A\u307E\u3059",
        plainSentence: "\u5B50\u3069\u3082\u304C\u52A9\u304B\u308B",
        plainKana: "\u3053\u3069\u3082\u304C\u305F\u3059\u304B\u308B",
        type: "Intransitive",
        english: "The child is saved",
        noun: "\u5B50\u3069\u3082",
        nounRuby: [
            {
                text: "\u5B50",
                rt: "\u3053"
            },
            {
                text: "\u3069\u3082",
                rt: ""
            }
        ],
        verbPrompt: "\u52A9",
        verbRuby: [
            {
                text: "\u52A9",
                rt: "\u305F\u3059"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u52A9",
                rt: "\u305F\u3059"
            },
            {
                text: "\u304B",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $dbe0cbc446f3d7c2$export$2e2bcd8739ae039),
        color: "text-pink-300",
        morphologicalEnding: "\u3042\u308B-\u3048\u308B"
    },
    {
        id: 58,
        level: 3,
        politeSentence: "\u5B50\u3069\u3082\u3092\u52A9\u3051\u307E\u3059",
        politeKana: "\u3053\u3069\u3082\u3092\u305F\u3059\u3051\u307E\u3059",
        plainSentence: "\u5B50\u3069\u3082\u3092\u52A9\u3051\u308B",
        plainKana: "\u3053\u3069\u3082\u3092\u305F\u3059\u3051\u308B",
        type: "Transitive",
        english: "I save the child",
        noun: "\u5B50\u3069\u3082",
        nounRuby: [
            {
                text: "\u5B50",
                rt: "\u3053"
            },
            {
                text: "\u3069\u3082",
                rt: ""
            }
        ],
        verbPrompt: "\u52A9",
        verbRuby: [
            {
                text: "\u52A9",
                rt: "\u305F\u3059"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u52A9",
                rt: "\u305F\u3059"
            },
            {
                text: "\u3051",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $dbe0cbc446f3d7c2$export$2e2bcd8739ae039),
        color: "text-pink-500",
        morphologicalEnding: "\u3042\u308B-\u3048\u308B"
    },
    {
        id: 59,
        level: 3,
        politeSentence: "\u30C6\u30FC\u30D6\u30EB\u304C\u56DE\u308A\u307E\u3059",
        politeKana: "\u30C6\u30FC\u30D6\u30EB\u304C\u307E\u308F\u308A\u307E\u3059",
        plainSentence: "\u30C6\u30FC\u30D6\u30EB\u304C\u56DE\u308B",
        plainKana: "\u30C6\u30FC\u30D6\u30EB\u304C\u307E\u308F\u308B",
        type: "Intransitive",
        english: "The table turns",
        noun: "\u30C6\u30FC\u30D6\u30EB",
        nounRuby: [
            {
                text: "\u30C6\u30FC\u30D6\u30EB",
                rt: ""
            }
        ],
        verbPrompt: "\u56DE",
        verbRuby: [
            {
                text: "\u56DE",
                rt: "\u307E\u308F"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u56DE",
                rt: "\u307E\u308F"
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $3b2757083c1fe006$export$2e2bcd8739ae039),
        color: "text-gray-400",
        morphologicalEnding: "\u308B-\u3059"
    },
    {
        id: 60,
        level: 3,
        politeSentence: "\u30C6\u30FC\u30D6\u30EB\u3092\u56DE\u3057\u307E\u3059",
        politeKana: "\u30C6\u30FC\u30D6\u30EB\u3092\u307E\u308F\u3057\u307E\u3059",
        plainSentence: "\u30C6\u30FC\u30D6\u30EB\u3092\u56DE\u3059",
        plainKana: "\u30C6\u30FC\u30D6\u30EB\u3092\u307E\u308F\u3059",
        type: "Transitive",
        english: "I turn the table",
        noun: "\u30C6\u30FC\u30D6\u30EB",
        nounRuby: [
            {
                text: "\u30C6\u30FC\u30D6\u30EB",
                rt: ""
            }
        ],
        verbPrompt: "\u56DE",
        verbRuby: [
            {
                text: "\u56DE",
                rt: "\u307E\u308F"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u56DE",
                rt: "\u307E\u308F"
            },
            {
                text: "\u3059",
                rt: ""
            }
        ],
        icon: (0, $3b2757083c1fe006$export$2e2bcd8739ae039),
        color: "text-gray-600",
        morphologicalEnding: "\u308B-\u3059"
    },
    // --- LEVEL 4 (IDs 61-80) ---
    {
        id: 61,
        level: 4,
        politeSentence: "\u8155\u304C\u66F2\u304C\u308A\u307E\u3059",
        politeKana: "\u3046\u3067\u304C\u307E\u304C\u308A\u307E\u3059",
        plainSentence: "\u8155\u304C\u66F2\u304C\u308B",
        plainKana: "\u3046\u3067\u304C\u307E\u304C\u308B",
        type: "Intransitive",
        english: "The arm bends",
        noun: "\u8155",
        nounRuby: [
            {
                text: "\u8155",
                rt: "\u3046\u3067"
            }
        ],
        verbPrompt: "\u66F2",
        verbRuby: [
            {
                text: "\u66F2",
                rt: "\u307E"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u66F2",
                rt: "\u307E"
            },
            {
                text: "\u304C",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $0f45c1e8ae52ad76$export$2e2bcd8739ae039),
        color: "text-orange-300",
        morphologicalEnding: "\u3042\u308B-\u3048\u308B"
    },
    {
        id: 62,
        level: 4,
        politeSentence: "\u8155\u3092\u66F2\u3052\u307E\u3059",
        politeKana: "\u3046\u3067\u3092\u307E\u3052\u307E\u3059",
        plainSentence: "\u8155\u3092\u66F2\u3052\u308B",
        plainKana: "\u3046\u3067\u3092\u307E\u3052\u308B",
        type: "Transitive",
        english: "I bend my arm",
        noun: "\u8155",
        nounRuby: [
            {
                text: "\u8155",
                rt: "\u3046\u3067"
            }
        ],
        verbPrompt: "\u66F2",
        verbRuby: [
            {
                text: "\u66F2",
                rt: "\u307E"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u66F2",
                rt: "\u307E"
            },
            {
                text: "\u3052",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $0f45c1e8ae52ad76$export$2e2bcd8739ae039),
        color: "text-orange-500",
        morphologicalEnding: "\u3042\u308B-\u3048\u308B"
    },
    {
        id: 63,
        level: 4,
        politeSentence: "\u9AA8\u304C\u6298\u308C\u307E\u3059",
        politeKana: "\u307B\u306D\u304C\u304A\u308C\u307E\u3059",
        plainSentence: "\u9AA8\u304C\u6298\u308C\u308B",
        plainKana: "\u307B\u306D\u304C\u304A\u308C\u308B",
        type: "Intransitive",
        english: "The bone breaks",
        noun: "\u9AA8",
        nounRuby: [
            {
                text: "\u9AA8",
                rt: "\u307B\u306D"
            }
        ],
        verbPrompt: "\u6298",
        verbRuby: [
            {
                text: "\u6298",
                rt: "\u304A"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u6298",
                rt: "\u304A"
            },
            {
                text: "\u308C",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $42cc10498d5d9f4b$export$2e2bcd8739ae039),
        color: "text-gray-300",
        morphologicalEnding: "\u3048\u308B-\u3046"
    },
    {
        id: 64,
        level: 4,
        politeSentence: "\u9AA8\u3092\u6298\u308A\u307E\u3059",
        politeKana: "\u307B\u306D\u3092\u304A\u308A\u307E\u3059",
        plainSentence: "\u9AA8\u3092\u6298\u308B",
        plainKana: "\u307B\u306D\u3092\u304A\u308B",
        type: "Transitive",
        english: "I break a bone",
        noun: "\u9AA8",
        nounRuby: [
            {
                text: "\u9AA8",
                rt: "\u307B\u306D"
            }
        ],
        verbPrompt: "\u6298",
        verbRuby: [
            {
                text: "\u6298",
                rt: "\u304A"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u6298",
                rt: "\u304A"
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $42cc10498d5d9f4b$export$2e2bcd8739ae039),
        color: "text-gray-500",
        morphologicalEnding: "\u3048\u308B-\u3046"
    },
    {
        id: 65,
        level: 4,
        politeSentence: "\u4EBA\u304C\u96C6\u307E\u308A\u307E\u3059",
        politeKana: "\u3072\u3068\u304C\u3042\u3064\u307E\u308A\u307E\u3059",
        plainSentence: "\u4EBA\u304C\u96C6\u307E\u308B",
        plainKana: "\u3072\u3068\u304C\u3042\u3064\u307E\u308B",
        type: "Intransitive",
        english: "People gather",
        noun: "\u4EBA",
        nounRuby: [
            {
                text: "\u4EBA",
                rt: "\u3072\u3068"
            }
        ],
        verbPrompt: "\u96C6",
        verbRuby: [
            {
                text: "\u96C6",
                rt: "\u3042\u3064"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u96C6",
                rt: "\u3042\u3064"
            },
            {
                text: "\u307E",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $c38b5b11d1e2b813$export$2e2bcd8739ae039),
        color: "text-blue-400",
        morphologicalEnding: "\u3042\u308B-\u3048\u308B"
    },
    {
        id: 66,
        level: 4,
        politeSentence: "\u4EBA\u3092\u96C6\u3081\u307E\u3059",
        politeKana: "\u3072\u3068\u3092\u3042\u3064\u3081\u307E\u3059",
        plainSentence: "\u4EBA\u3092\u96C6\u3081\u308B",
        plainKana: "\u3072\u3068\u3092\u3042\u3064\u3081\u308B",
        type: "Transitive",
        english: "I gather people",
        noun: "\u4EBA",
        nounRuby: [
            {
                text: "\u4EBA",
                rt: "\u3072\u3068"
            }
        ],
        verbPrompt: "\u96C6",
        verbRuby: [
            {
                text: "\u96C6",
                rt: "\u3042\u3064"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u96C6",
                rt: "\u3042\u3064"
            },
            {
                text: "\u3081",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $c38b5b11d1e2b813$export$2e2bcd8739ae039),
        color: "text-green-400",
        morphologicalEnding: "\u3042\u308B-\u3048\u308B"
    },
    {
        id: 67,
        level: 4,
        politeSentence: "\u4EBA\u304C\u4E26\u3073\u307E\u3059",
        politeKana: "\u3072\u3068\u304C\u306A\u3089\u3073\u307E\u3059",
        plainSentence: "\u4EBA\u304C\u4E26\u3076",
        plainKana: "\u3072\u3068\u304C\u306A\u3089\u3076",
        type: "Intransitive",
        english: "People line up",
        noun: "\u4EBA",
        nounRuby: [
            {
                text: "\u4EBA",
                rt: "\u3072\u3068"
            }
        ],
        verbPrompt: "\u4E26",
        verbRuby: [
            {
                text: "\u4E26",
                rt: "\u306A\u3089"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u4E26",
                rt: "\u306A\u3089"
            },
            {
                text: "\u3076",
                rt: ""
            }
        ],
        icon: (0, $c38b5b11d1e2b813$export$2e2bcd8739ae039),
        color: "text-indigo-400",
        morphologicalEnding: "\u3046-\u3048\u308B"
    },
    {
        id: 68,
        level: 4,
        politeSentence: "\u4EBA\u3092\u4E26\u3079\u307E\u3059",
        politeKana: "\u3072\u3068\u3092\u306A\u3089\u3079\u307E\u3059",
        plainSentence: "\u4EBA\u3092\u4E26\u3079\u308B",
        plainKana: "\u3072\u3068\u3092\u306A\u3089\u3079\u308B",
        type: "Transitive",
        english: "I line people up",
        noun: "\u4EBA",
        nounRuby: [
            {
                text: "\u4EBA",
                rt: "\u3072\u3068"
            }
        ],
        verbPrompt: "\u4E26",
        verbRuby: [
            {
                text: "\u4E26",
                rt: "\u306A\u3089"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u4E26",
                rt: "\u306A\u3089"
            },
            {
                text: "\u3079",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $c38b5b11d1e2b813$export$2e2bcd8739ae039),
        color: "text-indigo-600",
        morphologicalEnding: "\u3046-\u3048\u308B"
    },
    {
        id: 69,
        level: 4,
        politeSentence: "\u30B3\u30FC\u30D2\u30FC\u304C\u3053\u307C\u308C\u307E\u3059",
        politeKana: "\u30B3\u30FC\u30D2\u30FC\u304C\u3053\u307C\u308C\u307E\u3059",
        plainSentence: "\u30B3\u30FC\u30D2\u30FC\u304C\u3053\u307C\u308C\u308B",
        plainKana: "\u30B3\u30FC\u30D2\u30FC\u304C\u3053\u307C\u308C\u308B",
        type: "Intransitive",
        english: "The coffee spills",
        noun: "\u30B3\u30FC\u30D2\u30FC",
        nounRuby: [
            {
                text: "\u30B3\u30FC\u30D2\u30FC",
                rt: ""
            }
        ],
        verbPrompt: "\u3053\u307C",
        verbRuby: [
            {
                text: "\u3053\u307C",
                rt: ""
            }
        ],
        dictionaryRuby: [
            {
                text: "\u3053\u307C",
                rt: ""
            },
            {
                text: "\u308C",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $6826835d9d90fe9d$export$2e2bcd8739ae039),
        color: "text-amber-700",
        morphologicalEnding: "\u308C\u308B-\u3059"
    },
    {
        id: 70,
        level: 4,
        politeSentence: "\u30B3\u30FC\u30D2\u30FC\u3092\u3053\u307C\u3057\u307E\u3059",
        politeKana: "\u30B3\u30FC\u30D2\u30FC\u3092\u3053\u307C\u3057\u307E\u3059",
        plainSentence: "\u30B3\u30FC\u30D2\u30FC\u3092\u3053\u307C\u3059",
        plainKana: "\u30B3\u30FC\u30D2\u30FC\u3092\u3053\u307C\u3059",
        type: "Transitive",
        english: "I spill the coffee",
        noun: "\u30B3\u30FC\u30D2\u30FC",
        nounRuby: [
            {
                text: "\u30B3\u30FC\u30D2\u30FC",
                rt: ""
            }
        ],
        verbPrompt: "\u3053\u307C",
        verbRuby: [
            {
                text: "\u3053\u307C",
                rt: ""
            }
        ],
        dictionaryRuby: [
            {
                text: "\u3053\u307C",
                rt: ""
            },
            {
                text: "\u3059",
                rt: ""
            }
        ],
        icon: (0, $6826835d9d90fe9d$export$2e2bcd8739ae039),
        color: "text-amber-900",
        morphologicalEnding: "\u308C\u308B-\u3059"
    },
    {
        id: 71,
        level: 4,
        politeSentence: "\u5375\u304C\u5272\u308C\u307E\u3059",
        politeKana: "\u305F\u307E\u3054\u304C\u308F\u308C\u307E\u3059",
        plainSentence: "\u5375\u304C\u5272\u308C\u308B",
        plainKana: "\u305F\u307E\u3054\u304C\u308F\u308C\u308B",
        type: "Intransitive",
        english: "The egg breaks",
        noun: "\u5375",
        nounRuby: [
            {
                text: "\u5375",
                rt: "\u305F\u307E\u3054"
            }
        ],
        verbPrompt: "\u5272",
        verbRuby: [
            {
                text: "\u5272",
                rt: "\u308F"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u5272",
                rt: "\u308F"
            },
            {
                text: "\u308C",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $9f84efd0d553789a$export$2e2bcd8739ae039),
        color: "text-yellow-200",
        morphologicalEnding: "\u3048\u308B-\u3046"
    },
    {
        id: 72,
        level: 4,
        politeSentence: "\u5375\u3092\u5272\u308A\u307E\u3059",
        politeKana: "\u305F\u307E\u3054\u3092\u308F\u308A\u307E\u3059",
        plainSentence: "\u5375\u3092\u5272\u308B",
        plainKana: "\u305F\u307E\u3054\u3092\u308F\u308B",
        type: "Transitive",
        english: "I break the egg",
        noun: "\u5375",
        nounRuby: [
            {
                text: "\u5375",
                rt: "\u305F\u307E\u3054"
            }
        ],
        verbPrompt: "\u5272",
        verbRuby: [
            {
                text: "\u5272",
                rt: "\u308F"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u5272",
                rt: "\u308F"
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $9f84efd0d553789a$export$2e2bcd8739ae039),
        color: "text-yellow-400",
        morphologicalEnding: "\u3048\u308B-\u3046"
    },
    {
        id: 73,
        level: 4,
        politeSentence: "\u30ED\u30FC\u30D7\u304C\u5207\u308C\u307E\u3059",
        politeKana: "\u30ED\u30FC\u30D7\u304C\u304D\u308C\u307E\u3059",
        plainSentence: "\u30ED\u30FC\u30D7\u304C\u5207\u308C\u308B",
        plainKana: "\u30ED\u30FC\u30D7\u304C\u304D\u308C\u308B",
        type: "Intransitive",
        english: "The rope snaps",
        noun: "\u30ED\u30FC\u30D7",
        nounRuby: [
            {
                text: "\u30ED\u30FC\u30D7",
                rt: ""
            }
        ],
        verbPrompt: "\u5207",
        verbRuby: [
            {
                text: "\u5207",
                rt: "\u304D"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u5207",
                rt: "\u304D"
            },
            {
                text: "\u308C",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $2c4b775586278895$export$2e2bcd8739ae039),
        color: "text-red-400",
        morphologicalEnding: "\u3048\u308B-\u3046"
    },
    {
        id: 74,
        level: 4,
        politeSentence: "\u30ED\u30FC\u30D7\u3092\u5207\u308A\u307E\u3059",
        politeKana: "\u30ED\u30FC\u30D7\u3092\u304D\u308A\u307E\u3059",
        plainSentence: "\u30ED\u30FC\u30D7\u3092\u5207\u308B",
        plainKana: "\u30ED\u30FC\u30D7\u3092\u304D\u308B",
        type: "Transitive",
        english: "I cut the rope",
        noun: "\u30ED\u30FC\u30D7",
        nounRuby: [
            {
                text: "\u30ED\u30FC\u30D7",
                rt: ""
            }
        ],
        verbPrompt: "\u5207",
        verbRuby: [
            {
                text: "\u5207",
                rt: "\u304D"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u5207",
                rt: "\u304D"
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $2c4b775586278895$export$2e2bcd8739ae039),
        color: "text-red-600",
        morphologicalEnding: "\u3048\u308B-\u3046"
    },
    {
        id: 75,
        level: 4,
        politeSentence: "\u3054\u307F\u304C\u71C3\u3048\u307E\u3059",
        politeKana: "\u3054\u307F\u304C\u3082\u3048\u307E\u3059",
        plainSentence: "\u3054\u307F\u304C\u71C3\u3048\u308B",
        plainKana: "\u3054\u307F\u304C\u3082\u3048\u308B",
        type: "Intransitive",
        english: "The trash burns",
        noun: "\u3054\u307F",
        nounRuby: [
            {
                text: "\u3054\u307F",
                rt: ""
            }
        ],
        verbPrompt: "\u71C3",
        verbRuby: [
            {
                text: "\u71C3",
                rt: "\u3082"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u71C3",
                rt: "\u3082"
            },
            {
                text: "\u3048",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $1d55a58c47e43a5b$export$2e2bcd8739ae039),
        color: "text-orange-500",
        morphologicalEnding: "\u3048\u308B-\u3042\u3059"
    },
    {
        id: 76,
        level: 4,
        politeSentence: "\u3054\u307F\u3092\u71C3\u3084\u3057\u307E\u3059",
        politeKana: "\u3054\u307F\u3092\u3082\u3084\u3057\u307E\u3059",
        plainSentence: "\u3054\u307F\u3092\u71C3\u3084\u3059",
        plainKana: "\u3054\u307F\u3092\u3082\u3084\u3059",
        type: "Transitive",
        english: "I burn the trash",
        noun: "\u3054\u307F",
        nounRuby: [
            {
                text: "\u3054\u307F",
                rt: ""
            }
        ],
        verbPrompt: "\u71C3",
        verbRuby: [
            {
                text: "\u71C3",
                rt: "\u3082"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u71C3",
                rt: "\u3082"
            },
            {
                text: "\u3084",
                rt: ""
            },
            {
                text: "\u3059",
                rt: ""
            }
        ],
        icon: (0, $1d55a58c47e43a5b$export$2e2bcd8739ae039),
        color: "text-orange-700",
        morphologicalEnding: "\u3048\u308B-\u3042\u3059"
    },
    {
        id: 77,
        level: 4,
        politeSentence: "\u30DC\u30BF\u30F3\u304C\u53D6\u308C\u307E\u3059",
        politeKana: "\u30DC\u30BF\u30F3\u304C\u3068\u308C\u307E\u3059",
        plainSentence: "\u30DC\u30BF\u30F3\u304C\u53D6\u308C\u308B",
        plainKana: "\u30DC\u30BF\u30F3\u304C\u3068\u308C\u308B",
        type: "Intransitive",
        english: "The button comes off",
        noun: "\u30DC\u30BF\u30F3",
        nounRuby: [
            {
                text: "\u30DC\u30BF\u30F3",
                rt: ""
            }
        ],
        verbPrompt: "\u53D6",
        verbRuby: [
            {
                text: "\u53D6",
                rt: "\u3068"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u53D6",
                rt: "\u3068"
            },
            {
                text: "\u308C",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $8a5d1dc6449205ac$export$2e2bcd8739ae039),
        color: "text-purple-400",
        morphologicalEnding: "\u3048\u308B-\u3046"
    },
    {
        id: 78,
        level: 4,
        politeSentence: "\u30DC\u30BF\u30F3\u3092\u53D6\u308A\u307E\u3059",
        politeKana: "\u30DC\u30BF\u30F3\u3092\u3068\u308A\u307E\u3059",
        plainSentence: "\u30DC\u30BF\u30F3\u3092\u53D6\u308B",
        plainKana: "\u30DC\u30BF\u30F3\u3092\u3068\u308B",
        type: "Transitive",
        english: "I take the button",
        noun: "\u30DC\u30BF\u30F3",
        nounRuby: [
            {
                text: "\u30DC\u30BF\u30F3",
                rt: ""
            }
        ],
        verbPrompt: "\u53D6",
        verbRuby: [
            {
                text: "\u53D6",
                rt: "\u3068"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u53D6",
                rt: "\u3068"
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $8a5d1dc6449205ac$export$2e2bcd8739ae039),
        color: "text-purple-600",
        morphologicalEnding: "\u3048\u308B-\u3046"
    },
    {
        id: 79,
        level: 4,
        politeSentence: "\u30DC\u30BF\u30F3\u304C\u5916\u308C\u307E\u3059",
        politeKana: "\u30DC\u30BF\u30F3\u304C\u306F\u305A\u308C\u307E\u3059",
        plainSentence: "\u30DC\u30BF\u30F3\u304C\u5916\u308C\u308B",
        plainKana: "\u30DC\u30BF\u30F3\u304C\u306F\u305A\u308C\u308B",
        type: "Intransitive",
        english: "The button gets undone",
        noun: "\u30DC\u30BF\u30F3",
        nounRuby: [
            {
                text: "\u30DC\u30BF\u30F3",
                rt: ""
            }
        ],
        verbPrompt: "\u5916",
        verbRuby: [
            {
                text: "\u5916",
                rt: "\u306F\u305A"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u5916",
                rt: "\u306F\u305A"
            },
            {
                text: "\u308C",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $8a5d1dc6449205ac$export$2e2bcd8739ae039),
        color: "text-blue-400",
        morphologicalEnding: "\u308C\u308B-\u3059"
    },
    {
        id: 80,
        level: 4,
        politeSentence: "\u30DC\u30BF\u30F3\u3092\u5916\u3057\u307E\u3059",
        politeKana: "\u30DC\u30BF\u30F3\u3092\u306F\u305A\u3057\u307E\u3059",
        plainSentence: "\u30DC\u30BF\u30F3\u3092\u5916\u3059",
        plainKana: "\u30DC\u30BF\u30F3\u3092\u306F\u305A\u3059",
        type: "Transitive",
        english: "I undo the button",
        noun: "\u30DC\u30BF\u30F3",
        nounRuby: [
            {
                text: "\u30DC\u30BF\u30F3",
                rt: ""
            }
        ],
        verbPrompt: "\u5916",
        verbRuby: [
            {
                text: "\u5916",
                rt: "\u306F\u305A"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u5916",
                rt: "\u306F\u305A"
            },
            {
                text: "\u3059",
                rt: ""
            }
        ],
        icon: (0, $8a5d1dc6449205ac$export$2e2bcd8739ae039),
        color: "text-blue-600",
        morphologicalEnding: "\u308C\u308B-\u3059"
    },
    // --- LEVEL 5 (IDs 81-100) ---
    {
        id: 81,
        level: 5,
        politeSentence: "\u30D3\u30FC\u30EB\u304C\u58F2\u308C\u307E\u3059",
        politeKana: "\u30D3\u30FC\u30EB\u304C\u3046\u308C\u307E\u3059",
        plainSentence: "\u30D3\u30FC\u30EB\u304C\u58F2\u308C\u308B",
        plainKana: "\u30D3\u30FC\u30EB\u304C\u3046\u308C\u308B",
        type: "Intransitive",
        english: "The beer sells (well)",
        noun: "\u30D3\u30FC\u30EB",
        nounRuby: [
            {
                text: "\u30D3\u30FC\u30EB",
                rt: ""
            }
        ],
        verbPrompt: "\u58F2",
        verbRuby: [
            {
                text: "\u58F2",
                rt: "\u3046"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u58F2",
                rt: "\u3046"
            },
            {
                text: "\u308C",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $399d1cc6b64aaf4c$export$2e2bcd8739ae039),
        color: "text-yellow-500",
        morphologicalEnding: "\u3048\u308B-\u3046"
    },
    {
        id: 82,
        level: 5,
        politeSentence: "\u30D3\u30FC\u30EB\u3092\u58F2\u308A\u307E\u3059",
        politeKana: "\u30D3\u30FC\u30EB\u3092\u3046\u308A\u307E\u3059",
        plainSentence: "\u30D3\u30FC\u30EB\u3092\u58F2\u308B",
        plainKana: "\u30D3\u30FC\u30EB\u3092\u3046\u308B",
        type: "Transitive",
        english: "I sell beer",
        noun: "\u30D3\u30FC\u30EB",
        nounRuby: [
            {
                text: "\u30D3\u30FC\u30EB",
                rt: ""
            }
        ],
        verbPrompt: "\u58F2",
        verbRuby: [
            {
                text: "\u58F2",
                rt: "\u3046"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u58F2",
                rt: "\u3046"
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $399d1cc6b64aaf4c$export$2e2bcd8739ae039),
        color: "text-yellow-700",
        morphologicalEnding: "\u3048\u308B-\u3046"
    },
    {
        id: 83,
        level: 5,
        politeSentence: "\u66F8\u985E\u304C\u63C3\u3044\u307E\u3059",
        politeKana: "\u3057\u3087\u308B\u3044\u304C\u305D\u308D\u3044\u307E\u3059",
        plainSentence: "\u66F8\u985E\u304C\u63C3\u3046",
        plainKana: "\u3057\u3087\u308B\u3044\u304C\u305D\u308D\u3046",
        type: "Intransitive",
        english: "The documents are gathered",
        noun: "\u66F8\u985E",
        nounRuby: [
            {
                text: "\u66F8",
                rt: "\u3057\u3087"
            },
            {
                text: "\u985E",
                rt: "\u308B\u3044"
            }
        ],
        verbPrompt: "\u63C3",
        verbRuby: [
            {
                text: "\u63C3",
                rt: "\u305D\u308D"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u63C3",
                rt: "\u305D\u308D"
            },
            {
                text: "\u3046",
                rt: ""
            }
        ],
        icon: (0, $ed5cb62e5e60963e$export$2e2bcd8739ae039),
        color: "text-gray-400",
        morphologicalEnding: "\u3046-\u3048\u308B"
    },
    {
        id: 84,
        level: 5,
        politeSentence: "\u66F8\u985E\u3092\u63C3\u3048\u307E\u3059",
        politeKana: "\u3057\u3087\u308B\u3044\u3092\u305D\u308D\u3048\u307E\u3059",
        plainSentence: "\u66F8\u985E\u3092\u63C3\u3048\u308B",
        plainKana: "\u3057\u3087\u308B\u3044\u3092\u305D\u308D\u3048\u308B",
        type: "Transitive",
        english: "I gather/arrange the documents",
        noun: "\u66F8\u985E",
        nounRuby: [
            {
                text: "\u66F8",
                rt: "\u3057\u3087"
            },
            {
                text: "\u985E",
                rt: "\u308B\u3044"
            }
        ],
        verbPrompt: "\u63C3",
        verbRuby: [
            {
                text: "\u63C3",
                rt: "\u305D\u308D"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u63C3",
                rt: "\u305D\u308D"
            },
            {
                text: "\u3048",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $ed5cb62e5e60963e$export$2e2bcd8739ae039),
        color: "text-gray-600",
        morphologicalEnding: "\u3046-\u3048\u308B"
    },
    {
        id: 85,
        level: 5,
        politeSentence: "\u4ED5\u4E8B\u304C\u9032\u307F\u307E\u3059",
        politeKana: "\u3057\u3054\u3068\u304C\u3059\u3059\u307F\u307E\u3059",
        plainSentence: "\u4ED5\u4E8B\u304C\u9032\u3080",
        plainKana: "\u3057\u3054\u3068\u304C\u3059\u3059\u3080",
        type: "Intransitive",
        english: "The work progresses",
        noun: "\u4ED5\u4E8B",
        nounRuby: [
            {
                text: "\u4ED5",
                rt: "\u3057"
            },
            {
                text: "\u4E8B",
                rt: "\u3054\u3068"
            }
        ],
        verbPrompt: "\u9032",
        verbRuby: [
            {
                text: "\u9032",
                rt: "\u3059\u3059"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u9032",
                rt: "\u3059\u3059"
            },
            {
                text: "\u3080",
                rt: ""
            }
        ],
        icon: (0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039),
        color: "text-blue-400",
        morphologicalEnding: "\u3046-\u3048\u308B"
    },
    {
        id: 86,
        level: 5,
        politeSentence: "\u4ED5\u4E8B\u3092\u9032\u3081\u307E\u3059",
        politeKana: "\u3057\u3054\u3068\u3092\u3059\u3059\u3081\u307E\u3059",
        plainSentence: "\u4ED5\u4E8B\u3092\u9032\u3081\u308B",
        plainKana: "\u3057\u3054\u3068\u3092\u3059\u3059\u3081\u308B",
        type: "Transitive",
        english: "I advance the work",
        noun: "\u4ED5\u4E8B",
        nounRuby: [
            {
                text: "\u4ED5",
                rt: "\u3057"
            },
            {
                text: "\u4E8B",
                rt: "\u3054\u3068"
            }
        ],
        verbPrompt: "\u9032",
        verbRuby: [
            {
                text: "\u9032",
                rt: "\u3059\u3059"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u9032",
                rt: "\u3059\u3059"
            },
            {
                text: "\u3081",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $f9e50e5a44fb11e0$export$2e2bcd8739ae039),
        color: "text-green-400",
        morphologicalEnding: "\u3046-\u3048\u308B"
    },
    {
        id: 87,
        level: 5,
        politeSentence: "\u4ED5\u4E8B\u304C\u6E08\u307F\u307E\u3059",
        politeKana: "\u3057\u3054\u3068\u304C\u3059\u307F\u307E\u3059",
        plainSentence: "\u4ED5\u4E8B\u304C\u6E08\u3080",
        plainKana: "\u3057\u3054\u3068\u304C\u3059\u3080",
        type: "Intransitive",
        english: "The work is finished",
        noun: "\u4ED5\u4E8B",
        nounRuby: [
            {
                text: "\u4ED5",
                rt: "\u3057"
            },
            {
                text: "\u4E8B",
                rt: "\u3054\u3068"
            }
        ],
        verbPrompt: "\u6E08",
        verbRuby: [
            {
                text: "\u6E08",
                rt: "\u3059"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u6E08",
                rt: "\u3059"
            },
            {
                text: "\u3080",
                rt: ""
            }
        ],
        icon: (0, $176d6e46e6973fb2$export$2e2bcd8739ae039),
        color: "text-green-500",
        morphologicalEnding: "\u3046-\u3042\u305B\u308B"
    },
    {
        id: 88,
        level: 5,
        politeSentence: "\u4ED5\u4E8B\u3092\u6E08\u307E\u305B\u307E\u3059",
        politeKana: "\u3057\u3054\u3068\u3092\u3059\u307E\u305B\u307E\u3059",
        plainSentence: "\u4ED5\u4E8B\u3092\u6E08\u307E\u305B\u308B",
        plainKana: "\u3057\u3054\u3068\u3092\u3059\u307E\u305B\u308B",
        type: "Transitive",
        english: "I finish the work",
        noun: "\u4ED5\u4E8B",
        nounRuby: [
            {
                text: "\u4ED5",
                rt: "\u3057"
            },
            {
                text: "\u4E8B",
                rt: "\u3054\u3068"
            }
        ],
        verbPrompt: "\u6E08",
        verbRuby: [
            {
                text: "\u6E08",
                rt: "\u3059"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u6E08",
                rt: "\u3059"
            },
            {
                text: "\u307E",
                rt: ""
            },
            {
                text: "\u305B",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $176d6e46e6973fb2$export$2e2bcd8739ae039),
        color: "text-green-700",
        morphologicalEnding: "\u3046-\u3042\u305B\u308B"
    },
    {
        id: 89,
        level: 5,
        politeSentence: "\u6642\u9593\u304C\u904E\u304E\u307E\u3059",
        politeKana: "\u3058\u304B\u3093\u304C\u3059\u304E\u307E\u3059",
        plainSentence: "\u6642\u9593\u304C\u904E\u304E\u308B",
        plainKana: "\u3058\u304B\u3093\u304C\u3059\u304E\u308B",
        type: "Intransitive",
        english: "Time passes",
        noun: "\u6642\u9593",
        nounRuby: [
            {
                text: "\u6642",
                rt: "\u3058"
            },
            {
                text: "\u9593",
                rt: "\u304B\u3093"
            }
        ],
        verbPrompt: "\u904E",
        verbRuby: [
            {
                text: "\u904E",
                rt: "\u3059"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u904E",
                rt: "\u3059"
            },
            {
                text: "\u304E",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $200392fae49ddb7e$export$2e2bcd8739ae039),
        color: "text-purple-400",
        morphologicalEnding: "\u3044\u308B-\u304A\u3059"
    },
    {
        id: 90,
        level: 5,
        politeSentence: "\u6642\u9593\u3092\u904E\u3054\u3057\u307E\u3059",
        politeKana: "\u3058\u304B\u3093\u3092\u3059\u3054\u3057\u307E\u3059",
        plainSentence: "\u6642\u9593\u3092\u904E\u3054\u3059",
        plainKana: "\u3058\u304B\u3093\u3092\u3059\u3054\u3059",
        type: "Transitive",
        english: "I spend time",
        noun: "\u6642\u9593",
        nounRuby: [
            {
                text: "\u6642",
                rt: "\u3058"
            },
            {
                text: "\u9593",
                rt: "\u304B\u3093"
            }
        ],
        verbPrompt: "\u904E",
        verbRuby: [
            {
                text: "\u904E",
                rt: "\u3059"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u904E",
                rt: "\u3059"
            },
            {
                text: "\u3054",
                rt: ""
            },
            {
                text: "\u3059",
                rt: ""
            }
        ],
        icon: (0, $200392fae49ddb7e$export$2e2bcd8739ae039),
        color: "text-purple-600",
        morphologicalEnding: "\u3044\u308B-\u304A\u3059"
    },
    {
        id: 91,
        level: 5,
        politeSentence: "\u30B9\u30C8\u30EC\u30B9\u304C\u6E9C\u307E\u308A\u307E\u3059",
        politeKana: "\u30B9\u30C8\u30EC\u30B9\u304C\u305F\u307E\u308A\u307E\u3059",
        plainSentence: "\u30B9\u30C8\u30EC\u30B9\u304C\u6E9C\u307E\u308B",
        plainKana: "\u30B9\u30C8\u30EC\u30B9\u304C\u305F\u307E\u308B",
        type: "Intransitive",
        english: "Stress accumulates",
        noun: "\u30B9\u30C8\u30EC\u30B9",
        nounRuby: [
            {
                text: "\u30B9\u30C8\u30EC\u30B9",
                rt: ""
            }
        ],
        verbPrompt: "\u6E9C",
        verbRuby: [
            {
                text: "\u6E9C",
                rt: "\u305F"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u6E9C",
                rt: "\u305F"
            },
            {
                text: "\u307E",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $b5e412fe3136fb7c$export$2e2bcd8739ae039),
        color: "text-red-400",
        morphologicalEnding: "\u3042\u308B-\u3048\u308B"
    },
    {
        id: 92,
        level: 5,
        politeSentence: "\u30B9\u30C8\u30EC\u30B9\u3092\u6E9C\u3081\u307E\u3059",
        politeKana: "\u30B9\u30C8\u30EC\u30B9\u3092\u305F\u3081\u307E\u3059",
        plainSentence: "\u30B9\u30C8\u30EC\u30B9\u3092\u6E9C\u3081\u308B",
        plainKana: "\u30B9\u30C8\u30EC\u30B9\u3092\u305F\u3081\u308B",
        type: "Transitive",
        english: "I build up stress",
        noun: "\u30B9\u30C8\u30EC\u30B9",
        nounRuby: [
            {
                text: "\u30B9\u30C8\u30EC\u30B9",
                rt: ""
            }
        ],
        verbPrompt: "\u6E9C",
        verbRuby: [
            {
                text: "\u6E9C",
                rt: "\u305F"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u6E9C",
                rt: "\u305F"
            },
            {
                text: "\u3081",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $b5e412fe3136fb7c$export$2e2bcd8739ae039),
        color: "text-red-600",
        morphologicalEnding: "\u3042\u308B-\u3048\u308B"
    },
    {
        id: 93,
        level: 5,
        politeSentence: "\u304A\u91D1\u304C\u8CAF\u307E\u308A\u307E\u3059",
        politeKana: "\u304A\u304B\u306D\u304C\u305F\u307E\u308A\u307E\u3059",
        plainSentence: "\u304A\u91D1\u304C\u8CAF\u307E\u308B",
        plainKana: "\u304A\u304B\u306D\u304C\u305F\u307E\u308B",
        type: "Intransitive",
        english: "Money is saved",
        noun: "\u304A\u91D1",
        nounRuby: [
            {
                text: "\u304A",
                rt: ""
            },
            {
                text: "\u91D1",
                rt: "\u304B\u306D"
            }
        ],
        verbPrompt: "\u8CAF",
        verbRuby: [
            {
                text: "\u8CAF",
                rt: "\u305F"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u8CAF",
                rt: "\u305F"
            },
            {
                text: "\u307E",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $9ec88f95add56de8$export$2e2bcd8739ae039),
        color: "text-yellow-400",
        morphologicalEnding: "\u3042\u308B-\u3048\u308B"
    },
    {
        id: 94,
        level: 5,
        politeSentence: "\u304A\u91D1\u3092\u8CAF\u3081\u307E\u3059",
        politeKana: "\u304A\u304B\u306D\u3092\u305F\u3081\u307E\u3059",
        plainSentence: "\u304A\u91D1\u3092\u8CAF\u3081\u308B",
        plainKana: "\u304A\u304B\u306D\u3092\u305F\u3081\u308B",
        type: "Transitive",
        english: "I save money",
        noun: "\u304A\u91D1",
        nounRuby: [
            {
                text: "\u304A",
                rt: ""
            },
            {
                text: "\u91D1",
                rt: "\u304B\u306D"
            }
        ],
        verbPrompt: "\u8CAF",
        verbRuby: [
            {
                text: "\u8CAF",
                rt: "\u305F"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u8CAF",
                rt: "\u305F"
            },
            {
                text: "\u3081",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $9ec88f95add56de8$export$2e2bcd8739ae039),
        color: "text-yellow-600",
        morphologicalEnding: "\u3042\u308B-\u3048\u308B"
    },
    {
        id: 95,
        level: 5,
        politeSentence: "\u6C34\u304C\u6D41\u308C\u307E\u3059",
        politeKana: "\u307F\u305A\u304C\u306A\u304C\u308C\u307E\u3059",
        plainSentence: "\u6C34\u304C\u6D41\u308C\u308B",
        plainKana: "\u307F\u305A\u304C\u306A\u304C\u308C\u308B",
        type: "Intransitive",
        english: "Water flows",
        noun: "\u6C34",
        nounRuby: [
            {
                text: "\u6C34",
                rt: "\u307F\u305A"
            }
        ],
        verbPrompt: "\u6D41",
        verbRuby: [
            {
                text: "\u6D41",
                rt: "\u306A\u304C"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u6D41",
                rt: "\u306A\u304C"
            },
            {
                text: "\u308C",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $228a858c8f4b4bf0$export$2e2bcd8739ae039),
        color: "text-blue-300",
        morphologicalEnding: "\u308C\u308B-\u3059"
    },
    {
        id: 96,
        level: 5,
        politeSentence: "\u6C34\u3092\u6D41\u3057\u307E\u3059",
        politeKana: "\u307F\u305A\u3092\u306A\u304C\u3057\u307E\u3059",
        plainSentence: "\u6C34\u3092\u6D41\u3059",
        plainKana: "\u307F\u305A\u3092\u306A\u304C\u3059",
        type: "Transitive",
        english: "I let the water flow",
        noun: "\u6C34",
        nounRuby: [
            {
                text: "\u6C34",
                rt: "\u307F\u305A"
            }
        ],
        verbPrompt: "\u6D41",
        verbRuby: [
            {
                text: "\u6D41",
                rt: "\u306A\u304C"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u6D41",
                rt: "\u306A\u304C"
            },
            {
                text: "\u3059",
                rt: ""
            }
        ],
        icon: (0, $228a858c8f4b4bf0$export$2e2bcd8739ae039),
        color: "text-blue-500",
        morphologicalEnding: "\u308C\u308B-\u3059"
    },
    {
        id: 97,
        level: 5,
        politeSentence: "\u6728\u304C\u5012\u308C\u307E\u3059",
        politeKana: "\u304D\u304C\u305F\u304A\u308C\u307E\u3059",
        plainSentence: "\u6728\u304C\u5012\u308C\u308B",
        plainKana: "\u304D\u304C\u305F\u304A\u308C\u308B",
        type: "Intransitive",
        english: "The tree falls down",
        noun: "\u6728",
        nounRuby: [
            {
                text: "\u6728",
                rt: "\u304D"
            }
        ],
        verbPrompt: "\u5012",
        verbRuby: [
            {
                text: "\u5012",
                rt: "\u305F\u304A"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u5012",
                rt: "\u305F\u304A"
            },
            {
                text: "\u308C",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $fab2f21898bf5b1d$export$2e2bcd8739ae039),
        color: "text-green-800",
        morphologicalEnding: "\u308C\u308B-\u3059"
    },
    {
        id: 98,
        level: 5,
        politeSentence: "\u6728\u3092\u5012\u3057\u307E\u3059",
        politeKana: "\u304D\u3092\u305F\u304A\u3057\u307E\u3059",
        plainSentence: "\u6728\u3092\u5012\u3059",
        plainKana: "\u304D\u3092\u305F\u304A\u3059",
        type: "Transitive",
        english: "I knock down the tree",
        noun: "\u6728",
        nounRuby: [
            {
                text: "\u6728",
                rt: "\u304D"
            }
        ],
        verbPrompt: "\u5012",
        verbRuby: [
            {
                text: "\u5012",
                rt: "\u305F\u304A"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u5012",
                rt: "\u305F\u304A"
            },
            {
                text: "\u3059",
                rt: ""
            }
        ],
        icon: (0, $fab2f21898bf5b1d$export$2e2bcd8739ae039),
        color: "text-green-900",
        morphologicalEnding: "\u308C\u308B-\u3059"
    },
    {
        id: 99,
        level: 5,
        politeSentence: "\u7D19\u304C\u7834\u308C\u307E\u3059",
        politeKana: "\u304B\u307F\u304C\u3084\u3076\u308C\u307E\u3059",
        plainSentence: "\u7D19\u304C\u7834\u308C\u308B",
        plainKana: "\u304B\u307F\u304C\u3084\u3076\u308C\u308B",
        type: "Intransitive",
        english: "The paper tears",
        noun: "\u7D19",
        nounRuby: [
            {
                text: "\u7D19",
                rt: "\u304B\u307F"
            }
        ],
        verbPrompt: "\u7834",
        verbRuby: [
            {
                text: "\u7834",
                rt: "\u3084\u3076"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u7834",
                rt: "\u3084\u3076"
            },
            {
                text: "\u308C",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $72b94b0deb61e5b1$export$2e2bcd8739ae039),
        color: "text-gray-300",
        morphologicalEnding: "\u308C\u308B-\u3046"
    },
    {
        id: 100,
        level: 5,
        politeSentence: "\u7D19\u3092\u7834\u308A\u307E\u3059",
        politeKana: "\u304B\u307F\u3092\u3084\u3076\u308A\u307E\u3059",
        plainSentence: "\u7D19\u3092\u7834\u308B",
        plainKana: "\u304B\u307F\u3092\u3084\u3076\u308B",
        type: "Transitive",
        english: "I tear the paper",
        noun: "\u7D19",
        nounRuby: [
            {
                text: "\u7D19",
                rt: "\u304B\u307F"
            }
        ],
        verbPrompt: "\u7834",
        verbRuby: [
            {
                text: "\u7834",
                rt: "\u3084\u3076"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u7834",
                rt: "\u3084\u3076"
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $72b94b0deb61e5b1$export$2e2bcd8739ae039),
        color: "text-gray-500",
        morphologicalEnding: "\u308C\u308B-\u3046"
    },
    // --- LEVEL 6 (IDs 101-120) ---
    {
        id: 101,
        level: 6,
        politeSentence: "\u9AEA\u304C\u4E7E\u304D\u307E\u3059",
        politeKana: "\u304B\u307F\u304C\u304B\u308F\u304D\u307E\u3059",
        plainSentence: "\u9AEA\u304C\u4E7E\u304F",
        plainKana: "\u304B\u307F\u304C\u304B\u308F\u304F",
        type: "Intransitive",
        english: "Hair dries",
        noun: "\u9AEA",
        nounRuby: [
            {
                text: "\u9AEA",
                rt: "\u304B\u307F"
            }
        ],
        verbPrompt: "\u4E7E",
        verbRuby: [
            {
                text: "\u4E7E",
                rt: "\u304B\u308F"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u4E7E",
                rt: "\u304B\u308F"
            },
            {
                text: "\u304F",
                rt: ""
            }
        ],
        icon: (0, $23f985f27b046d81$export$2e2bcd8739ae039),
        color: "text-blue-200",
        morphologicalEnding: "\u3046-\u3042\u3059"
    },
    {
        id: 102,
        level: 6,
        politeSentence: "\u9AEA\u3092\u4E7E\u304B\u3057\u307E\u3059",
        politeKana: "\u304B\u307F\u3092\u304B\u308F\u304B\u3057\u307E\u3059",
        plainSentence: "\u9AEA\u3092\u4E7E\u304B\u3059",
        plainKana: "\u304B\u307F\u3092\u304B\u308F\u304B\u3059",
        type: "Transitive",
        english: "I dry my hair",
        noun: "\u9AEA",
        nounRuby: [
            {
                text: "\u9AEA",
                rt: "\u304B\u307F"
            }
        ],
        verbPrompt: "\u4E7E",
        verbRuby: [
            {
                text: "\u4E7E",
                rt: "\u304B\u308F"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u4E7E",
                rt: "\u304B\u308F"
            },
            {
                text: "\u304B",
                rt: ""
            },
            {
                text: "\u3059",
                rt: ""
            }
        ],
        icon: (0, $23f985f27b046d81$export$2e2bcd8739ae039),
        color: "text-blue-400",
        morphologicalEnding: "\u3046-\u3042\u3059"
    },
    {
        id: 103,
        level: 6,
        politeSentence: "\u4F53\u304C\u51B7\u3048\u307E\u3059",
        politeKana: "\u304B\u3089\u3060\u304C\u3072\u3048\u307E\u3059",
        plainSentence: "\u4F53\u304C\u51B7\u3048\u308B",
        plainKana: "\u304B\u3089\u3060\u304C\u3072\u3048\u308B",
        type: "Intransitive",
        english: "Body cools down",
        noun: "\u4F53",
        nounRuby: [
            {
                text: "\u4F53",
                rt: "\u304B\u3089\u3060"
            }
        ],
        verbPrompt: "\u51B7",
        verbRuby: [
            {
                text: "\u51B7",
                rt: "\u3072"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u51B7",
                rt: "\u3072"
            },
            {
                text: "\u3048",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $8c74e91f1b4ec8c3$export$2e2bcd8739ae039),
        color: "text-blue-300",
        morphologicalEnding: "\u3048\u308B-\u3042\u3059"
    },
    {
        id: 104,
        level: 6,
        politeSentence: "\u4F53\u3092\u51B7\u3084\u3057\u307E\u3059",
        politeKana: "\u304B\u3089\u3060\u3092\u3072\u3084\u3057\u307E\u3059",
        plainSentence: "\u4F53\u3092\u51B7\u3084\u3059",
        plainKana: "\u304B\u3089\u3060\u3092\u3072\u3084\u3059",
        type: "Transitive",
        english: "I cool my body",
        noun: "\u4F53",
        nounRuby: [
            {
                text: "\u4F53",
                rt: "\u304B\u3089\u3060"
            }
        ],
        verbPrompt: "\u51B7",
        verbRuby: [
            {
                text: "\u51B7",
                rt: "\u3072"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u51B7",
                rt: "\u3072"
            },
            {
                text: "\u3084",
                rt: ""
            },
            {
                text: "\u3059",
                rt: ""
            }
        ],
        icon: (0, $8c74e91f1b4ec8c3$export$2e2bcd8739ae039),
        color: "text-blue-500",
        morphologicalEnding: "\u3048\u308B-\u3042\u3059"
    },
    {
        id: 105,
        level: 6,
        politeSentence: "\u4F53\u304C\u6E29\u307E\u308A\u307E\u3059",
        politeKana: "\u304B\u3089\u3060\u304C\u3042\u305F\u305F\u307E\u308A\u307E\u3059",
        plainSentence: "\u4F53\u304C\u6E29\u307E\u308B",
        plainKana: "\u304B\u3089\u3060\u304C\u3042\u305F\u305F\u307E\u308B",
        type: "Intransitive",
        english: "Body warms up",
        noun: "\u4F53",
        nounRuby: [
            {
                text: "\u4F53",
                rt: "\u304B\u3089\u3060"
            }
        ],
        verbPrompt: "\u6E29",
        verbRuby: [
            {
                text: "\u6E29",
                rt: "\u3042\u305F\u305F"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u6E29",
                rt: "\u3042\u305F\u305F"
            },
            {
                text: "\u307E",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $9d9f9102f02f4e08$export$2e2bcd8739ae039),
        color: "text-orange-300",
        morphologicalEnding: "\u3042\u308B-\u3048\u308B"
    },
    {
        id: 106,
        level: 6,
        politeSentence: "\u4F53\u3092\u6E29\u3081\u307E\u3059",
        politeKana: "\u304B\u3089\u3060\u3092\u3042\u305F\u305F\u3081\u307E\u3059",
        plainSentence: "\u4F53\u3092\u6E29\u3081\u308B",
        plainKana: "\u304B\u3089\u3060\u3092\u3042\u305F\u305F\u3081\u308B",
        type: "Transitive",
        english: "I warm my body",
        noun: "\u4F53",
        nounRuby: [
            {
                text: "\u4F53",
                rt: "\u304B\u3089\u3060"
            }
        ],
        verbPrompt: "\u6E29",
        verbRuby: [
            {
                text: "\u6E29",
                rt: "\u3042\u305F\u305F"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u6E29",
                rt: "\u3042\u305F\u305F"
            },
            {
                text: "\u3081",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $9d9f9102f02f4e08$export$2e2bcd8739ae039),
        color: "text-orange-500",
        morphologicalEnding: "\u3042\u308B-\u3048\u308B"
    },
    {
        id: 107,
        level: 6,
        politeSentence: "\u30B9\u30FC\u30D7\u304C\u51B7\u3081\u307E\u3059",
        politeKana: "\u30B9\u30FC\u30D7\u304C\u3055\u3081\u307E\u3059",
        plainSentence: "\u30B9\u30FC\u30D7\u304C\u51B7\u3081\u308B",
        plainKana: "\u30B9\u30FC\u30D7\u304C\u3055\u3081\u308B",
        type: "Intransitive",
        english: "The soup cools down",
        noun: "\u30B9\u30FC\u30D7",
        nounRuby: [
            {
                text: "\u30B9\u30FC\u30D7",
                rt: ""
            }
        ],
        verbPrompt: "\u51B7",
        verbRuby: [
            {
                text: "\u51B7",
                rt: "\u3055"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u51B7",
                rt: "\u3055"
            },
            {
                text: "\u3081",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $bbd8efc75c2264c3$export$2e2bcd8739ae039),
        color: "text-blue-200",
        morphologicalEnding: "\u3048\u308B-\u3042\u3059"
    },
    {
        id: 108,
        level: 6,
        politeSentence: "\u30B9\u30FC\u30D7\u3092\u51B7\u307E\u3057\u307E\u3059",
        politeKana: "\u30B9\u30FC\u30D7\u3092\u3055\u307E\u3057\u307E\u3059",
        plainSentence: "\u30B9\u30FC\u30D7\u3092\u51B7\u307E\u3059",
        plainKana: "\u30B9\u30FC\u30D7\u3092\u3055\u307E\u3059",
        type: "Transitive",
        english: "I let the soup cool",
        noun: "\u30B9\u30FC\u30D7",
        nounRuby: [
            {
                text: "\u30B9\u30FC\u30D7",
                rt: ""
            }
        ],
        verbPrompt: "\u51B7",
        verbRuby: [
            {
                text: "\u51B7",
                rt: "\u3055"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u51B7",
                rt: "\u3055"
            },
            {
                text: "\u307E",
                rt: ""
            },
            {
                text: "\u3059",
                rt: ""
            }
        ],
        icon: (0, $bbd8efc75c2264c3$export$2e2bcd8739ae039),
        color: "text-blue-400",
        morphologicalEnding: "\u3048\u308B-\u3042\u3059"
    },
    {
        id: 109,
        level: 6,
        politeSentence: "\u670D\u304C\u6C5A\u308C\u307E\u3059",
        politeKana: "\u3075\u304F\u304C\u3088\u3054\u308C\u307E\u3059",
        plainSentence: "\u670D\u304C\u6C5A\u308C\u308B",
        plainKana: "\u3075\u304F\u304C\u3088\u3054\u308C\u308B",
        type: "Intransitive",
        english: "Clothes get dirty",
        noun: "\u670D",
        nounRuby: [
            {
                text: "\u670D",
                rt: "\u3075\u304F"
            }
        ],
        verbPrompt: "\u6C5A",
        verbRuby: [
            {
                text: "\u6C5A",
                rt: "\u3088\u3054"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u6C5A",
                rt: "\u3088\u3054"
            },
            {
                text: "\u308C",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $0d47d6236e6e268e$export$2e2bcd8739ae039),
        color: "text-gray-500",
        morphologicalEnding: "\u308C\u308B-\u3059"
    },
    {
        id: 110,
        level: 6,
        politeSentence: "\u670D\u3092\u6C5A\u3057\u307E\u3059",
        politeKana: "\u3075\u304F\u3092\u3088\u3054\u3057\u307E\u3059",
        plainSentence: "\u670D\u3092\u6C5A\u3059",
        plainKana: "\u3075\u304F\u3092\u3088\u3054\u3059",
        type: "Transitive",
        english: "I get clothes dirty",
        noun: "\u670D",
        nounRuby: [
            {
                text: "\u670D",
                rt: "\u3075\u304F"
            }
        ],
        verbPrompt: "\u6C5A",
        verbRuby: [
            {
                text: "\u6C5A",
                rt: "\u3088\u3054"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u6C5A",
                rt: "\u3088\u3054"
            },
            {
                text: "\u3059",
                rt: ""
            }
        ],
        icon: (0, $0d47d6236e6e268e$export$2e2bcd8739ae039),
        color: "text-gray-700",
        morphologicalEnding: "\u308C\u308B-\u3059"
    },
    {
        id: 111,
        level: 6,
        politeSentence: "\u5B50\u3069\u3082\u304C\u8D77\u304D\u307E\u3059",
        politeKana: "\u3053\u3069\u3082\u304C\u304A\u304D\u307E\u3059",
        plainSentence: "\u5B50\u3069\u3082\u304C\u8D77\u304D\u308B",
        plainKana: "\u3053\u3069\u3082\u304C\u304A\u304D\u308B",
        type: "Intransitive",
        english: "The child wakes up",
        noun: "\u5B50\u3069\u3082",
        nounRuby: [
            {
                text: "\u5B50",
                rt: "\u3053"
            },
            {
                text: "\u3069\u3082",
                rt: ""
            }
        ],
        verbPrompt: "\u8D77",
        verbRuby: [
            {
                text: "\u8D77",
                rt: "\u304A"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u8D77",
                rt: "\u304A"
            },
            {
                text: "\u304D",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $552554c986ed6ef6$export$2e2bcd8739ae039),
        color: "text-yellow-400",
        morphologicalEnding: "\u3044\u308B-\u304A\u3059"
    },
    {
        id: 112,
        level: 6,
        politeSentence: "\u5B50\u3069\u3082\u3092\u8D77\u3053\u3057\u307E\u3059",
        politeKana: "\u3053\u3069\u3082\u3092\u304A\u3053\u3057\u307E\u3059",
        plainSentence: "\u5B50\u3069\u3082\u3092\u8D77\u3053\u3059",
        plainKana: "\u3053\u3069\u3082\u3092\u304A\u3053\u3059",
        type: "Transitive",
        english: "I wake the child up",
        noun: "\u5B50\u3069\u3082",
        nounRuby: [
            {
                text: "\u5B50",
                rt: "\u3053"
            },
            {
                text: "\u3069\u3082",
                rt: ""
            }
        ],
        verbPrompt: "\u8D77",
        verbRuby: [
            {
                text: "\u8D77",
                rt: "\u304A"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u8D77",
                rt: "\u304A"
            },
            {
                text: "\u3053",
                rt: ""
            },
            {
                text: "\u3059",
                rt: ""
            }
        ],
        icon: (0, $552554c986ed6ef6$export$2e2bcd8739ae039),
        color: "text-yellow-600",
        morphologicalEnding: "\u3044\u308B-\u304A\u3059"
    },
    {
        id: 113,
        level: 6,
        politeSentence: "\u76AE\u304C\u3080\u3051\u307E\u3059",
        politeKana: "\u304B\u308F\u304C\u3080\u3051\u307E\u3059",
        plainSentence: "\u76AE\u304C\u3080\u3051\u308B",
        plainKana: "\u304B\u308F\u304C\u3080\u3051\u308B",
        type: "Intransitive",
        english: "The skin peels",
        noun: "\u76AE",
        nounRuby: [
            {
                text: "\u76AE",
                rt: "\u304B\u308F"
            }
        ],
        verbPrompt: "\u3080",
        verbRuby: [
            {
                text: "\u3080",
                rt: ""
            }
        ],
        dictionaryRuby: [
            {
                text: "\u3080",
                rt: ""
            },
            {
                text: "\u3051",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $a9a828219bd3e73d$export$2e2bcd8739ae039),
        color: "text-yellow-300",
        morphologicalEnding: "\u3048\u308B-\u3046"
    },
    {
        id: 114,
        level: 6,
        politeSentence: "\u76AE\u3092\u3080\u304D\u307E\u3059",
        politeKana: "\u304B\u308F\u3092\u3080\u304D\u307E\u3059",
        plainSentence: "\u76AE\u3092\u3080\u304F",
        plainKana: "\u304B\u308F\u3092\u3080\u304F",
        type: "Transitive",
        english: "I peel the skin",
        noun: "\u76AE",
        nounRuby: [
            {
                text: "\u76AE",
                rt: "\u304B\u308F"
            }
        ],
        verbPrompt: "\u3080",
        verbRuby: [
            {
                text: "\u3080",
                rt: ""
            }
        ],
        dictionaryRuby: [
            {
                text: "\u3080",
                rt: ""
            },
            {
                text: "\u304F",
                rt: ""
            }
        ],
        icon: (0, $a9a828219bd3e73d$export$2e2bcd8739ae039),
        color: "text-yellow-500",
        morphologicalEnding: "\u3048\u308B-\u3046"
    },
    {
        id: 115,
        level: 6,
        politeSentence: "\u8D64\u3061\u3083\u3093\u304C\u751F\u307E\u308C\u307E\u3059",
        politeKana: "\u3042\u304B\u3061\u3083\u3093\u304C\u3046\u307E\u308C\u307E\u3059",
        plainSentence: "\u8D64\u3061\u3083\u3093\u304C\u751F\u307E\u308C\u308B",
        plainKana: "\u3042\u304B\u3061\u3083\u3093\u304C\u3046\u307E\u308C\u308B",
        type: "Intransitive",
        english: "The baby is born",
        noun: "\u8D64\u3061\u3083\u3093",
        nounRuby: [
            {
                text: "\u8D64",
                rt: "\u3042\u304B"
            },
            {
                text: "\u3061\u3083\u3093",
                rt: ""
            }
        ],
        verbPrompt: "\u751F",
        verbRuby: [
            {
                text: "\u751F",
                rt: "\u3046"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u751F",
                rt: "\u3046"
            },
            {
                text: "\u307E",
                rt: ""
            },
            {
                text: "\u308C",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $dbe0cbc446f3d7c2$export$2e2bcd8739ae039),
        color: "text-pink-200",
        morphologicalEnding: "\u308C\u308B-\u3046"
    },
    {
        id: 116,
        level: 6,
        politeSentence: "\u8D64\u3061\u3083\u3093\u3092\u751F\u307F\u307E\u3059",
        politeKana: "\u3042\u304B\u3061\u3083\u3093\u3092\u3046\u307F\u307E\u3059",
        plainSentence: "\u8D64\u3061\u3083\u3093\u3092\u751F\u3080",
        plainKana: "\u3042\u304B\u3061\u3083\u3093\u3092\u3046\u3080",
        type: "Transitive",
        english: "I give birth to a baby",
        noun: "\u8D64\u3061\u3083\u3093",
        nounRuby: [
            {
                text: "\u8D64",
                rt: "\u3042\u304B"
            },
            {
                text: "\u3061\u3083\u3093",
                rt: ""
            }
        ],
        verbPrompt: "\u751F",
        verbRuby: [
            {
                text: "\u751F",
                rt: "\u3046"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u751F",
                rt: "\u3046"
            },
            {
                text: "\u3080",
                rt: ""
            }
        ],
        icon: (0, $dbe0cbc446f3d7c2$export$2e2bcd8739ae039),
        color: "text-pink-400",
        morphologicalEnding: "\u308C\u308B-\u3046"
    },
    {
        id: 117,
        level: 6,
        politeSentence: "\u4E88\u5B9A\u304C\u5EF6\u3073\u307E\u3059",
        politeKana: "\u3088\u3066\u3044\u304C\u306E\u3073\u307E\u3059",
        plainSentence: "\u4E88\u5B9A\u304C\u5EF6\u3073\u308B",
        plainKana: "\u3088\u3066\u3044\u304C\u306E\u3073\u308B",
        type: "Intransitive",
        english: "The schedule is extended",
        noun: "\u4E88\u5B9A",
        nounRuby: [
            {
                text: "\u4E88",
                rt: "\u3088"
            },
            {
                text: "\u5B9A",
                rt: "\u3066\u3044"
            }
        ],
        verbPrompt: "\u5EF6",
        verbRuby: [
            {
                text: "\u5EF6",
                rt: "\u306E"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u5EF6",
                rt: "\u306E"
            },
            {
                text: "\u3073",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $30050f52d874b8f2$export$2e2bcd8739ae039),
        color: "text-blue-300",
        morphologicalEnding: "\u3044\u308B-\u3042\u3059"
    },
    {
        id: 118,
        level: 6,
        politeSentence: "\u4E88\u5B9A\u3092\u5EF6\u3070\u3057\u307E\u3059",
        politeKana: "\u3088\u3066\u3044\u3092\u306E\u3070\u3057\u307E\u3059",
        plainSentence: "\u4E88\u5B9A\u3092\u5EF6\u3070\u3059",
        plainKana: "\u3088\u3066\u3044\u3092\u306E\u3070\u3059",
        type: "Transitive",
        english: "I extend the schedule",
        noun: "\u4E88\u5B9A",
        nounRuby: [
            {
                text: "\u4E88",
                rt: "\u3088"
            },
            {
                text: "\u5B9A",
                rt: "\u3066\u3044"
            }
        ],
        verbPrompt: "\u5EF6",
        verbRuby: [
            {
                text: "\u5EF6",
                rt: "\u306E"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u5EF6",
                rt: "\u306E"
            },
            {
                text: "\u3070",
                rt: ""
            },
            {
                text: "\u3059",
                rt: ""
            }
        ],
        icon: (0, $30050f52d874b8f2$export$2e2bcd8739ae039),
        color: "text-blue-500",
        morphologicalEnding: "\u3044\u308B-\u3042\u3059"
    },
    {
        id: 119,
        level: 6,
        politeSentence: "\u72AF\u4EBA\u304C\u6355\u307E\u308A\u307E\u3059",
        politeKana: "\u306F\u3093\u306B\u3093\u304C\u3064\u304B\u307E\u308A\u307E\u3059",
        plainSentence: "\u72AF\u4EBA\u304C\u6355\u307E\u308B",
        plainKana: "\u306F\u3093\u306B\u3093\u304C\u3064\u304B\u307E\u308B",
        type: "Intransitive",
        english: "The criminal is caught",
        noun: "\u72AF\u4EBA",
        nounRuby: [
            {
                text: "\u72AF",
                rt: "\u306F\u3093"
            },
            {
                text: "\u4EBA",
                rt: "\u306B\u3093"
            }
        ],
        verbPrompt: "\u6355",
        verbRuby: [
            {
                text: "\u6355",
                rt: "\u3064\u304B"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u6355",
                rt: "\u3064\u304B"
            },
            {
                text: "\u307E",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $0d83c4063ed3cfa6$export$2e2bcd8739ae039),
        color: "text-gray-600",
        morphologicalEnding: "\u3042\u308B-\u3048\u308B"
    },
    {
        id: 120,
        level: 6,
        politeSentence: "\u72AF\u4EBA\u3092\u6355\u307E\u3048\u307E\u3059",
        politeKana: "\u306F\u3093\u306B\u3093\u3092\u3064\u304B\u307E\u3048\u307E\u3059",
        plainSentence: "\u72AF\u4EBA\u3092\u6355\u307E\u3048\u308B",
        plainKana: "\u306F\u3093\u306B\u3093\u3092\u3064\u304B\u307E\u3048\u308B",
        type: "Transitive",
        english: "I catch the criminal",
        noun: "\u72AF\u4EBA",
        nounRuby: [
            {
                text: "\u72AF",
                rt: "\u306F\u3093"
            },
            {
                text: "\u4EBA",
                rt: "\u306B\u3093"
            }
        ],
        verbPrompt: "\u6355",
        verbRuby: [
            {
                text: "\u6355",
                rt: "\u3064\u304B"
            }
        ],
        dictionaryRuby: [
            {
                text: "\u6355",
                rt: "\u3064\u304B"
            },
            {
                text: "\u307E",
                rt: ""
            },
            {
                text: "\u3048",
                rt: ""
            },
            {
                text: "\u308B",
                rt: ""
            }
        ],
        icon: (0, $0d83c4063ed3cfa6$export$2e2bcd8739ae039),
        color: "text-gray-800",
        morphologicalEnding: "\u3042\u308B-\u3048\u308B"
    }
];


// --- UTILS: Romaji to Hiragana Converter ---
const $f0c6b89f778a0142$export$55846812dd1a72bc = {
    // Basic Vowels
    'a': "\u3042",
    'i': "\u3044",
    'u': "\u3046",
    'e': "\u3048",
    'o': "\u304A",
    // K
    'ka': "\u304B",
    'ki': "\u304D",
    'ku': "\u304F",
    'ke': "\u3051",
    'ko': "\u3053",
    // S
    'sa': "\u3055",
    'shi': "\u3057",
    'si': "\u3057",
    'su': "\u3059",
    'se': "\u305B",
    'so': "\u305D",
    // T
    'ta': "\u305F",
    'chi': "\u3061",
    'ti': "\u3061",
    'tsu': "\u3064",
    'tu': "\u3064",
    'te': "\u3066",
    'to': "\u3068",
    // N
    'na': "\u306A",
    'ni': "\u306B",
    'nu': "\u306C",
    'ne': "\u306D",
    'no': "\u306E",
    // H
    'ha': "\u306F",
    'hi': "\u3072",
    'fu': "\u3075",
    'hu': "\u3075",
    'he': "\u3078",
    'ho': "\u307B",
    // M
    'ma': "\u307E",
    'mi': "\u307F",
    'mu': "\u3080",
    'me': "\u3081",
    'mo': "\u3082",
    // Y
    'ya': "\u3084",
    'yu': "\u3086",
    'yo': "\u3088",
    // R
    'ra': "\u3089",
    'ri': "\u308A",
    'ru': "\u308B",
    're': "\u308C",
    'ro': "\u308D",
    // W
    'wa': "\u308F",
    'wo': "\u3092",
    // N singular (explicit nn is handled by regex usually, but good to have)
    'nn': "\u3093",
    // G
    'ga': "\u304C",
    'gi': "\u304E",
    'gu': "\u3050",
    'ge': "\u3052",
    'go': "\u3054",
    // Z
    'za': "\u3056",
    'ji': "\u3058",
    'zi': "\u3058",
    'zu': "\u305A",
    'ze': "\u305C",
    'zo': "\u305E",
    // D
    'da': "\u3060",
    'di': "\u3062",
    'du': "\u3065",
    'de': "\u3067",
    'do': "\u3069",
    // B
    'ba': "\u3070",
    'bi': "\u3073",
    'bu': "\u3076",
    'be': "\u3079",
    'bo': "\u307C",
    // P
    'pa': "\u3071",
    'pi': "\u3074",
    'pu': "\u3077",
    'pe': "\u307A",
    'po': "\u307D",
    // Compounds (Small Y)
    'kya': "\u304D\u3083",
    'kyu': "\u304D\u3085",
    'kyo': "\u304D\u3087",
    'sha': "\u3057\u3083",
    'shu': "\u3057\u3085",
    'sho': "\u3057\u3087",
    'cha': "\u3061\u3083",
    'chu': "\u3061\u3085",
    'cho': "\u3061\u3087",
    'nya': "\u306B\u3083",
    'nyu': "\u306B\u3085",
    'nyo': "\u306B\u3087",
    'hya': "\u3072\u3083",
    'hyu': "\u3072\u3085",
    'hyo': "\u3072\u3087",
    'mya': "\u307F\u3083",
    'myu': "\u307F\u3085",
    'myo': "\u307F\u3087",
    'rya': "\u308A\u3083",
    'ryu': "\u308A\u3085",
    'ryo': "\u308A\u3087",
    'gya': "\u304E\u3083",
    'gyu': "\u304E\u3085",
    'gyo': "\u304E\u3087",
    'ja': "\u3058\u3083",
    'ju': "\u3058\u3085",
    'jo': "\u3058\u3087",
    'jya': "\u3058\u3083",
    'jyu': "\u3058\u3085",
    'jyo': "\u3058\u3087",
    'bya': "\u3073\u3083",
    'byu': "\u3073\u3085",
    'byo': "\u3073\u3087",
    'pya': "\u3074\u3083",
    'pyu': "\u3074\u3085",
    'pyo': "\u3074\u3087",
    // Small Tsu (for direct input if needed, though regex handles doubling)
    'ltu': "\u3063",
    'xtu': "\u3063",
    // Small Vowels
    'la': "\u3041",
    'li': "\u3043",
    'lu': "\u3045",
    'le': "\u3047",
    'lo': "\u3049",
    'xa': "\u3041",
    'xi': "\u3043",
    'xu': "\u3045",
    'xe': "\u3047",
    'xo': "\u3049",
    // Punctuation
    '-': "\u30FC",
    '.': "\u3002",
    ',': "\u3001",
    '?': "\uFF1F",
    '!': "\uFF01"
};


// Helper to escape regex characters
const $244778c8bb25e663$var$escapeRegExp = (string)=>{
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};
// Sort keys by length descending to match longest possible string first
const $244778c8bb25e663$var$MAP_KEYS = Object.keys((0, $f0c6b89f778a0142$export$55846812dd1a72bc)).sort((a, b)=>b.length - a.length);
// Escape keys before joining to prevent "nothing to repeat" error
const $244778c8bb25e663$var$MAP_REGEX = new RegExp($244778c8bb25e663$var$MAP_KEYS.map($244778c8bb25e663$var$escapeRegExp).join('|'), 'g');
const $244778c8bb25e663$export$df0ac7caf6813e1a = (text)=>{
    if (!text) return '';
    let converted = text.toLowerCase();
    // 1. Handle Sokuon (Double Consonants): 'tt' -> 'っt', 'kk' -> 'っk'
    // Excluding 'n' because 'nn' is 'ん'
    converted = converted.replace(/([bcdfghjklmpqrstvwxyz])\1/g, "\u3063$1");
    // 2. Handle 'nn' -> 'ん' (must come BEFORE n+consonant rule)
    converted = converted.replace(/nn/g, "\u3093");
    // 3. Handle 'n' followed by a consonant (except y) -> 'ん' + consonant
    // e.g., 'kanta' -> 'ka' 'n' 'ta' -> 'ka' 'ん' 'ta'
    converted = converted.replace(/n(?=[^aeiouy])/g, "\u3093");
    // 4. Main Mapping Replacement
    converted = converted.replace($244778c8bb25e663$var$MAP_REGEX, (match)=>(0, $f0c6b89f778a0142$export$55846812dd1a72bc)[match]);
    return converted;
};
const $244778c8bb25e663$export$28ab6cab47a15260 = (str)=>{
    return str.replace(/[\u30a1-\u30f6]/g, (match)=>{
        const chr = match.charCodeAt(0) - 0x60;
        return String.fromCharCode(chr);
    });
};


const $d4417072adffad0c$export$d042775ae746d5e7 = (levels, types, isFixedOrder)=>{
    const filtered = (0, $1e60d8c6534cd098$export$b28a0e5be47ced59).filter((item)=>levels.includes(item.level) && types.includes(item.type));
    if (filtered.length === 0) return [];
    return isFixedOrder ? [
        ...filtered
    ].sort((a, b)=>a.id - b.id) : [
        ...filtered
    ].sort(()=>Math.random() - 0.5);
};
const $d4417072adffad0c$export$aeb603ca3c42d91c = (input, question, selectedForms)=>{
    const inputHira = (0, $244778c8bb25e663$export$28ab6cab47a15260)(input.trim().replace(/\s+/g, ''));
    const validAnswers = [];
    if (selectedForms.includes('Polite')) {
        validAnswers.push((0, $244778c8bb25e663$export$28ab6cab47a15260)(question.politeSentence));
        validAnswers.push((0, $244778c8bb25e663$export$28ab6cab47a15260)(question.politeKana.replace(/\s+/g, '')));
    }
    if (selectedForms.includes('Plain')) {
        validAnswers.push((0, $244778c8bb25e663$export$28ab6cab47a15260)(question.plainSentence));
        validAnswers.push((0, $244778c8bb25e663$export$28ab6cab47a15260)(question.plainKana.replace(/\s+/g, '')));
    }
    return validAnswers.includes(inputHira);
};
const $d4417072adffad0c$export$1a21776e138ef20b = (question)=>{
    const pairId = question.id % 2 === 1 ? question.id + 1 : question.id - 1;
    return (0, $1e60d8c6534cd098$export$b28a0e5be47ced59).find((v)=>v.id === pairId);
};



const $c4204af8016d9a61$var$QuizContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
// Initial state
const $c4204af8016d9a61$var$initialState = {
    shuffledData: [],
    currentIndex: 0,
    feedback: null,
    userInput: '',
    showAnswer: false,
    correctCount: 0,
    totalQuestions: 0,
    isInvalidInput: false
};
// Action types
const $c4204af8016d9a61$var$ACTIONS = {
    SET_DATA: 'SET_DATA',
    SET_FEEDBACK: 'SET_FEEDBACK',
    SET_INPUT: 'SET_INPUT',
    SET_SHOW_ANSWER: 'SET_SHOW_ANSWER',
    SET_INVALID_INPUT: 'SET_INVALID_INPUT',
    CORRECT_ANSWER: 'CORRECT_ANSWER',
    INCORRECT_ANSWER: 'INCORRECT_ANSWER',
    RETRY: 'RETRY',
    RESET: 'RESET'
};
function $c4204af8016d9a61$var$quizReducer(state, action) {
    switch(action.type){
        case $c4204af8016d9a61$var$ACTIONS.SET_DATA:
            return {
                ...state,
                shuffledData: action.payload,
                currentIndex: 0,
                feedback: null,
                userInput: '',
                showAnswer: false,
                correctCount: 0,
                totalQuestions: action.payload.length
            };
        case $c4204af8016d9a61$var$ACTIONS.SET_FEEDBACK:
            return {
                ...state,
                feedback: action.payload
            };
        case $c4204af8016d9a61$var$ACTIONS.SET_INPUT:
            return {
                ...state,
                userInput: action.payload,
                isInvalidInput: false
            };
        case $c4204af8016d9a61$var$ACTIONS.SET_SHOW_ANSWER:
            return {
                ...state,
                showAnswer: action.payload
            };
        case $c4204af8016d9a61$var$ACTIONS.SET_INVALID_INPUT:
            return {
                ...state,
                isInvalidInput: action.payload
            };
        case $c4204af8016d9a61$var$ACTIONS.CORRECT_ANSWER:
            {
                // Remove current question from pool
                const newData = [
                    ...state.shuffledData
                ];
                newData.splice(state.currentIndex, 1);
                return {
                    ...state,
                    shuffledData: newData,
                    correctCount: state.correctCount + 1,
                    currentIndex: state.currentIndex >= newData.length ? 0 : state.currentIndex,
                    feedback: null,
                    userInput: '',
                    showAnswer: false
                };
            }
        case $c4204af8016d9a61$var$ACTIONS.INCORRECT_ANSWER:
            {
                // Move current question to end of pool
                const newData = [
                    ...state.shuffledData
                ];
                const [currentQ] = newData.splice(state.currentIndex, 1);
                newData.push(currentQ);
                return {
                    ...state,
                    shuffledData: newData,
                    feedback: null,
                    userInput: '',
                    showAnswer: false
                };
            }
        case $c4204af8016d9a61$var$ACTIONS.RETRY:
            return {
                ...state,
                feedback: null,
                userInput: '',
                showAnswer: false
            };
        case $c4204af8016d9a61$var$ACTIONS.RESET:
            return {
                ...$c4204af8016d9a61$var$initialState,
                totalQuestions: state.totalQuestions
            };
        default:
            return state;
    }
}
function $c4204af8016d9a61$export$660171dc0394dc07({ children: children }) {
    const [state, dispatch] = (0, $acw62.useReducer)($c4204af8016d9a61$var$quizReducer, $c4204af8016d9a61$var$initialState);
    const inputRef = (0, $acw62.useRef)(null);
    const { selectedLevels: selectedLevels, selectedTypes: selectedTypes, isFixedOrder: isFixedOrder, selectedForms: selectedForms } = (0, $967b4ec559f6d613$export$9115b42802a3e44f)();
    // Initialize/reinitialize quiz when filters change
    (0, $acw62.useEffect)(()=>{
        const data = (0, $d4417072adffad0c$export$d042775ae746d5e7)(selectedLevels, selectedTypes, isFixedOrder);
        dispatch({
            type: $c4204af8016d9a61$var$ACTIONS.SET_DATA,
            payload: data
        });
    }, [
        selectedLevels,
        selectedTypes,
        isFixedOrder
    ]);
    // Force focus on mount
    (0, $acw62.useEffect)(()=>{
        if (inputRef.current) inputRef.current.focus();
    }, []);
    // Auto-focus when new question renders
    const currentQuestion = state.shuffledData[state.currentIndex];
    (0, $acw62.useEffect)(()=>{
        if (currentQuestion && !state.feedback && inputRef.current) {
            inputRef.current.focus();
            inputRef.current.select();
        }
    }, [
        currentQuestion,
        state.feedback
    ]);
    // Action creators
    const setInput = (0, $acw62.useCallback)((value)=>{
        dispatch({
            type: $c4204af8016d9a61$var$ACTIONS.SET_INPUT,
            payload: value
        });
    }, []);
    const setFeedback = (0, $acw62.useCallback)((value)=>{
        dispatch({
            type: $c4204af8016d9a61$var$ACTIONS.SET_FEEDBACK,
            payload: value
        });
    }, []);
    const setInvalidInput = (0, $acw62.useCallback)((value)=>{
        dispatch({
            type: $c4204af8016d9a61$var$ACTIONS.SET_INVALID_INPUT,
            payload: value
        });
        if (value) setTimeout(()=>dispatch({
                type: $c4204af8016d9a61$var$ACTIONS.SET_INVALID_INPUT,
                payload: false
            }), 500);
    }, []);
    const handleCorrect = (0, $acw62.useCallback)(()=>{
        dispatch({
            type: $c4204af8016d9a61$var$ACTIONS.CORRECT_ANSWER
        });
        if (inputRef.current) inputRef.current.focus();
    }, []);
    const handleIncorrect = (0, $acw62.useCallback)(()=>{
        dispatch({
            type: $c4204af8016d9a61$var$ACTIONS.INCORRECT_ANSWER
        });
        if (inputRef.current) inputRef.current.focus();
    }, []);
    const handleNext = (0, $acw62.useCallback)((wasCorrect)=>{
        if (wasCorrect) handleCorrect();
        else handleIncorrect();
    }, [
        handleCorrect,
        handleIncorrect
    ]);
    const handleRetry = (0, $acw62.useCallback)(()=>{
        dispatch({
            type: $c4204af8016d9a61$var$ACTIONS.RETRY
        });
        if (inputRef.current) inputRef.current.focus();
    }, []);
    const handleGiveUp = (0, $acw62.useCallback)(()=>{
        dispatch({
            type: $c4204af8016d9a61$var$ACTIONS.SET_FEEDBACK,
            payload: 'incorrect'
        });
        dispatch({
            type: $c4204af8016d9a61$var$ACTIONS.SET_SHOW_ANSWER,
            payload: true
        });
        if (inputRef.current) inputRef.current.focus();
    }, []);
    const handleRestart = (0, $acw62.useCallback)(()=>{
        const data = (0, $d4417072adffad0c$export$d042775ae746d5e7)(selectedLevels, selectedTypes, isFixedOrder);
        dispatch({
            type: $c4204af8016d9a61$var$ACTIONS.SET_DATA,
            payload: data
        });
        if (inputRef.current) inputRef.current.focus();
    }, [
        selectedLevels,
        selectedTypes,
        isFixedOrder
    ]);
    const checkAnswer = (0, $acw62.useCallback)((input)=>{
        if (!currentQuestion) return false;
        return (0, $d4417072adffad0c$export$aeb603ca3c42d91c)(input, currentQuestion, selectedForms);
    }, [
        currentQuestion,
        selectedForms
    ]);
    const value = {
        // State
        ...state,
        currentQuestion: currentQuestion,
        inputRef: inputRef,
        // Derived state
        isComplete: state.shuffledData.length === 0 && state.totalQuestions > 0,
        isEmpty: state.shuffledData.length === 0 && state.totalQuestions === 0,
        progress: state.totalQuestions > 0 ? state.correctCount / state.totalQuestions * 100 : 0,
        questionNumber: state.correctCount + 1,
        setInput: // Actions
        setInput,
        setFeedback: setFeedback,
        setInvalidInput: setInvalidInput,
        handleNext: handleNext,
        handleRetry: handleRetry,
        handleGiveUp: handleGiveUp,
        handleRestart: handleRestart,
        handleCorrect: handleCorrect,
        handleIncorrect: handleIncorrect,
        checkAnswer: checkAnswer
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c4204af8016d9a61$var$QuizContext.Provider, {
        value: value,
        children: children
    });
}
const $c4204af8016d9a61$export$279b3db6af62ec8 = ()=>{
    const context = (0, $acw62.useContext)($c4204af8016d9a61$var$QuizContext);
    if (!context) throw new Error('useQuiz must be used within a QuizProvider');
    return context;
};




/**
 * @fileoverview Exports settings and configuration components.
 * These components allow users to customize their quiz experience,
 * including difficulty levels, verb types, and display preferences.
 * @module components/settings
 */ /** @description Main collapsible panel containing all quiz configuration options */ // SettingsPanel - Main settings container with dropdown


var $acw62 = parcelRequire("acw62");

// useClickOutside - detects clicks outside a ref element

var $acw62 = parcelRequire("acw62");
function $8e9dd5da3c461864$export$1896bab46732d207(callback) {
    const ref = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) callback();
        }
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [
        callback
    ]);
    return ref;
}


// LevelSelector - Level selection checkboxes

parcelRequire("acw62");

// Checkbox - styled checkbox component

parcelRequire("acw62");

function $8fec56c7b59917b1$export$48513f6b9f8ce62d({ checked: checked, onChange: onChange, label: label, sublabel: sublabel, colorClass: colorClass = 'bg-green-500 border-green-500', labelColorClass: labelColorClass = 'text-white' }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        role: "checkbox",
        "aria-checked": checked,
        tabIndex: 0,
        onClick: onChange,
        onKeyDown: (e)=>{
            if (e.key === ' ' || e.key === 'Enter') {
                e.preventDefault();
                onChange(e);
            }
        },
        onMouseDown: (e)=>e.preventDefault(),
        className: "flex items-center gap-2 cursor-pointer hover:bg-[#333] py-0.5 px-2 rounded transition-colors",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: `w-4 h-4 rounded border flex items-center justify-center transition-colors ${checked ? colorClass : 'border-gray-500'}`,
                children: checked && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $176d6e46e6973fb2$export$2e2bcd8739ae039), {
                    size: 12,
                    className: "text-white"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: `text-base ${checked ? `${labelColorClass} font-bold` : 'text-gray-400'}`,
                        children: label
                    }),
                    sublabel && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: `text-[10px] ${checked ? 'text-gray-400 font-bold' : 'text-gray-400'}`,
                        children: sublabel
                    })
                ]
            })
        ]
    });
}



function $ce9076f23fbc9cfc$export$4895eee1da58b5ea() {
    const { selectedLevels: selectedLevels, toggleLevel: toggleLevel } = (0, $967b4ec559f6d613$export$9115b42802a3e44f)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-xs font-bold uppercase tracking-wider text-gray-400 mb-1 border-b border-gray-600 pb-1",
                children: "Select Levels"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "grid grid-cols-2 gap-0 mb-2",
                children: (0, $2dbe475692899d38$export$d894ea38a8d3ed54).map((level)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8fec56c7b59917b1$export$48513f6b9f8ce62d), {
                        checked: selectedLevels.includes(level),
                        onChange: ()=>toggleLevel(level),
                        label: `\u{30EC}\u{30D9}\u{30EB} ${level}`,
                        colorClass: "bg-green-500 border-green-500",
                        labelColorClass: "text-white"
                    }, level))
            })
        ]
    });
}


// TypeSelector - Verb type (Transitive/Intransitive) selection

parcelRequire("acw62");


function $4e734d644be16574$export$1cbeb7199b91dfe2() {
    const { selectedTypes: selectedTypes, toggleType: toggleType } = (0, $967b4ec559f6d613$export$9115b42802a3e44f)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-xs font-bold uppercase tracking-wider text-gray-400 mb-1 border-b border-gray-600 pb-1",
                children: "Verb Type"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-2 gap-0 mb-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8fec56c7b59917b1$export$48513f6b9f8ce62d), {
                        checked: selectedTypes.includes('Intransitive'),
                        onChange: ()=>toggleType('Intransitive'),
                        label: "\u81EA\u52D5\u8A5E",
                        sublabel: "Intransitive",
                        colorClass: "bg-purple-500 border-purple-500",
                        labelColorClass: "text-purple-400"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8fec56c7b59917b1$export$48513f6b9f8ce62d), {
                        checked: selectedTypes.includes('Transitive'),
                        onChange: ()=>toggleType('Transitive'),
                        label: "\u4ED6\u52D5\u8A5E",
                        sublabel: "Transitive",
                        colorClass: "bg-yellow-500 border-yellow-500",
                        labelColorClass: "text-yellow-400"
                    })
                ]
            })
        ]
    });
}


// FormSelector - Verb form (Polite/Plain) selection

parcelRequire("acw62");


function $2a0d4e43e1542966$export$e3869581001f0f6e() {
    const { selectedForms: selectedForms, toggleForm: toggleForm } = (0, $967b4ec559f6d613$export$9115b42802a3e44f)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-xs font-bold uppercase tracking-wider text-gray-400 mb-1 border-b border-gray-600 pb-1",
                children: "Verb Form"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-2 gap-0 mb-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8fec56c7b59917b1$export$48513f6b9f8ce62d), {
                        checked: selectedForms.includes('Polite'),
                        onChange: ()=>toggleForm('Polite'),
                        label: "\u4E01\u5BE7\u5F62",
                        sublabel: "Polite Form",
                        colorClass: "bg-[#5F9EA0] border-[#5F9EA0]",
                        labelColorClass: "text-[#5F9EA0]"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8fec56c7b59917b1$export$48513f6b9f8ce62d), {
                        checked: selectedForms.includes('Plain'),
                        onChange: ()=>toggleForm('Plain'),
                        label: "\u666E\u901A\u5F62",
                        sublabel: "Plain Form",
                        colorClass: "bg-[#D1AD8C] border-[#D1AD8C]",
                        labelColorClass: "text-[#D1AD8C]"
                    })
                ]
            })
        ]
    });
}


// DisplayOptions - Toggle display options (English, Furigana, Dictionary, Pairs)

parcelRequire("acw62");


function $6ebb4ba2eccd0817$export$92a25f92810e61f8() {
    const { showEnglish: showEnglish, setShowEnglish: setShowEnglish, showFurigana: showFurigana, setShowFurigana: setShowFurigana, showDictionary: showDictionary, setShowDictionary: setShowDictionary, showPairs: showPairs, setShowPairs: setShowPairs, showSimilarPatterns: showSimilarPatterns, setShowSimilarPatterns: setShowSimilarPatterns } = (0, $967b4ec559f6d613$export$9115b42802a3e44f)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-xs font-bold uppercase tracking-wider text-gray-400 mb-1 border-b border-gray-600 pb-1",
                children: "Display Options"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "grid grid-cols-2 gap-0 mb-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8fec56c7b59917b1$export$48513f6b9f8ce62d), {
                        checked: showEnglish,
                        onChange: ()=>setShowEnglish(!showEnglish),
                        label: "\u82F1\u8A9E\u8868\u8A18",
                        sublabel: "English Labels",
                        colorClass: "bg-green-500 border-green-500",
                        labelColorClass: "text-white"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8fec56c7b59917b1$export$48513f6b9f8ce62d), {
                        checked: showFurigana,
                        onChange: ()=>setShowFurigana(!showFurigana),
                        label: "\u632F\u4EEE\u540D",
                        sublabel: "Furigana",
                        colorClass: "bg-green-500 border-green-500",
                        labelColorClass: "text-white"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8fec56c7b59917b1$export$48513f6b9f8ce62d), {
                        checked: showDictionary,
                        onChange: ()=>setShowDictionary(!showDictionary),
                        label: "\u8F9E\u66F8\u5F62",
                        sublabel: "Dictionary Form",
                        colorClass: "bg-green-500 border-green-500",
                        labelColorClass: "text-white"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8fec56c7b59917b1$export$48513f6b9f8ce62d), {
                        checked: showPairs,
                        onChange: ()=>setShowPairs(!showPairs),
                        label: "\u30DA\u30A2\u30D2\u30F3\u30C8\u8868\u793A",
                        sublabel: "Display Pairs Hints",
                        colorClass: "bg-green-500 border-green-500",
                        labelColorClass: "text-white"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8fec56c7b59917b1$export$48513f6b9f8ce62d), {
                        checked: showSimilarPatterns,
                        onChange: ()=>setShowSimilarPatterns(!showSimilarPatterns),
                        label: "\u540C\u3058\u30D1\u30BF\u30FC\u30F3\u306E\u8868\u793A",
                        sublabel: "Show Similar Patterns",
                        colorClass: "bg-green-500 border-green-500",
                        labelColorClass: "text-white"
                    })
                ]
            })
        ]
    });
}


// QuizModeSelector - Fixed sequence toggle

parcelRequire("acw62");


function $7567b320ba2907f0$export$1b01eef995bc5ae9() {
    const { isFixedOrder: isFixedOrder, setIsFixedOrder: setIsFixedOrder } = (0, $967b4ec559f6d613$export$9115b42802a3e44f)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "text-xs font-bold uppercase tracking-wider text-gray-400 mb-1 border-b border-gray-600 pb-1",
                children: "Quiz Mode"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "grid grid-cols-2 gap-0",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8fec56c7b59917b1$export$48513f6b9f8ce62d), {
                    checked: isFixedOrder,
                    onChange: ()=>setIsFixedOrder(!isFixedOrder),
                    label: "\u56FA\u5B9A\u9806",
                    sublabel: "Fixed Sequence",
                    colorClass: "bg-green-500 border-green-500",
                    labelColorClass: "text-white"
                })
            })
        ]
    });
}


function $1a00bcc4c62aa58d$export$fef7159a5e479b3c() {
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const handleClose = (0, $acw62.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const ref = (0, $8e9dd5da3c461864$export$1896bab46732d207)(handleClose);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "absolute top-4 left-3 z-50",
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                onClick: ()=>setIsOpen(!isOpen),
                className: "flex items-center gap-2 bg-[#2a2a2a] hover:bg-[#333] text-gray-200 px-4 py-2 rounded-lg border border-[#333] shadow-md transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-gray-500",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $da03c070d837b197$export$2e2bcd8739ae039), {
                        size: 18,
                        className: "text-gray-300"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "font-medium text-sm tracking-wide",
                        children: "\u8A2D\u5B9A"
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "absolute top-full left-0 mt-1 bg-[#2a2a2a] p-2 rounded-lg border border-[#333] shadow-xl w-[22rem] animate-in fade-in slide-in-from-top-2 z-50 max-h-[100vh] overflow-y-auto",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ce9076f23fbc9cfc$export$4895eee1da58b5ea), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e734d644be16574$export$1cbeb7199b91dfe2), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2a0d4e43e1542966$export$e3869581001f0f6e), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6ebb4ba2eccd0817$export$92a25f92810e61f8), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7567b320ba2907f0$export$1b01eef995bc5ae9), {})
                ]
            })
        ]
    });
}









/**
 * @fileoverview Exports all quiz-related components.
 * These components work together to provide the interactive quiz experience,
 * handling question display, user input, feedback, and progress tracking.
 * @module components/quiz
 */ /** @description Main container component that orchestrates the quiz interface */ // QuizCard - displays noun and verb prompt

parcelRequire("acw62");
// RubyText - displays Japanese text with tap-to-toggle furigana


var $acw62 = parcelRequire("acw62");
function $a738c439e9f5d693$export$184a93565bb489ae({ data: data, showFurigana: showFurigana }) {
    // Track if the entire compound word's furigana is toggled
    const [isToggled, setIsToggled] = (0, $acw62.useState)(false);
    // Reset toggle when data changes (new question)
    (0, $acw62.useEffect)(()=>{
        setIsToggled(false);
    }, [
        data
    ]);
    // Check if this compound has any furigana
    const hasFurigana = data.some((item)=>item.rt);
    const handleTap = ()=>{
        if (!hasFurigana) return; // Only toggle if there's furigana
        setIsToggled((prev)=>!prev);
    };
    // Determine if furigana should show: global setting XOR toggle
    const shouldShowFurigana = showFurigana ? !isToggled : isToggled;
    // Prevent mousedown/touchstart from stealing focus from input (keeps virtual keyboard open)
    const preventBlur = (e)=>{
        e.preventDefault();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `flex items-end ${hasFurigana ? 'cursor-pointer select-none hover:opacity-80 transition-opacity' : ''}`,
        onMouseDown: hasFurigana ? preventBlur : undefined,
        onTouchStart: hasFurigana ? preventBlur : undefined,
        onClick: handleTap,
        children: data.map((item, idx)=>{
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                children: item.rt ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ruby", {
                    className: "flex flex-col-reverse items-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-3xl font-medium tracking-wide",
                            children: item.text
                        }),
                        shouldShowFurigana && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rt", {
                            className: "text-xs text-gray-300 font-normal mb-0.5",
                            children: item.rt
                        })
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "text-3xl font-medium tracking-wide",
                    children: item.text
                })
            }, idx);
        })
    });
}




function $cf14a959478c556c$export$54b6586678658f62() {
    const { currentQuestion: currentQuestion } = (0, $c4204af8016d9a61$export$279b3db6af62ec8)();
    const { showFurigana: showFurigana, showDictionary: showDictionary, showEnglish: showEnglish } = (0, $967b4ec559f6d613$export$9115b42802a3e44f)();
    if (!currentQuestion) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "w-full max-w-sm flex flex-col items-center gap-1",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "w-full flex justify-between items-end px-4 pr-12",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col items-center group",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "mb-0.5 h-12 flex items-end",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a738c439e9f5d693$export$184a93565bb489ae), {
                                data: currentQuestion.nounRuby,
                                showFurigana: showFurigana
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col items-center w-full",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "h-[2px] w-10 bg-red-600 mb-0.5"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-[10px] text-gray-300 tracking-wider font-semibold",
                                    children: "\u540D\u8A5E"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: `flex flex-col items-center text-lg tracking-wide ${currentQuestion.type === 'Transitive' ? 'text-yellow-400' : 'text-purple-400'}`,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "font-bold",
                            children: currentQuestion.type === 'Transitive' ? "\u4ED6\u52D5\u8A5E" : "\u81EA\u52D5\u8A5E"
                        }),
                        showEnglish && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-[10px] text-gray-300 font-normal",
                            children: currentQuestion.type
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "flex flex-col items-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            className: "mb-0.5 h-12 flex items-end",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a738c439e9f5d693$export$184a93565bb489ae), {
                                data: showDictionary ? currentQuestion.dictionaryRuby : currentQuestion.verbRuby,
                                showFurigana: showFurigana
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "flex flex-col items-center w-full",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "h-[2px] w-10 bg-red-600 mb-0.5"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: "text-[10px] text-gray-300 tracking-wider font-semibold",
                                    children: "\u52D5\u8A5E"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}


// QuizInput - input field with validation

parcelRequire("acw62");


// useInputHandler - handles romaji to hiragana conversion with cursor preservation

var $acw62 = parcelRequire("acw62");

// Pure functions for text validation
// Check if a string contains Katakana characters
const $2deb8f60bc8d7b04$export$3b4fda923fb2b16e = (str)=>/[\u30a1-\u30f6]/.test(str);
const $2deb8f60bc8d7b04$export$aaad9a892c33d846 = (str)=>/^[\u3041-\u3096]+$/.test(str);


function $9baf9d6b861be79e$export$dcc4911ee0e14964(inputRef, setInput, setInvalidInput) {
    const handleInputChange = (0, $acw62.useCallback)((e)=>{
        const input = e.target;
        const rawValue = input.value;
        const selectionStart = input.selectionStart;
        const selectionEnd = input.selectionEnd;
        // Get the portion before cursor to calculate length difference
        const beforeCursor = rawValue.slice(0, selectionStart);
        const convertedBeforeCursor = (0, $244778c8bb25e663$export$df0ac7caf6813e1a)(beforeCursor);
        // Convert full value to Hiragana
        const hiraganaValue = (0, $244778c8bb25e663$export$df0ac7caf6813e1a)(rawValue);
        // Calculate new cursor position based on converted text before cursor
        const newCursorPos = convertedBeforeCursor.length;
        setInput(hiraganaValue);
        // Restore cursor position after React re-renders
        requestAnimationFrame(()=>{
            if (inputRef.current) {
                inputRef.current.selectionStart = newCursorPos;
                inputRef.current.selectionEnd = newCursorPos + (selectionEnd - selectionStart);
            }
        });
    }, [
        inputRef,
        setInput
    ]);
    const validateInput = (0, $acw62.useCallback)((input)=>{
        const trimmed = input.trim();
        if (trimmed.length === 0 || !(0, $2deb8f60bc8d7b04$export$aaad9a892c33d846)(trimmed)) {
            setInvalidInput(true);
            return false;
        }
        return true;
    }, [
        setInvalidInput
    ]);
    return {
        handleInputChange: handleInputChange,
        validateInput: validateInput
    };
}


function $7568f1a81b4e3990$export$18b61be003f8ca6c() {
    const { userInput: userInput, setInput: setInput, setInvalidInput: setInvalidInput, setFeedback: setFeedback, isInvalidInput: isInvalidInput, feedback: feedback, inputRef: inputRef, handleNext: handleNext, checkAnswer: checkAnswer } = (0, $c4204af8016d9a61$export$279b3db6af62ec8)();
    const { handleInputChange: handleInputChange, validateInput: validateInput } = (0, $9baf9d6b861be79e$export$dcc4911ee0e14964)(inputRef, setInput, setInvalidInput);
    const handleFormSubmit = (e)=>{
        e.preventDefault();
        // If already showing feedback, Enter should go to next
        if (feedback === 'incorrect' || feedback === 'correct') {
            handleNext(feedback === 'correct');
            return;
        }
        // Validate input is hiragana only and not empty
        if (!validateInput(userInput)) return;
        // Check if answer is correct
        if (checkAnswer(userInput)) handleNext(true);
        else setFeedback('incorrect');
    };
    const handleKeyDown = (e)=>{
        // Allow Enter to proceed to next even when input is disabled
        if (e.key === 'Enter' && (feedback === 'incorrect' || feedback === 'correct')) {
            e.preventDefault();
            handleNext(feedback === 'correct');
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
        onSubmit: handleFormSubmit,
        className: "relative w-full",
        onKeyDown: handleKeyDown,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                ref: inputRef,
                type: "text",
                value: userInput,
                onChange: handleInputChange,
                placeholder: "\u6587\u3092\u5165\u529B...",
                className: `w-full bg-white text-black text-center text-lg py-2.5 px-4 rounded-full focus:outline-none focus:ring-2 transition-all shadow-lg
          ${feedback === 'correct' ? 'ring-green-500 bg-green-50' : ''}
          ${feedback === 'incorrect' ? 'ring-red-500 bg-red-50' : ''}
          ${isInvalidInput ? 'ring-red-500 ring-2 bg-red-50 animate-shake' : ''}
          ${!feedback && !isInvalidInput ? 'ring-transparent focus:ring-blue-400' : ''}
        `,
                autoFocus: true,
                disabled: feedback === 'correct' || feedback === 'incorrect'
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "absolute right-3 top-1/2 -translate-y-1/2",
                children: [
                    feedback === 'correct' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3f86240925e7a9e$export$2e2bcd8739ae039), {
                        size: 16,
                        className: "text-green-600 animate-bounce"
                    }),
                    feedback === 'incorrect' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $839eea37a960d2b1$export$2e2bcd8739ae039), {
                        size: 16,
                        className: "text-red-600 animate-pulse"
                    })
                ]
            })
        ]
    });
}


// QuizFeedback - displays correct/incorrect feedback with answers

parcelRequire("acw62");
// AnswerRubyText - displays sentence with furigana above kanji and katakana


var $acw62 = parcelRequire("acw62");


function $df5e76c625f1e3b9$export$dd633d68feb88420({ data: data, colorClass: colorClass, textSize: textSize = "text-xl", showFurigana: showFurigana = true }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `flex items-end justify-center ${colorClass}`,
        children: data.map((item, idx)=>{
            // Determine furigana: use rt if available, or generate from Katakana
            const furigana = item.rt || ((0, $2deb8f60bc8d7b04$export$3b4fda923fb2b16e)(item.text) ? (0, $244778c8bb25e663$export$28ab6cab47a15260)(item.text) : "");
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                children: furigana && showFurigana ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ruby", {
                    className: "flex flex-col-reverse items-center",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: `${textSize} font-bold`,
                            children: item.text
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rt", {
                            className: "text-[10px] text-gray-400 font-normal",
                            children: furigana
                        })
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: `${textSize} font-bold`,
                    children: item.text
                })
            }, idx);
        })
    });
}




// Build ruby data for a sentence
// Returns array of { text, rt } objects where rt is only set for kanji/katakana
const $402b516d63562a34$export$775fde2da2236266 = (question, isPolite)=>{
    const result = [];
    // Add noun parts (already has proper rt for kanji/katakana)
    result.push(...question.nounRuby);
    // Determine particle from sentence (character after noun)
    const sentence = isPolite ? question.politeSentence : question.plainSentence;
    const nounText = question.nounRuby.map((r)=>r.text).join('');
    const nounIndex = sentence.indexOf(nounText);
    const particle = sentence.charAt(nounIndex + nounText.length);
    result.push({
        text: particle,
        rt: ""
    });
    if (isPolite) {
        // For polite form, get verb part from sentence
        const verbStart = nounIndex + nounText.length + 1; // +1 for particle
        const verbPart = sentence.substring(verbStart);
        // The verbRuby has the kanji stem, rest is hiragana suffix
        const verbKanji = question.verbRuby.map((r)=>r.text).join('');
        if (verbPart.startsWith(verbKanji)) {
            // Add verb kanji with furigana
            result.push(...question.verbRuby);
            // Add remaining hiragana suffix (きます, けます, etc.)
            const suffix = verbPart.substring(verbKanji.length);
            if (suffix) result.push({
                text: suffix,
                rt: ""
            });
        } else // Fallback: add the whole verb part without ruby
        result.push({
            text: verbPart,
            rt: ""
        });
    } else // For plain form, use dictionaryRuby directly
    result.push(...question.dictionaryRuby);
    return result;
};




function $8516ede8494b3acf$export$cad1a0fd0a84a510() {
    const { feedback: feedback, currentQuestion: currentQuestion } = (0, $c4204af8016d9a61$export$279b3db6af62ec8)();
    const { selectedForms: selectedForms, showFurigana: showFurigana, showEnglish: showEnglish, showPairs: showPairs, showSimilarPatterns: showSimilarPatterns, selectedLevels: selectedLevels } = (0, $967b4ec559f6d613$export$9115b42802a3e44f)();
    if (!feedback || !currentQuestion) return null;
    if (feedback === 'correct') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "min-h-[90px] flex items-start justify-center pt-3",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "text-center text-green-400 font-bold text-sm animate-in zoom-in space-y-1",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: "Great Job!"
            })
        })
    });
    if (feedback === 'incorrect') {
        const pairVerb = showPairs ? (0, $d4417072adffad0c$export$1a21776e138ef20b)(currentQuestion) : null;
        const morphEnding = currentQuestion.morphologicalEnding;
        const endingLabel = morphEnding ? morphEnding.replace('-', " \u2192 ") : null;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "min-h-[90px] flex items-start justify-center pt-3",
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "text-center animate-in fade-in slide-in-from-bottom-2 space-y-1.5",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-green-700 text-xs font-bold mb-2",
                        children: "\u6B63\u3057\u3044\u56DE\u7B54"
                    }),
                    selectedForms.includes('Polite') && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mb-2",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df5e76c625f1e3b9$export$dd633d68feb88420), {
                            data: (0, $402b516d63562a34$export$775fde2da2236266)(currentQuestion, true),
                            colorClass: "text-[#5F9EA0]",
                            showFurigana: showFurigana
                        })
                    }),
                    selectedForms.includes('Plain') && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mb-2",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df5e76c625f1e3b9$export$dd633d68feb88420), {
                            data: (0, $402b516d63562a34$export$775fde2da2236266)(currentQuestion, false),
                            colorClass: "text-[#D1AD8C]",
                            showFurigana: showFurigana
                        })
                    }),
                    showEnglish && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "text-sm text-gray-300 italic",
                        children: currentQuestion.english
                    }),
                    endingLabel && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "mt-1",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                            className: "text-xs text-gray-500 bg-[#2a2a2a] px-2 py-0.5 rounded-full",
                            children: endingLabel
                        })
                    }),
                    showPairs && pairVerb && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8516ede8494b3acf$var$PairHints, {
                        currentQuestion: currentQuestion,
                        pairVerb: pairVerb,
                        showFurigana: showFurigana,
                        showEnglish: showEnglish
                    }),
                    showSimilarPatterns && morphEnding && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8516ede8494b3acf$var$SimilarPatterns, {
                        currentQuestion: currentQuestion,
                        selectedLevels: selectedLevels,
                        showFurigana: showFurigana
                    })
                ]
            })
        });
    }
    return null;
}
// Sub-component for pair hints
function $8516ede8494b3acf$var$PairHints({ currentQuestion: currentQuestion, pairVerb: pairVerb, showFurigana: showFurigana, showEnglish: showEnglish }) {
    // Determine which is intransitive (purple) and transitive (yellow)
    const isCurrentIntransitive = currentQuestion.type === 'Intransitive';
    const intransitiveVerb = isCurrentIntransitive ? currentQuestion : pairVerb;
    const transitiveVerb = isCurrentIntransitive ? pairVerb : currentQuestion;
    // Get suffix types for both verbs
    const intransitiveSuffix = (0, $1e60d8c6534cd098$export$c6323d5e307fb20c)(intransitiveVerb.dictionaryRuby);
    const transitiveSuffix = (0, $1e60d8c6534cd098$export$c6323d5e307fb20c)(transitiveVerb.dictionaryRuby);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col items-center gap-2 mt-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex items-center justify-center gap-3",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df5e76c625f1e3b9$export$dd633d68feb88420), {
                        data: intransitiveVerb.dictionaryRuby,
                        colorClass: "text-purple-400",
                        textSize: "text-lg",
                        showFurigana: showFurigana
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "text-gray-500",
                        children: "/"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df5e76c625f1e3b9$export$dd633d68feb88420), {
                        data: transitiveVerb.dictionaryRuby,
                        colorClass: "text-yellow-400",
                        textSize: "text-lg",
                        showFurigana: showFurigana
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "flex flex-col items-center gap-1 text-base mt-1",
                children: [
                    intransitiveSuffix === 'suffix-aru' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-purple-400",
                                children: (0, $1e60d8c6534cd098$export$af1e5d9f49fbe577).aru.explanationJa
                            }),
                            showEnglish && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-sm text-gray-300 italic",
                                children: (0, $1e60d8c6534cd098$export$af1e5d9f49fbe577).aru.explanationEn
                            })
                        ]
                    }),
                    transitiveSuffix === 'suffix-su' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-yellow-400",
                                children: (0, $1e60d8c6534cd098$export$af1e5d9f49fbe577).su.explanationJa
                            }),
                            showEnglish && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-sm text-gray-300 italic",
                                children: (0, $1e60d8c6534cd098$export$af1e5d9f49fbe577).su.explanationEn
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
// Sub-component for similar pattern verb pairs
function $8516ede8494b3acf$var$SimilarPatterns({ currentQuestion: currentQuestion, selectedLevels: selectedLevels, showFurigana: showFurigana }) {
    const ending = currentQuestion.morphologicalEnding;
    const currentPairBase = currentQuestion.id % 2 === 1 ? currentQuestion.id : currentQuestion.id - 1;
    // Find all verb pairs with the same morphologicalEnding, filtered by active levels
    const pairs = [];
    const seen = new Set();
    for (const verb of (0, $1e60d8c6534cd098$export$b28a0e5be47ced59)){
        if (verb.morphologicalEnding !== ending) continue;
        if (!selectedLevels.includes(verb.level)) continue;
        const pairBase = verb.id % 2 === 1 ? verb.id : verb.id - 1;
        if (pairBase === currentPairBase) continue;
        if (seen.has(pairBase)) continue;
        seen.add(pairBase);
        const intransitive = (0, $1e60d8c6534cd098$export$b28a0e5be47ced59).find((v)=>v.id === pairBase);
        const transitive = (0, $1e60d8c6534cd098$export$b28a0e5be47ced59).find((v)=>v.id === pairBase + 1);
        if (intransitive && transitive) pairs.push({
            intransitive: intransitive,
            transitive: transitive
        });
    }
    if (pairs.length === 0) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex flex-col items-center gap-1.5 mt-3 pt-2 border-t border-gray-700",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "text-[10px] text-gray-500 uppercase tracking-wider font-bold",
                children: "\u540C\u3058\u30D1\u30BF\u30FC\u30F3"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex flex-col items-center gap-1",
                children: pairs.map(({ intransitive: intransitive, transitive: transitive })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "flex items-center justify-center gap-2",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df5e76c625f1e3b9$export$dd633d68feb88420), {
                                data: intransitive.dictionaryRuby,
                                colorClass: "text-purple-400",
                                textSize: "text-sm",
                                showFurigana: showFurigana
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "text-gray-600 text-xs",
                                children: "/"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $df5e76c625f1e3b9$export$dd633d68feb88420), {
                                data: transitive.dictionaryRuby,
                                colorClass: "text-yellow-400",
                                textSize: "text-sm",
                                showFurigana: showFurigana
                            })
                        ]
                    }, intransitive.id))
            })
        ]
    });
}


// QuizControls - Retry, Next, Give Up buttons

parcelRequire("acw62");

function $d8c075ddaa9c16d0$export$6763d839167d0362() {
    const { feedback: feedback, showAnswer: showAnswer, handleRetry: handleRetry, handleNext: handleNext, handleGiveUp: handleGiveUp } = (0, $c4204af8016d9a61$export$279b3db6af62ec8)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex gap-3 justify-center mt-12 mb-4",
                children: (feedback === 'incorrect' || showAnswer) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: handleRetry,
                            className: "bg-gray-600 hover:bg-gray-500 text-white font-bold py-2.5 px-8 rounded-full flex items-center gap-1.5 transition-colors text-sm",
                            children: "\u3082\u3046\u4E00\u5EA6"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            onClick: ()=>handleNext(feedback === 'correct'),
                            className: `${feedback === 'correct' ? 'bg-green-700 hover:bg-green-600' : 'bg-red-700 hover:bg-red-600'} text-white font-bold py-2.5 px-8 rounded-full transition-colors text-sm`,
                            children: "\u6B21\u3078"
                        })
                    ]
                })
            }),
            feedback === null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    onClick: handleGiveUp,
                    className: "text-gray-300 hover:text-gray-100 text-sm font-medium py-1 px-4 transition-colors",
                    children: "\u308F\u304B\u3089\u306A\u3044"
                })
            })
        ]
    });
}


// QuizComplete - Celebration screen when quiz is completed

parcelRequire("acw62");

function $e712075b12d868e5$export$50ef97fc69b8e52e() {
    const { totalQuestions: totalQuestions, handleRestart: handleRestart } = (0, $c4204af8016d9a61$export$279b3db6af62ec8)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex-1 flex flex-col items-center justify-start px-4 pt-16 pb-1",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "text-center text-green-400 text-xl font-bold space-y-4",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: "\uD83C\uDF89 \u304A\u3081\u3067\u3068\u3046\u3054\u3056\u3044\u307E\u3059\uFF01"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    className: "text-base text-gray-300 font-normal",
                    children: [
                        "\u5168 ",
                        totalQuestions,
                        " \u554F\u6B63\u89E3\u3067\u3059\uFF01"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    onClick: handleRestart,
                    className: "bg-green-800 hover:bg-green-700 text-white font-bold py-2.5 px-8 rounded-full transition-colors text-sm mt-4",
                    children: "\u30EA\u30B9\u30BF\u30FC\u30C8"
                })
            ]
        })
    });
}


// QuizHeader - Top right controls (reset button, icon)

parcelRequire("acw62");


function $ef60cbcd740f3ca2$export$f74c0dab7cd54400() {
    const { currentQuestion: currentQuestion, handleRestart: handleRestart } = (0, $c4204af8016d9a61$export$279b3db6af62ec8)();
    if (!currentQuestion) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "absolute top-4 right-3 z-40 flex items-center gap-2",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                onClick: handleRestart,
                className: "px-3 py-2 bg-[#2a2a2a] rounded-lg shadow-inner border border-[#333] flex items-center justify-center hover:bg-[#333] transition-colors",
                title: "\u30EA\u30BB\u30C3\u30C8 (Reset Quiz)",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8a800148d042d893$export$2e2bcd8739ae039), {
                    size: 18,
                    className: "text-gray-300 opacity-90",
                    strokeWidth: 1.5
                })
            }),
            currentQuestion.icon && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "px-3 py-2 bg-[#2a2a2a] rounded-lg shadow-inner border border-[#333] flex items-center justify-center",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(currentQuestion.icon, {
                    size: 18,
                    className: `${currentQuestion.color} opacity-90`,
                    strokeWidth: 1.5
                })
            })
        ]
    });
}


// QuizCounter - Question counter display

parcelRequire("acw62");

function $23bd27c4e1dea350$export$1c9695bb02587ffc() {
    const { shuffledData: shuffledData, questionNumber: questionNumber, totalQuestions: totalQuestions } = (0, $c4204af8016d9a61$export$279b3db6af62ec8)();
    if (shuffledData.length === 0) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "text-center text-gray-400 text-base pb-1",
        children: [
            "\u7B2C",
            questionNumber,
            "\u554F / \u5168",
            totalQuestions,
            "\u554F"
        ]
    });
}




/**
 * @fileoverview Exports reusable UI primitives and utility components.
 * These components provide consistent styling and behavior across the app,
 * including Japanese text rendering with furigana support.
 * @module components/ui
 */ /** @description Renders Japanese text with furigana (reading aid) above kanji characters */ 

// ProgressBar - displays quiz progress

parcelRequire("acw62");

function $efbdbf402bba1453$export$c17561cb55d4db30() {
    const { progress: progress } = (0, $c4204af8016d9a61$export$279b3db6af62ec8)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "w-full absolute top-0 h-1 bg-gray-800",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "h-full bg-red-500 transition-all duration-300",
            style: {
                width: `${progress}%`
            }
        })
    });
}






/**
 * @fileoverview Exports custom React hooks for shared behavior.
 * These hooks encapsulate reusable logic for DOM interactions and
 * event handling, keeping components focused on rendering.
 * @module hooks
 */ /** @description Detects clicks outside a ref element to close dropdowns/modals */ 
// useKeyboardShortcuts - handles global keyboard events for quiz navigation

var $acw62 = parcelRequire("acw62");
function $e201052dbd6edd4e$export$195013e3b6534b06({ feedback: feedback, onNext: onNext, onRetry: onRetry }) {
    (0, $acw62.useEffect)(()=>{
        const handleKeyDown = (e)=>{
            // Enter to proceed to next when feedback is showing
            if (e.key === 'Enter' && (feedback === 'incorrect' || feedback === 'correct')) {
                e.preventDefault();
                onNext(feedback === 'correct');
            }
            // Backspace to retry when answer is revealed
            if (e.key === 'Backspace' && (feedback === 'incorrect' || feedback === 'correct')) {
                e.preventDefault();
                onRetry();
            }
        };
        if (feedback) window.addEventListener('keydown', handleKeyDown);
        return ()=>{
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        feedback,
        onNext,
        onRetry
    ]);
}





// Empty state component
function $1b8e0994176c9ade$var$EmptyState() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex-1 flex flex-col items-center justify-start px-4 pt-16 pb-1",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "text-center text-gray-400 text-sm",
            children: "\u958B\u59CB\u3059\u308B\u306B\u306F\u3001\u30EC\u30D9\u30EB\u3068\u30BF\u30A4\u30D7\u30921\u3064\u4EE5\u4E0A\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
        })
    });
}
// Loading state component
function $1b8e0994176c9ade$var$LoadingState() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "flex-1 flex flex-col items-center justify-start px-4 pt-16 pb-1",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: "flex items-center justify-center text-white text-sm",
            children: "\u30ED\u30FC\u30C9\u4E2D..."
        })
    });
}
// Main quiz content
function $1b8e0994176c9ade$var$QuizMain() {
    const { currentQuestion: currentQuestion, feedback: feedback, handleNext: handleNext, handleRetry: handleRetry } = (0, $c4204af8016d9a61$export$279b3db6af62ec8)();
    // Enable keyboard shortcuts
    (0, $e201052dbd6edd4e$export$195013e3b6534b06)({
        feedback: feedback,
        onNext: handleNext,
        onRetry: handleRetry
    });
    if (!currentQuestion) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1b8e0994176c9ade$var$LoadingState, {});
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "flex-1 flex flex-col items-center justify-start px-4 pt-10 pb-1",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cf14a959478c556c$export$54b6586678658f62), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "w-full max-w-sm space-y-2 mt-2",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7568f1a81b4e3990$export$18b61be003f8ca6c), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8516ede8494b3acf$export$cad1a0fd0a84a510), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d8c075ddaa9c16d0$export$6763d839167d0362), {})
                ]
            })
        ]
    });
}
// Quiz layout with conditional rendering
function $1b8e0994176c9ade$var$QuizLayout() {
    const { isComplete: isComplete, isEmpty: isEmpty, shuffledData: shuffledData, currentQuestion: currentQuestion } = (0, $c4204af8016d9a61$export$279b3db6af62ec8)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "min-h-screen bg-[#1a1a1a] text-white flex flex-col font-sans relative",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "h-[60vh] flex flex-col relative",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $efbdbf402bba1453$export$c17561cb55d4db30), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1a00bcc4c62aa58d$export$fef7159a5e479b3c), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ef60cbcd740f3ca2$export$f74c0dab7cd54400), {}),
                    isEmpty ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1b8e0994176c9ade$var$EmptyState, {}) : isComplete ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e712075b12d868e5$export$50ef97fc69b8e52e), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1b8e0994176c9ade$var$QuizMain, {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $23bd27c4e1dea350$export$1c9695bb02587ffc), {})
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "h-[40vh] bg-[#1a1a1a]"
            })
        ]
    });
}
function $1b8e0994176c9ade$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $967b4ec559f6d613$export$e134aa690da9cc14), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4204af8016d9a61$export$660171dc0394dc07), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1b8e0994176c9ade$var$QuizLayout, {})
        })
    });
}


const $34a83e38fb8b3bfc$var$container = document.getElementById('root');
const $34a83e38fb8b3bfc$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)($34a83e38fb8b3bfc$var$container);
$34a83e38fb8b3bfc$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b8e0994176c9ade$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=root.404fb9d3.js.map
